var _style, _rect, _path, _path2, _path3, _path4, _g, _defs, _g2, _defs2, _rect2, _defs3, _rect3, _defs4, _rect4, _defs5, _rect5, _defs6, _rect6, _defs7, _rect7, _defs8, _rect8, _g3, _g4, _g5, _defs9, _g6, _path5, _g7, _g8, _defs0, _path6, _g9, _defs1, _g0, _g1, _g10, _g11, _path7, _path8, _g12, _defs10, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path9, _defs11, _g29, _g30, _g31, _g32, _g33, _g34, _path0, _path1, _path10, _g35, _g36, _g37, _defs12, _g38, _defs13, _g39, _defs14, _g40, _defs15, _g41, _g42, _g43, _g44, _g45, _g46, _defs16, _g47, _defs17, _g48, _defs18, _g49, _defs19, _path11, _defs20, _g50, _defs21, _path12, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g66, _defs22, _g67, _defs23, _g68, _g69, _g70, _line, _line2, _line3, _line4, _line5, _line6, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _defs24, _g86, _defs25, _g87, _defs26, _g88, _defs27, _g89, _defs28, _g90, _g91, _g92, _g93, _g94, _rect9, _rect0, _rect1, _g95;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarteIngenieur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 3154",
    style: {
      enableBackground: "new 0 0 750 3154"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#26A863;}\n\t.st1{fill:none;stroke:#6BC5F7;stroke-width:20;stroke-miterlimit:10;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#DD6F31;}\n\t.st3{clip-path:url(#SVGID_2_);}\n\t.st4{fill:#8ED679;}\n\t.st5{fill:#55961D;}\n\t.st6{clip-path:url(#SVGID_4_);fill:#A3EA8C;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#5DC12F;}\n\t.st8{clip-path:url(#SVGID_8_);fill:#A3EA8C;}\n\t.st9{clip-path:url(#SVGID_10_);fill:#5DC12F;}\n\t.st10{clip-path:url(#SVGID_12_);fill:#A3EA8C;}\n\t.st11{clip-path:url(#SVGID_14_);fill:#5DC12F;}\n\t.st12{clip-path:url(#SVGID_16_);fill:#A3EA8C;}\n\t.st13{fill:#A3EA8C;}\n\t.st14{fill:#5DC12F;}\n\t.st15{fill:#4AD381;}\n\t.st16{fill:#249451;}\n\t.st17{fill:#7FA195;}\n\t.st18{fill:#7F5A41;}\n\t.st19{fill:#213D33;}\n\t.st20{clip-path:url(#SVGID_18_);}\n\t.st21{clip-path:url(#SVGID_20_);}\n\t.st22{fill:#062265;}\n\t.st23{fill:#FFFFFF;}\n\t.st24{clip-path:url(#SVGID_22_);}\n\t.st25{fill:#B82B35;}\n\t.st26{fill:#A43138;}\n\t.st27{fill:#3B3C6B;}\n\t.st28{fill:none;stroke:#213D33;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st29{fill:#F6C459;}\n\t.st30{clip-path:url(#SVGID_24_);}\n\t.st31{fill:#E7B7B7;}\n\t.st32{clip-path:url(#SVGID_26_);}\n\t.st33{fill:none;stroke:#213D33;stroke-width:2;stroke-miterlimit:10;}\n\t.st34{fill:none;stroke:#213D33;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:12.8884,8.5922;}\n\t.st35{fill:#8B5939;}\n\t.st36{fill:#A36B3E;}\n\t.st37{fill:#604131;}\n\t.st38{opacity:0.5;fill:#604131;enable-background:new    ;}\n\t.st39{opacity:0.5;fill:#F6C459;enable-background:new    ;}\n\t.st40{clip-path:url(#SVGID_28_);}\n\t.st41{clip-path:url(#SVGID_30_);}\n\t.st42{clip-path:url(#SVGID_32_);}\n\t.st43{clip-path:url(#SVGID_34_);}\n\t.st44{clip-path:url(#SVGID_36_);}\n\t.st45{clip-path:url(#SVGID_38_);}\n\t.st46{clip-path:url(#SVGID_40_);}\n\t.st47{clip-path:url(#SVGID_42_);fill:#FFFFFF;}\n\t.st48{clip-path:url(#SVGID_44_);}\n\t.st49{clip-path:url(#SVGID_46_);fill:#FFFFFF;}\n\t.st50{display:none;fill:#F6C459;}\n\t.st51{fill:none;stroke:#213D33;stroke-width:0.75;}\n\t.st52{clip-path:url(#SVGID_48_);}\n\t.st53{clip-path:url(#SVGID_50_);}\n\t.st54{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st55{clip-path:url(#SVGID_52_);}\n\t.st56{clip-path:url(#SVGID_54_);}\n\t.st57{clip-path:url(#SVGID_56_);}\n\t.st58{clip-path:url(#SVGID_58_);}\n\t.st59{fill:#FBC13D;}\n\t.st60{fill:#190B02;}\n\t.st61{clip-path:url(#SVGID_60_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 750,
    height: 3154
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,67.8h305c16.6,0,30-13.4,30-30V-0.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-0.5,2245.8H450c16.6,0,30,13.4,30,30v265.5c0,16.6,13.4,30,30,30h240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M750,2933.3H138.8c-16.6,0-30,13.4-30,30v190.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,923.6h159.8c16.6,0,30,13.4,30,30v594.1c0,16.6,13.4,30,30,30H750"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,904.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C43.3,904.8,43.7,904.5,44.1,904.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.9,904.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C69.1,904.8,69.4,904.5,69.9,904.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.3,
    y: 1373.1,
    className: "st4",
    width: 11.2,
    height: 235.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7,
    y: 1373.2,
    className: "st4",
    width: 11.2,
    height: 235.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 1373.1,
    className: "st5",
    width: 4.9,
    height: 235.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 1373.1,
    className: "st4",
    width: 11.2,
    height: 235.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 1373.1,
    className: "st5",
    width: 4.9,
    height: 235.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1339.1,
    className: "st6",
    width: 195.9,
    height: 11.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1334.2,
    className: "st7",
    width: 195.9,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1354.9,
    className: "st8",
    width: 195.9,
    height: 11.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1350,
    className: "st9",
    width: 195.9,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1323.3,
    className: "st10",
    width: 195.9,
    height: 11.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1318.4,
    className: "st11",
    width: 195.9,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 0.3,
    y: 1281.6,
    width: 42,
    height: 335.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -157.5,
    y: 1307.2,
    className: "st12",
    width: 195.9,
    height: 11.2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2448.9,
    className: "st13",
    width: 209.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2512.1,
    className: "st13",
    width: 209.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2507.2,
    className: "st14",
    width: 209.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2527.9,
    className: "st13",
    width: 209.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2523,
    className: "st14",
    width: 209.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2496.3,
    className: "st13",
    width: 209.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2491.4,
    className: "st14",
    width: 209.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2480.2,
    className: "st13",
    width: 209.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2475.3,
    className: "st14",
    width: 209.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2464.5,
    className: "st13",
    width: 209.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 2459.6,
    className: "st14",
    width: 209.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144.8,
    y: 2326.5,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 2326.5,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 2326.6,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.6,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.1,
    y: 2326.6,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.9,
    y: 2326.5,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.4,
    y: 2326.5,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 2326.5,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 2326.5,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.7,
    y: 2326.5,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.3,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.2,
    y: 2326.6,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.5,
    y: 2326.6,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.3,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.8,
    y: 2326.6,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.4,
    y: 2326.5,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.2,
    y: 2326.5,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.7,
    y: 2326.5,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 2326.5,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.3,
    y: 2326.5,
    className: "st16",
    width: 5.1,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.6,
    y: 2326.6,
    className: "st15",
    width: 11.5,
    height: 114.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.5,
    y: 2326.6,
    className: "st16",
    width: 5.1,
    height: 114.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 185.2,
    cy: 717.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 187.5,
    cy: 725.3,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 193.2,
    cy: 711,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 198.5,
    cy: 713.9,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 197,
    cy: 728.7,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 195.1,
    cy: 720.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 203,
    cy: 720.8,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 176.2,
    cy: 720.9,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 177.5,
    cy: 727.4,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 202.5,
    cy: 728.2,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M177.2,721.7c4.6,3.2,11.4,6.3,12.3,12.4c0.2,6.9,0.8,14.7-2.4,21c0,0.1,0,0.2,0.1,0.2h9.2 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.8-2.7-13.5l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.2-4.2c1.4-1,2.3-1.8,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,5-6.9,7c1-2.4,1.7-5.9,1.8-8.2c-0.9,2.8-1,6.5-2.9,8.8c-1.2,0.8-2.6,1.3-3.4,2.7 c-3.3-4.3-0.5-10.2-2-14.9c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.8-1.1,7.1c-3.2-1.6-5.5-3.2-6.3-6.8l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.6,2.8,8.1c-1.7-0.7-3.8-2.1-5.2-2.8C178.6,722.5,173.7,719.1,177.2,721.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 205.1,
    cy: 713.9,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 208.2,
    cy: 724.1,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 215.7,
    cy: 705.1,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 222.7,
    cy: 708.9,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 220.7,
    cy: 728.5,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 218.2,
    cy: 717.2,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 228.7,
    cy: 718,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 193.2,
    cy: 718.2,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 194.9,
    cy: 726.8,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 228,
    cy: 727.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M194.6,719.2c6.1,4.2,15.1,8.3,16.3,16.4c0.3,9.2,1.1,19.5-3.1,27.8c-0.1,0.1,0,0.2,0.1,0.2H220 c0.1,0,0.2-0.1,0.2-0.2c-2.8-5.7-2.6-11.7-3.5-17.9l0,0c-1.1-5.5-1.4-9.6,3.2-13.6c1.9-1.8,3.7-3.7,5.5-5.6c1.9-1.3,3-2.3,3.9-4.8 c0.3-0.9,0.4-1.7,0.3-1.4c-1,4.4-5.9,6.6-9.2,9.3c1.4-3.2,2.2-7.8,2.4-10.9c-1.1,3.8-1.3,8.6-3.9,11.7c-1.6,1-3.5,1.8-4.5,3.5 c-4.4-5.8-0.7-13.5-2.7-19.7c-0.7-2.4,0.4,2.8,0,4c0,3.2-0.9,6.3-1.4,9.4c-4.2-2.1-7.3-4.2-8.3-9l0,0c-1-1.6-1.1-3.7-1.9-5.2 c0.8,3.7,1.7,7.4,3.7,10.7c-2.2-0.9-5-2.8-6.9-3.7C196.4,720.2,189.9,715.8,194.6,719.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 0,
    y: 318.4,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 8.2,
    cy: 349.2,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 5.9,
    cy: 356.8,
    r: 8.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -1.228496e-03 1.228496e-03 1 -0.4209 6.270756e-04)",
    className: "st19",
    cx: 0.3,
    cy: 342.6,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -5,
    cy: 345.4,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -3.5,
    cy: 360.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415435e-03 -1 1 2.415435e-03 -353.2949 349.0508)",
    className: "st19",
    cx: -1.7,
    cy: 351.6,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.802501e-03 -1 1 9.802501e-03 -361.6899 339.347)",
    className: "st19",
    cx: -9.5,
    cy: 352.3,
    rx: 7.8,
    ry: 7.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.089770e-03 -1 1 9.089770e-03 -335.4409 366.2961)",
    className: "st19",
    cx: 17.1,
    cy: 352.4,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020247e-02 1.020247e-02 0.9999 -3.6598 0.1809)",
    className: "st19",
    cx: 15.9,
    cy: 358.8,
    rx: 3.3,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -9,
    cy: 359.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M16.1,353.1c-4.6,3.2-11.3,6.2-12.2,12.3c-0.2,6.9-0.8,14.6,2.4,20.8c0,0.1,0,0.2-0.1,0.2H-3 c-0.1,0-0.2-0.1-0.1-0.2c2.1-4.3,1.9-8.7,2.6-13.4l0,0c0.8-4.1,1.1-7.2-2.4-10.2c-1.4-1.4-2.8-2.8-4.1-4.2 c-1.4-1-2.3-1.7-2.9-3.6c-0.3-0.7-0.3-1.3-0.2-1.1c0.8,3.3,4.4,4.9,6.9,7c-1-2.4-1.7-5.8-1.8-8.2c0.8,2.8,1,6.4,2.9,8.8 c1.2,0.8,2.6,1.3,3.3,2.6c3.3-4.3,0.5-10.1,2-14.8c0.5-1.8-0.3,2.1,0,3c0,2.4,0.7,4.7,1.1,7.1c3.1-1.6,5.5-3.2,6.2-6.7l0,0 c0.7-1.2,0.9-2.8,1.4-3.9c-0.6,2.8-1.3,5.5-2.8,8c1.7-0.7,3.8-2.1,5.2-2.7C14.7,353.9,19.6,350.6,16.1,353.1z"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M749.5,430.7H610c-9.6,0-17.3,7.8-17.3,17.4l0.1,25.5c0,9.6-7.7,17.4-17.3,17.4h-24.6 c-13,0-23.5,10.5-23.5,23.5V539c0,13,10.5,23.5,23.5,23.5h198.6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 432.1,
    cy: 294.6,
    r: 12.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 435.3,
    cy: 305.4,
    r: 12.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 443.3,
    cy: 285.1,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 450.8,
    cy: 289.2,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 448.7,
    cy: 310.1,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 446.1,
    cy: 298,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 457.2,
    cy: 299,
    r: 11.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 419.4,
    cy: 299.1,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 421.2,
    cy: 308.3,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 456.5,
    cy: 309.4,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M420.8,300.2c6.5,4.5,16.1,8.9,17.4,17.5c0.3,9.8,1.2,20.8-3.3,29.7c-0.1,0.1,0,0.3,0.2,0.3H448 c0.1,0,0.2-0.1,0.2-0.3c-2.9-6.1-2.7-12.4-3.8-19.1l0,0c-1.2-5.8-1.5-10.2,3.4-14.5c2-2,4-4,5.9-6c2-1.4,3.2-2.5,4.2-5.1 c0.4-1,0.4-1.8,0.3-1.5c-1.1,4.7-6.2,7-9.8,9.9c1.5-3.4,2.4-8.3,2.6-11.6c-1.2,4-1.4,9.1-4.2,12.5c-1.7,1.1-3.7,1.9-4.7,3.8 c-4.7-6.1-0.7-14.4-2.9-21c-0.7-2.5,0.5,2.9,0,4.2c0,3.4-1,6.7-1.5,10c-4.5-2.2-7.8-4.5-8.9-9.6l0,0c-1-1.7-1.2-4-2-5.5 c0.9,4,1.8,7.9,4,11.4c-2.4-0.9-5.3-3-7.3-3.9C422.8,301.3,415.8,296.6,420.8,300.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 465.7,
    cy: 313.6,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 468,
    cy: 321.2,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 473.6,
    cy: 307,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 478.8,
    cy: 309.8,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 477.4,
    cy: 324.5,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 475.5,
    cy: 316.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 483.3,
    cy: 316.7,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 456.7,
    cy: 316.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 458,
    cy: 323.2,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 482.9,
    cy: 324,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M457.8,317.6c4.6,3.2,11.3,6.2,12.2,12.3c0.2,6.9,0.8,14.6-2.4,20.8c0,0.1,0,0.2,0.1,0.2h9.1 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.7-2.6-13.4l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.1-4.2c1.4-1,2.3-1.7,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,4.9-6.9,7c1-2.4,1.7-5.8,1.8-8.2c-0.8,2.8-1,6.4-2.9,8.8c-1.2,0.8-2.6,1.3-3.3,2.6 c-3.3-4.3-0.5-10.1-2-14.8c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.7-1.1,7.1c-3.1-1.6-5.5-3.2-6.2-6.7l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.5,2.8,8c-1.7-0.7-3.8-2.1-5.2-2.7C459.1,318.3,454.2,315,457.8,317.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 155.6,
    y: 326.1,
    transform: "matrix(0.9889 -0.1485 0.1485 0.9889 -48.8113 31.8741)",
    width: 66.9,
    height: 33.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M153.5,331.2l5,33.1l66.2-9.9l-5-33.1L153.5,331.2z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.5,331.2l71.1,23.1 M219.7,321.3l-61.2,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "223.6,357.5 189.6,346.5 160.4,367 156.6,361.6 181.7,343.9 152.5,334.4 154.6,328 188.5,339.1  217.8,318.5 221.6,324 196.5,341.7 225.7,351.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_21_",
    points: "189.1,342.8 222.2,337.8 224.6,354.4 191.6,359.3 158.5,364.3 156,347.8 153.5,331.2  186.6,326.2 219.7,321.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.5,331.2l71.1,23.1 M219.7,321.3l-61.2,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "224,356.5 189.5,345.3 159.8,366.1 157.2,362.5 184.2,343.5 152.8,333.3 154.2,329.1  188.7,340.3 218.4,319.5 221,323.1 194,342 225.3,352.2  "
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.6,326.2l5,33.1 M156,347.8l66.2-9.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "197.1,358.5 186.1,360.2 184.4,349.1 156.8,353.3 155.2,342.2 182.7,338.1 181.1,327.1  192.1,325.4 193.8,336.4 221.3,332.3 223,343.3 195.4,347.5  "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.6,326.2l5,33.1 M156,347.8l66.2-9.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "194.9,358.8 188.3,359.8 186.3,346.6 156.5,351.1 155.5,344.4 185.3,340 183.3,326.7 189.9,325.8  191.9,339 221.7,334.5 222.7,341.1 192.9,345.6  "
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 285.3,
    transform: "matrix(0.2756 -0.9613 0.9613 0.2756 -143.147 447.6201)",
    className: "st26",
    width: 35.2,
    height: 66.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197,296.5l64.3,18.4 M259.8,320.2l-64.3-18.4 M194,306.9l64.3,18.4 M256.8,330.6l-64.3-18.4 M191,317.4l64.3,18.4  M253.8,341l-64.3-18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M253.5,342.3l-64.3-18.4l0.7-2.6l64.3,18.4L253.5,342.3z M255,337.1l-64.3-18.4l0.7-2.6l64.3,18.4L255,337.1 z M256.5,331.9l-64.3-18.4l0.7-2.6l64.3,18.4L256.5,331.9z M257.9,326.7l-64.3-18.4l0.7-2.6l64.3,18.4L257.9,326.7z M259.4,321.5 L195.1,303l0.7-2.6l64.3,18.4L259.4,321.5z M260.9,316.3l-64.3-18.4l0.7-2.6l64.3,18.4L260.9,316.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 292,
    transform: "matrix(0.2756 -0.9613 0.9613 0.2756 -142.6212 421.5292)",
    className: "st27",
    width: 19,
    height: 26.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s18_00000056407002921702096240000006951125025369681312_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000080916852801031943980000000474316805875818908_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000140721928553410602830000002280393155808471999_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000037688720084875310970000016305471796281511608_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000088128065562353762400000007292146755536914870_",
    className: "st23",
    d: "M200,294l0.1,2.1l-1.3-1.6l2,0.6l-1.9,0.7 L200,294z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000048469333673824551430000000447829700058485919_",
    className: "st23",
    d: "M199,297.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L199,297.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000115514602640373639850000003298629809883095725_",
    className: "st23",
    d: "M197.9,301.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L197.9,301.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000120517640774524491200000016657259916865689767_",
    className: "st23",
    d: "M196.9,305l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L196.9,305z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000168076554647406199530000016444264054110594750_",
    className: "st23",
    d: "M195.9,308.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L195.9,308.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000067203931040366966840000017816203925352379296_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000096739914992998337640000004830849365442268081_",
    className: "st23",
    d: "M201.7,296.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L201.7,296.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000021834964687706076350000006012399001581954485_",
    className: "st23",
    d: "M200.6,300.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L200.6,300.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000156556909426246038920000000131900035137904521_",
    className: "st23",
    d: "M199.6,303.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L199.6,303.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000146487402812130834270000018172113755875519395_",
    className: "st23",
    d: "M198.5,307.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L198.5,307.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000002352034233517325220000000928210366315989918_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000091709189735018488770000003865271444138149762_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000058586964676612650490000008351630087482608262_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000183241843305039264660000014714896822673624492_",
    className: "st23",
    d: "M204.3,295.2l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L204.3,295.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000093887289719736138060000017481671049732676273_",
    className: "st23",
    d: "M203.3,298.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L203.3,298.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000117673161232311538550000017495124652188371119_",
    className: "st23",
    d: "M202.2,302.5l0.1,2.1L201,303l2,0.6 l-1.9,0.7L202.2,302.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000036214530428865762040000006289605062024033671_",
    className: "st23",
    d: "M201.2,306.2l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L201.2,306.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000055700791937638108250000004109697531749111230_",
    className: "st23",
    d: "M200.1,309.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L200.1,309.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000039820299186053878390000010908982794451826351_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000005266126270736587510000012892722825807708808_",
    className: "st23",
    d: "M205.9,297.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L205.9,297.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000145018752216476826620000005517925811807109284_",
    className: "st23",
    d: "M204.9,301.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L204.9,301.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000054986372047246065670000000654912529097323184_",
    className: "st23",
    d: "M203.9,305l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L203.9,305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000132070249218663157090000014061419674409719425_",
    className: "st23",
    d: "M202.8,308.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L202.8,308.6z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s18_00000181779927704912484900000009451968810136885379_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000037691731530515152630000007873923938203005067_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000099648021301537113460000006174239282908355998_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000067196375549563125250000010126243828931852931_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000130631645773622170730000014941790813356241804_",
    className: "st23",
    d: "M208.6,296.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L208.6,296.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000081618122625691354350000010769766187432007336_",
    className: "st23",
    d: "M207.6,300.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L207.6,300.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000163051950179723684620000010337306671120582047_",
    className: "st23",
    d: "M206.5,303.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L206.5,303.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000057127168091611089670000007699619094858919576_",
    className: "st23",
    d: "M205.5,307.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L205.5,307.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000098943283449255820010000014273259576443830427_",
    className: "st23",
    d: "M204.4,311.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L204.4,311.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000015345456499278943060000000973334880662549424_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000173152299734225759160000006102835969440454321_",
    className: "st23",
    d: "M210.2,298.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L210.2,298.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000075146845054021605140000010253176553024426124_",
    className: "st23",
    d: "M209.2,302.6l0.1,2.1L208,303l2,0.6 l-1.9,0.7L209.2,302.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000079444818182665517650000006044294821614418319_",
    className: "st23",
    d: "M208.1,306.2l0.1,2.1l-1.3-1.6l2,0.6 L207,308L208.1,306.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000082347696085274940570000010012381360444508800_",
    className: "st23",
    d: "M207.1,309.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L207.1,309.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000128471467632039759330000005610076883230166971_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000139982392226494046540000009962680379500423587_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000002349869011071064780000002979390715477510275_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000141415865011993635340000011489510395066728354_",
    className: "st23",
    d: "M212.9,297.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L212.9,297.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000153687807648062487560000008340264147929698950_",
    className: "st23",
    d: "M211.9,301.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L211.9,301.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000041976460698381474480000015539814503471913400_",
    className: "st23",
    d: "M210.8,305l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L210.8,305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000152985374888409081290000000217747034499444411_",
    className: "st23",
    d: "M209.8,308.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L209.8,308.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000114050673747269045510000013293381391319801751_",
    className: "st23",
    d: "M208.7,312.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L208.7,312.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000075149502653997270840000014733122298832134288_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000083807644663599924210000012358198380233738686_",
    className: "st23",
    d: "M214.5,300.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L214.5,300.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000081617718827784464580000017946590682919401390_",
    className: "st23",
    d: "M213.5,303.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L213.5,303.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000080901190656956023000000001995041200978889656_",
    className: "st23",
    d: "M212.4,307.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L212.4,307.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000011748145406810903590000016936946194701409952_",
    className: "st23",
    d: "M211.4,311.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L211.4,311.1z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000143605682506052089130000015577310393962587520_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000033361694299939489510000004624646749372335768_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000081628999967429152490000015452777465767673487_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000088101965967753312600000018125896490749437607_",
    className: "st23",
    d: "M217.2,298.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L217.2,298.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000036953848045779900890000004041636680267160998_",
    className: "st23",
    d: "M216.1,302.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L216.1,302.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000043444112910194828400000013025967085658070173_",
    className: "st23",
    d: "M215.1,306.2l0.1,2.1l-1.3-1.6l2,0.6 L214,308L215.1,306.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000107574543836141117700000003007119477732365245_",
    className: "st23",
    d: "M214.1,309.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L214.1,309.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000041994393291581756470000015526944682918385798_",
    className: "st23",
    d: "M213,313.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L213,313.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000183230970851574355230000013244823443511579547_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000010273838383092421630000005636392295077611164_",
    className: "st23",
    d: "M218.8,301.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L218.8,301.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000095313805683441890930000006882326780147561143_",
    className: "st23",
    d: "M217.8,305l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L217.8,305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000019675269353139893290000017417484154147623603_",
    className: "st23",
    d: "M216.7,308.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L216.7,308.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000083809301519661312130000006972352069008169366_",
    className: "st23",
    d: "M215.7,312.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L215.7,312.3z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000145771108474149172180000001142440115758176416_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000082329460696909955520000017916207825763645596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000117656741656362950120000008976882146105087135_",
    className: "st23",
    d: "M221.5,300.2l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L221.5,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000076564415443656481080000012290249334331085465_",
    className: "st23",
    d: "M220.4,303.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L220.4,303.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000065763783003165973760000012621558165206430872_",
    className: "st23",
    d: "M219.4,307.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L219.4,307.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000080896199574517463280000012405028918240716438_",
    className: "st23",
    d: "M218.3,311.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L218.3,311.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000015337578312280217020000016669677798386384040_",
    className: "st23",
    d: "M217.3,314.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L217.3,314.7z"
  }))))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M101.8,234.4H69.1c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C103.9,231.7,103.1,233.3,101.8,234.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M43.4,361.7H85c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6C40.8,358.3,41.8,360.3,43.4,361.7z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 35.4,
    y1: 277.9,
    x2: 35.4,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M35.4,299.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C43.5,304.9,39.9,299.3,35.4,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,260.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,260.1,33.8,260.9,35.1,260.4 C35,260.5,35.1,260.5,35.1,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,260.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,260.1,36.9,260.9,35.6,260.4 C35.6,260.5,35.6,260.5,35.6,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.3,258.8c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C36.6,257,36.6,258.2,35.3,258.8 C35.4,258.8,35.3,258.8,35.3,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,262.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,262.6,33.8,263.4,35.1,262.9 C35,263,35.1,262.9,35.1,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,262.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,262.6,36.9,263.4,35.6,262.9 C35.6,263,35.6,262.9,35.6,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,265.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,265.1,33.8,265.9,35.1,265.4 C35,265.5,35.1,265.4,35.1,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,265.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,265.1,36.9,265.9,35.6,265.4 C35.6,265.5,35.6,265.4,35.6,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,267.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,267.6,33.8,268.4,35.1,267.9 C35,268,35.1,267.9,35.1,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,267.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,267.6,36.9,268.4,35.6,267.9 C35.6,268,35.6,267.9,35.6,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,270.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,270.1,33.8,270.9,35.1,270.4 C35,270.5,35.1,270.4,35.1,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,270.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,270.1,36.9,270.9,35.6,270.4 C35.6,270.5,35.6,270.4,35.6,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,272.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,272.6,33.8,273.4,35.1,272.9 C35,273,35.1,272.9,35.1,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,272.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,272.6,36.9,273.4,35.6,272.9 C35.6,273,35.6,272.9,35.6,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,275.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,275.1,33.8,275.9,35.1,275.4 C35,275.5,35.1,275.4,35.1,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,275.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,275.1,36.9,275.9,35.6,275.4 C35.6,275.5,35.6,275.4,35.6,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,277.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,277.6,33.8,278.4,35.1,277.9 C35,277.9,35.1,277.9,35.1,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,277.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,277.6,36.9,278.4,35.6,277.9L35.6,277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M35.3,284.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C36.7,284.5,36.1,284.8,35.3,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M29.5,280.1c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1c-0.5-0.4-0.9-0.9-1.3-1.4C30.1,281.3,29.7,280.8,29.5,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M35.3,289.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S36.1,289.5,35.3,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M29.5,284.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1c-0.5-0.4-0.9-0.9-1.3-1.4C30.1,286.1,29.7,285.6,29.5,284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 48.8,
    y1: 277.9,
    x2: 48.8,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M48.9,299.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H60c0.4,0,0.6-0.5,0.2-0.7 C56.9,304.9,53.3,299.3,48.9,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,260.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,260.1,47.2,260.9,48.5,260.4 C48.5,260.5,48.5,260.5,48.5,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,260.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,260.1,50.3,260.9,49,260.4 C49.1,260.5,49,260.5,49,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.7,258.8c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C50,257,50,258.2,48.7,258.8 C48.8,258.8,48.8,258.8,48.7,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,262.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,262.6,47.2,263.4,48.5,262.9 C48.5,263,48.5,262.9,48.5,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,262.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,262.6,50.3,263.4,49,262.9 C49.1,263,49,262.9,49,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,265.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,265.1,47.2,265.9,48.5,265.4 C48.5,265.5,48.5,265.4,48.5,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,265.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,265.1,50.3,265.9,49,265.4 C49.1,265.5,49,265.4,49,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,267.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,267.6,47.2,268.4,48.5,267.9 C48.5,268,48.5,267.9,48.5,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,267.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,267.6,50.3,268.4,49,267.9 C49.1,268,49,267.9,49,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,270.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,270.1,47.2,270.9,48.5,270.4 C48.5,270.5,48.5,270.4,48.5,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,270.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,270.1,50.3,270.9,49,270.4 C49.1,270.5,49,270.4,49,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,272.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,272.6,47.2,273.4,48.5,272.9 C48.5,273,48.5,272.9,48.5,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,272.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,272.6,50.3,273.4,49,272.9 C49.1,273,49,272.9,49,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,275.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,275.1,47.2,275.9,48.5,275.4 C48.5,275.5,48.5,275.4,48.5,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,275.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,275.1,50.3,275.9,49,275.4 C49.1,275.5,49,275.4,49,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,277.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,277.6,47.2,278.4,48.5,277.9L48.5,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,277.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,277.6,50.3,278.4,49,277.9 C49.1,277.9,49,277.9,49,277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M48.8,284.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C50.1,284.5,49.5,284.8,48.8,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M42.9,280.1c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C43.5,281.3,43.1,280.8,42.9,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M48.8,289.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C50.1,289.3,49.5,289.5,48.8,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M42.9,284.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C43.5,286.1,43.1,285.6,42.9,284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 62.2,
    y1: 277.9,
    x2: 62.2,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M62.3,299.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C70.3,304.9,66.8,299.3,62.3,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,260.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,260.1,60.6,260.9,61.9,260.4 C61.9,260.5,61.9,260.5,61.9,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,260.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,260.1,63.7,260.9,62.4,260.4 C62.5,260.5,62.5,260.5,62.4,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.1,258.8c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C63.4,257,63.4,258.2,62.1,258.8 C62.2,258.8,62.2,258.8,62.1,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,262.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,262.6,60.6,263.4,61.9,262.9 C61.9,263,61.9,262.9,61.9,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,262.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,262.6,63.7,263.4,62.4,262.9 C62.5,263,62.5,262.9,62.4,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,265.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,265.1,60.6,265.9,61.9,265.4 C61.9,265.5,61.9,265.4,61.9,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,265.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,265.1,63.7,265.9,62.4,265.4 C62.5,265.5,62.5,265.4,62.4,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,267.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,267.6,60.6,268.4,61.9,267.9 C61.9,268,61.9,267.9,61.9,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,267.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,267.6,63.7,268.4,62.4,267.9 C62.5,268,62.5,267.9,62.4,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,270.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,270.1,60.6,270.9,61.9,270.4 C61.9,270.5,61.9,270.4,61.9,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,270.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,270.1,63.7,270.9,62.5,270.4 C62.5,270.5,62.5,270.4,62.5,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,272.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,272.6,60.6,273.4,61.9,272.9 C61.9,273,61.9,272.9,61.9,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,272.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,272.6,63.7,273.4,62.5,272.9 C62.5,273,62.5,272.9,62.5,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,275.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,275.1,60.6,275.9,61.9,275.4 C61.9,275.5,61.9,275.4,61.9,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,275.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,275.1,63.7,275.9,62.5,275.4 C62.5,275.5,62.5,275.4,62.5,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,277.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,277.6,60.6,278.4,61.9,277.9L61.9,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,277.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,277.6,63.7,278.4,62.5,277.9L62.5,277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M62.2,284.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C63.6,284.5,62.9,284.8,62.2,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M56.3,280.1c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C56.9,281.3,56.6,280.8,56.3,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M62.2,289.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S62.9,289.5,62.2,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M56.3,284.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C56.9,286.1,56.6,285.6,56.3,284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 75.6,
    y1: 277.9,
    x2: 75.6,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M75.7,299.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C83.7,304.9,80.2,299.3,75.7,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,260.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,260.1,74,260.9,75.3,260.4 C75.3,260.5,75.3,260.5,75.3,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,260.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,260.1,77.2,260.9,75.9,260.4 C75.9,260.5,75.9,260.5,75.9,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.6,258.8c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C76.9,257,76.8,258.2,75.6,258.8L75.6,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,262.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,262.6,74,263.4,75.3,262.9 C75.3,263,75.3,262.9,75.3,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,262.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,262.6,77.2,263.4,75.9,262.9 C75.9,263,75.9,262.9,75.9,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,265.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,265.1,74,265.9,75.3,265.4 C75.3,265.5,75.3,265.4,75.3,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,265.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,265.1,77.2,265.9,75.9,265.4 C75.9,265.5,75.9,265.4,75.9,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,267.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,267.6,74.1,268.4,75.3,267.9 C75.3,268,75.3,267.9,75.3,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,267.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,267.6,77.2,268.4,75.9,267.9 C75.9,268,75.9,267.9,75.9,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,270.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,270.1,74.1,270.9,75.3,270.4 C75.3,270.5,75.3,270.4,75.3,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,270.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,270.1,77.2,270.9,75.9,270.4 C75.9,270.5,75.9,270.4,75.9,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,272.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,272.6,74.1,273.4,75.3,272.9 C75.3,273,75.3,272.9,75.3,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,272.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,272.6,77.2,273.4,75.9,272.9 C75.9,273,75.9,272.9,75.9,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,275.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,275.1,74.1,275.9,75.3,275.4 C75.3,275.5,75.3,275.4,75.3,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,275.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,275.1,77.2,275.9,75.9,275.4 C75.9,275.5,75.9,275.4,75.9,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,277.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,277.6,74.1,278.4,75.3,277.9L75.3,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,277.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,277.6,77.2,278.4,75.9,277.9L75.9,277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M75.6,284.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C77,284.5,76.4,284.8,75.6,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M69.8,280.1c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C70.4,281.3,70,280.8,69.8,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M75.6,289.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S76.4,289.5,75.6,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M69.8,284.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C70.4,286.1,70,285.6,69.8,284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 89.1,
    y1: 277.9,
    x2: 89.1,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M89.1,299.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C97.2,304.9,93.6,299.3,89.1,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,260.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,260.1,87.5,260.9,88.8,260.4 C88.7,260.5,88.8,260.5,88.8,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,260.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,260.1,90.6,260.9,89.3,260.4 C89.3,260.5,89.3,260.5,89.3,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89,258.8c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C90.3,257,90.3,258.2,89,258.8 C89.1,258.8,89,258.8,89,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,262.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,262.6,87.5,263.4,88.8,262.9 C88.7,263,88.8,262.9,88.8,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,262.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,262.6,90.6,263.4,89.3,262.9 C89.3,263,89.3,262.9,89.3,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,265.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,265.1,87.5,265.9,88.8,265.4 C88.7,265.5,88.8,265.4,88.8,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,265.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,265.1,90.6,265.9,89.3,265.4 C89.3,265.5,89.3,265.4,89.3,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,267.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,267.6,87.5,268.4,88.8,267.9 C88.7,268,88.8,267.9,88.8,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,267.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,267.6,90.6,268.4,89.3,267.9 C89.3,268,89.3,267.9,89.3,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,270.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,270.1,87.5,270.9,88.8,270.4 C88.7,270.5,88.8,270.4,88.8,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,270.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,270.1,90.6,270.9,89.3,270.4 C89.3,270.5,89.3,270.4,89.3,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,272.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,272.6,87.5,273.4,88.8,272.9 C88.7,273,88.8,272.9,88.8,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,272.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,272.6,90.6,273.4,89.3,272.9 C89.3,273,89.3,272.9,89.3,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,275.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,275.1,87.5,275.9,88.8,275.4 C88.7,275.5,88.8,275.4,88.8,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,275.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,275.1,90.6,275.9,89.3,275.4 C89.3,275.5,89.3,275.4,89.3,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,277.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,277.6,87.5,278.4,88.8,277.9 C88.7,277.9,88.8,277.9,88.8,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,277.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,277.6,90.6,278.4,89.3,277.9L89.3,277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M89,284.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C90.4,284.5,89.8,284.8,89,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M83.2,280.1c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C83.8,281.3,83.4,280.8,83.2,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M89,289.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S89.8,289.5,89,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M83.2,284.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C83.8,286.1,83.4,285.6,83.2,284.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 102.5,
    y1: 277.9,
    x2: 102.5,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M102.6,299.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C110.6,304.9,107,299.3,102.6,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,260.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,260.1,100.9,260.9,102.2,260.4 C102.2,260.5,102.2,260.5,102.2,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,260.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,260.1,104,260.9,102.7,260.4 C102.8,260.5,102.7,260.5,102.7,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.4,258.8c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C103.7,257,103.7,258.2,102.4,258.8 C102.5,258.8,102.4,258.8,102.4,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,262.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,262.6,100.9,263.4,102.2,262.9 C102.2,263,102.2,262.9,102.2,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,262.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,262.6,104,263.4,102.7,262.9 C102.8,263,102.7,262.9,102.7,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,265.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,265.1,100.9,265.9,102.2,265.4 C102.2,265.5,102.2,265.4,102.2,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,265.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,265.1,104,265.9,102.7,265.4 C102.8,265.5,102.7,265.4,102.7,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,267.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,267.6,100.9,268.4,102.2,267.9 C102.2,268,102.2,267.9,102.2,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,267.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,267.6,104,268.4,102.7,267.9 C102.8,268,102.7,267.9,102.7,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,270.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,270.1,100.9,270.9,102.2,270.4 C102.2,270.5,102.2,270.4,102.2,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,270.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,270.1,104,270.9,102.7,270.4 C102.8,270.5,102.7,270.4,102.7,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,272.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,272.6,100.9,273.4,102.2,272.9 C102.2,273,102.2,272.9,102.2,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,272.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,272.6,104,273.4,102.7,272.9 C102.8,273,102.7,272.9,102.7,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,275.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,275.1,100.9,275.9,102.2,275.4 C102.2,275.5,102.2,275.4,102.2,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,275.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,275.1,104,275.9,102.7,275.4 C102.8,275.5,102.7,275.4,102.7,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,277.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,277.6,100.9,278.4,102.2,277.9 L102.2,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,277.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,277.6,104,278.4,102.7,277.9 C102.8,277.9,102.7,277.9,102.7,277.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M102.5,284.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C103.8,284.5,103.2,284.8,102.5,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M96.6,280.1c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C97.2,281.3,96.8,280.8,96.6,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M102.5,289.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C103.8,289.3,103.2,289.5,102.5,289.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M96.6,284.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C97.2,286.1,96.8,285.6,96.6,284.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 42.1,
    y1: 286.8,
    x2: 42.1,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M42.2,308.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C50.2,313.8,46.7,308.2,42.2,308.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,269.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,269,40.5,269.8,41.8,269.3 C41.8,269.4,41.8,269.3,41.8,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,269.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,269,43.7,269.8,42.4,269.3 C42.4,269.4,42.4,269.3,42.4,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.1,267.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C43.4,265.9,43.3,267.1,42.1,267.7L42.1,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,271.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,271.5,40.5,272.3,41.8,271.8 C41.8,271.9,41.8,271.8,41.8,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,271.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,271.5,43.7,272.3,42.4,271.8 C42.4,271.9,42.4,271.8,42.4,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,274.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,274,40.5,274.8,41.8,274.3L41.8,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,274.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,274,43.7,274.8,42.4,274.3L42.4,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,276.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,276.5,40.5,277.3,41.8,276.8L41.8,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,276.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,276.5,43.7,277.3,42.4,276.8L42.4,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,279.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,279,40.5,279.8,41.8,279.3L41.8,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,279.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,278.9,43.7,279.8,42.4,279.3L42.4,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,281.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,281.4,40.6,282.3,41.8,281.8L41.8,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,281.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,281.4,43.7,282.3,42.4,281.8L42.4,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,284.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,283.9,40.6,284.8,41.8,284.3L41.8,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,284.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,283.9,43.7,284.8,42.4,284.3L42.4,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,286.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,286.4,40.6,287.3,41.8,286.8L41.8,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,286.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,286.4,43.7,287.3,42.4,286.8L42.4,286.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M42.1,293.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S42.9,293.6,42.1,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M36.3,288.9c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C36.9,290.2,36.5,289.7,36.3,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M42.1,298.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C43.5,298.2,42.9,298.4,42.1,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M36.3,293.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S36.5,294.4,36.3,293.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 55.6,
    y1: 286.8,
    x2: 55.6,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M55.6,308.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C63.7,313.8,60.1,308.2,55.6,308.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,269.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,269,54,269.8,55.3,269.3 C55.2,269.4,55.3,269.3,55.3,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,269.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,269,57.1,269.8,55.8,269.3 C55.8,269.4,55.8,269.3,55.8,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.5,267.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C56.8,265.9,56.8,267.1,55.5,267.7 C55.6,267.7,55.5,267.7,55.5,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,271.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,271.5,54,272.3,55.3,271.8 C55.2,271.9,55.3,271.8,55.3,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,271.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,271.5,57.1,272.3,55.8,271.8 C55.8,271.9,55.8,271.8,55.8,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,274.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,274,54,274.8,55.3,274.3 C55.2,274.3,55.3,274.3,55.3,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,274.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,274,57.1,274.8,55.8,274.3L55.8,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,276.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,276.5,54,277.3,55.3,276.8 C55.2,276.8,55.3,276.8,55.3,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,276.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,276.5,57.1,277.3,55.8,276.8L55.8,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,279.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,279,54,279.8,55.3,279.3 C55.2,279.3,55.3,279.3,55.3,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,279.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,278.9,57.1,279.8,55.8,279.3L55.8,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,281.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,281.4,54,282.3,55.3,281.8 C55.2,281.8,55.3,281.8,55.3,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,281.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,281.4,57.1,282.3,55.8,281.8L55.8,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,284.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,283.9,54,284.8,55.3,284.3 C55.2,284.3,55.3,284.3,55.3,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,284.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,283.9,57.1,284.8,55.8,284.3L55.8,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,286.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,286.4,54,287.3,55.3,286.8 C55.2,286.8,55.3,286.8,55.3,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,286.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,286.4,57.1,287.3,55.8,286.8L55.8,286.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M55.5,293.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S56.3,293.6,55.5,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M49.7,288.9c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C50.3,290.2,49.9,289.7,49.7,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M55.5,298.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C56.9,298.2,56.3,298.4,55.5,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M49.7,293.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C50.3,295,49.9,294.4,49.7,293.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 69,
    y1: 286.8,
    x2: 69,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M69.1,308.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C77.1,313.8,73.5,308.2,69.1,308.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,269.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,269,67.4,269.8,68.7,269.3 C68.7,269.4,68.7,269.3,68.7,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,269.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,269,70.5,269.8,69.2,269.3 C69.3,269.4,69.2,269.3,69.2,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.9,267.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C70.2,265.9,70.2,267.1,68.9,267.7 C69,267.7,68.9,267.7,68.9,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,271.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,271.5,67.4,272.3,68.7,271.8 C68.7,271.9,68.7,271.8,68.7,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,271.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,271.5,70.5,272.3,69.2,271.8 C69.3,271.9,69.2,271.8,69.2,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,274.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,274,67.4,274.8,68.7,274.3L68.7,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,274.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,274,70.5,274.8,69.2,274.3 C69.3,274.3,69.2,274.3,69.2,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,276.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,276.5,67.4,277.3,68.7,276.8L68.7,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,276.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,276.5,70.5,277.3,69.2,276.8 C69.3,276.8,69.2,276.8,69.2,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,279.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,279,67.4,279.8,68.7,279.3L68.7,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,279.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,278.9,70.5,279.8,69.2,279.3 C69.3,279.3,69.2,279.3,69.2,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,281.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,281.4,67.4,282.3,68.7,281.8L68.7,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,281.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,281.4,70.5,282.3,69.2,281.8 C69.3,281.8,69.2,281.8,69.2,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,284.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,283.9,67.4,284.8,68.7,284.3L68.7,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,284.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,283.9,70.5,284.8,69.2,284.3 C69.3,284.3,69.2,284.3,69.2,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,286.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,286.4,67.4,287.3,68.7,286.8L68.7,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,286.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,286.4,70.5,287.3,69.2,286.8 C69.3,286.8,69.2,286.8,69.2,286.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M69,293.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C70.3,293.4,69.7,293.6,69,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M63.1,288.9c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C63.7,290.2,63.3,289.7,63.1,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M69,298.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C70.3,298.2,69.7,298.4,69,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M63.1,293.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C63.7,295,63.3,294.4,63.1,293.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 82.4,
    y1: 286.8,
    x2: 82.4,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82.5,308.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C90.5,313.8,87,308.2,82.5,308.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,269.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,269,80.8,269.8,82.1,269.3 C82.1,269.4,82.1,269.3,82.1,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,269.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,269,83.9,269.8,82.6,269.3 C82.7,269.4,82.7,269.3,82.6,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.3,267.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C83.6,265.9,83.6,267.1,82.3,267.7 C82.4,267.7,82.4,267.7,82.3,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,271.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,271.5,80.8,272.3,82.1,271.8 C82.1,271.9,82.1,271.8,82.1,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,271.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,271.5,83.9,272.3,82.6,271.8 C82.7,271.9,82.7,271.8,82.6,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,274.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,274,80.8,274.8,82.1,274.3L82.1,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,274.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,274,83.9,274.8,82.6,274.3 C82.7,274.3,82.7,274.3,82.6,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,276.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,276.5,80.8,277.3,82.1,276.8L82.1,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,276.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,276.5,83.9,277.3,82.6,276.8 C82.7,276.8,82.7,276.8,82.6,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,279.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,279,80.8,279.8,82.1,279.3L82.1,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,279.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,278.9,83.9,279.8,82.6,279.3 C82.7,279.3,82.7,279.3,82.6,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,281.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,281.4,80.8,282.3,82.1,281.8L82.1,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,281.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,281.4,83.9,282.3,82.6,281.8 C82.7,281.8,82.7,281.8,82.6,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,284.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C80,283.9,80.8,284.8,82.1,284.3L82.1,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,284.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,283.9,83.9,284.8,82.6,284.3 C82.7,284.3,82.7,284.3,82.6,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,286.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C80,286.4,80.8,287.3,82.1,286.8L82.1,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,286.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,286.4,83.9,287.3,82.6,286.8 C82.7,286.8,82.7,286.8,82.6,286.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M82.4,293.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S83.1,293.6,82.4,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M76.5,288.9c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C77.1,290.2,76.8,289.7,76.5,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M82.4,298.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C83.8,298.2,83.1,298.4,82.4,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M76.5,293.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S76.8,294.4,76.5,293.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 95.8,
    y1: 286.8,
    x2: 95.8,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M95.9,308.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H107c0.4,0,0.6-0.5,0.2-0.7 C103.9,313.8,100.4,308.2,95.9,308.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,269.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,269,94.2,269.8,95.5,269.3 C95.5,269.4,95.5,269.3,95.5,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,269.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,269,97.4,269.8,96.1,269.3 C96.1,269.4,96.1,269.3,96.1,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.8,267.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C97.1,265.9,97,267.1,95.8,267.7L95.8,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,271.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,271.5,94.2,272.3,95.5,271.8 C95.5,271.9,95.5,271.8,95.5,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,271.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,271.5,97.4,272.3,96.1,271.8 C96.1,271.9,96.1,271.8,96.1,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,274.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,274,94.2,274.8,95.5,274.3L95.5,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,274.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,274,97.4,274.8,96.1,274.3L96.1,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,276.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,276.5,94.2,277.3,95.5,276.8L95.5,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,276.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,276.5,97.4,277.3,96.1,276.8L96.1,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,279.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,279,94.2,279.8,95.5,279.3L95.5,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,279.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,278.9,97.4,279.8,96.1,279.3L96.1,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,281.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,281.4,94.2,282.3,95.5,281.8L95.5,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,281.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,281.4,97.4,282.3,96.1,281.8L96.1,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,284.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,283.9,94.2,284.8,95.5,284.3L95.5,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,284.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,283.9,97.4,284.8,96.1,284.3L96.1,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,286.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,286.4,94.2,287.3,95.5,286.8L95.5,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,286.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,286.4,97.4,287.3,96.1,286.8L96.1,286.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M95.8,293.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C97.2,293.4,96.6,293.6,95.8,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M90,288.9c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C90.5,290.2,90.2,289.7,90,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M95.8,298.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C97.2,298.2,96.6,298.4,95.8,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M90,293.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C90.5,295,90.2,294.4,90,293.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 109.3,
    y1: 286.8,
    x2: 109.3,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M109.3,308.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C117.3,313.8,113.8,308.2,109.3,308.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,269.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,269,107.7,269.8,109,269.3 C108.9,269.4,109,269.3,109,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,269.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,269,110.8,269.8,109.5,269.3 C109.5,269.4,109.5,269.3,109.5,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.2,267.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C110.5,265.9,110.5,267.1,109.2,267.7 C109.3,267.7,109.2,267.7,109.2,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,271.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,271.5,107.7,272.3,109,271.8 C108.9,271.9,109,271.8,109,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,271.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,271.5,110.8,272.3,109.5,271.8 C109.5,271.9,109.5,271.8,109.5,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,274.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,274,107.7,274.8,109,274.3 C108.9,274.3,109,274.3,109,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,274.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,274,110.8,274.8,109.5,274.3 L109.5,274.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,276.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,276.5,107.7,277.3,109,276.8 C108.9,276.8,109,276.8,109,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,276.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,276.5,110.8,277.3,109.5,276.8 L109.5,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,279.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,279,107.7,279.8,109,279.3 C108.9,279.3,109,279.3,109,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,279.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,278.9,110.8,279.8,109.5,279.3 L109.5,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,281.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,281.4,107.7,282.3,109,281.8 C108.9,281.8,109,281.8,109,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,281.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,281.4,110.8,282.3,109.5,281.8 L109.5,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,284.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,283.9,107.7,284.8,109,284.3 C108.9,284.3,109,284.3,109,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,284.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,283.9,110.8,284.8,109.5,284.3 L109.5,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,286.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,286.4,107.7,287.3,109,286.8 C108.9,286.8,109,286.8,109,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,286.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,286.4,110.8,287.3,109.5,286.8 L109.5,286.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M109.2,293.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S110,293.6,109.2,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M103.4,288.9c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C104,290.2,103.6,289.7,103.4,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M109.2,298.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C110.6,298.2,110,298.4,109.2,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M103.4,293.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S103.6,294.4,103.4,293.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 0,
    y: 318.4,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 8.2,
    cy: 349.2,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 5.9,
    cy: 356.8,
    r: 8.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -1.228496e-03 1.228496e-03 1 -0.4209 6.270756e-04)",
    className: "st19",
    cx: 0.3,
    cy: 342.6,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -5,
    cy: 345.4,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -3.5,
    cy: 360.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415435e-03 -1 1 2.415435e-03 -353.2949 349.0508)",
    className: "st19",
    cx: -1.7,
    cy: 351.6,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.802501e-03 -1 1 9.802501e-03 -361.6899 339.347)",
    className: "st19",
    cx: -9.5,
    cy: 352.3,
    rx: 7.8,
    ry: 7.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.089770e-03 -1 1 9.089770e-03 -335.4409 366.2961)",
    className: "st19",
    cx: 17.1,
    cy: 352.4,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020247e-02 1.020247e-02 0.9999 -3.6598 0.1809)",
    className: "st19",
    cx: 15.9,
    cy: 358.8,
    rx: 3.3,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -9,
    cy: 359.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M16.1,353.1c-4.6,3.2-11.3,6.2-12.2,12.3c-0.2,6.9-0.8,14.6,2.4,20.8c0,0.1,0,0.2-0.1,0.2H-3 c-0.1,0-0.2-0.1-0.1-0.2c2.1-4.3,1.9-8.7,2.6-13.4l0,0c0.8-4.1,1.1-7.2-2.4-10.2c-1.4-1.4-2.8-2.8-4.1-4.2 c-1.4-1-2.3-1.7-2.9-3.6c-0.3-0.7-0.3-1.3-0.2-1.1c0.8,3.3,4.4,4.9,6.9,7c-1-2.4-1.7-5.8-1.8-8.2c0.8,2.8,1,6.4,2.9,8.8 c1.2,0.8,2.6,1.3,3.3,2.6c3.3-4.3,0.5-10.1,2-14.8c0.5-1.8-0.3,2.1,0,3c0,2.4,0.7,4.7,1.1,7.1c3.1-1.6,5.5-3.2,6.2-6.7l0,0 c0.7-1.2,0.9-2.8,1.4-3.9c-0.6,2.8-1.3,5.5-2.8,8c1.7-0.7,3.8-2.1,5.2-2.7C14.7,353.9,19.6,350.6,16.1,353.1z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 23.3,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 23.2,
    className: "st5",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.8,
    y: 23.2,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 23.3,
    className: "st5",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.8,
    y: 23.2,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.1,
    y: 23.3,
    className: "st5",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 23.3,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.7,
    y: 23.3,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.8,
    y: 23.2,
    className: "st5",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.9,
    y: 23.3,
    className: "st5",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.7,
    y: 23.2,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.8,
    y: 23.3,
    className: "st4",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 23.3,
    className: "st5",
    width: 4.9,
    height: 138.7
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 150.8,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 146,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 135.1,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 130.2,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 119,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 114.1,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 103.2,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 98.4,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 87.2,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 82.3,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 71.5,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 55.3,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 66.6,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 50.5,
    className: "st16",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 39.3,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 23.2,
    className: "st15",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 34.4,
    className: "st16",
    width: 223.6,
    height: 4.9
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 59.4,
    cy: 40.6,
    r: 13.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 62.8,
    cy: 51.7,
    r: 13.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 71,
    cy: 30.9,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 78.8,
    cy: 35.1,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 76.6,
    cy: 56.6,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 73.9,
    cy: 44.2,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 85.3,
    cy: 45.1,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 46.3,
    cy: 45.3,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 48.2,
    cy: 54.7,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 84.6,
    cy: 55.9,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M47.8,46.4c6.7,4.6,16.6,9.2,17.9,18C66.1,74.5,67,85.9,62.3,95c-0.1,0.1,0,0.3,0.2,0.3h13.3 c0.1,0,0.2-0.1,0.2-0.3c-3-6.3-2.8-12.8-3.9-19.7l0,0c-1.2-6-1.6-10.5,3.5-14.9c2-2,4.1-4.1,6-6.2c2-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.8-6.4,7.3-10.1,10.2c1.5-3.5,2.5-8.5,2.7-12c-1.2,4.1-1.4,9.4-4.3,12.9c-1.7,1.1-3.8,2-4.9,3.9 c-4.8-6.3-0.7-14.8-2.9-21.7c-0.8-2.6,0.5,3,0,4.4c0,3.5-1,6.9-1.5,10.3c-4.6-2.3-8.1-4.6-9.1-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.8,4.3,1.8,8.3,4,12c-2.4-1-5.5-3.1-7.6-4C49.9,47.5,42.7,42.7,47.8,46.4z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 25.3,
    cy: 126.5,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 28.7,
    cy: 137.7,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 37.1,
    cy: 116.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 44.8,
    cy: 120.9,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 42.7,
    cy: 142.6,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 39.9,
    cy: 130.1,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 51.5,
    cy: 131,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 12.2,
    cy: 131.1,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 14,
    cy: 140.7,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 50.7,
    cy: 141.9,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M13.7,132.3c6.7,4.7,16.7,9.2,18.1,18.2c0.3,10.2,1.2,21.6-3.5,30.8c-0.1,0.1,0,0.3,0.2,0.3h13.4 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.3-2.9-12.9-3.9-19.8l0,0c-1.2-6-1.6-10.6,3.5-15c2.1-2,4.1-4.1,6.1-6.2c2.1-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.9-6.5,7.3-10.2,10.3c1.5-3.6,2.5-8.6,2.7-12.1c-1.3,4.2-1.5,9.5-4.3,13c-1.7,1.2-3.9,2-4.9,3.9 c-4.9-6.4-0.7-14.9-3-21.8c-0.8-2.6,0.5,3.1,0,4.4c0,3.5-1,7-1.6,10.4c-4.6-2.3-8.1-4.7-9.2-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.2,4.1,11.9c-2.4-1-5.5-3.1-7.6-4C15.7,133.4,8.5,128.5,13.7,132.3z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 117,
    cy: 674.1,
    r: 13.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9951 -9.853765e-02 9.853765e-02 0.9951 -66.9419 15.1991)",
    className: "st19",
    cx: 120.4,
    cy: 685.3,
    rx: 13.2,
    ry: 13.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.327785e-02 -0.9994 0.9994 3.327785e-02 -539.5149 770.8222)",
    className: "st19",
    cx: 128.7,
    cy: 664.3,
    rx: 5.6,
    ry: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 136.5,
    cy: 668.5,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 134.3,
    cy: 690.2,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 131.6,
    cy: 677.7,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 143.2,
    cy: 678.7,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 103.9,
    cy: 678.8,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 105.7,
    cy: 688.3,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 142.4,
    cy: 689.5,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M105.4,679.9c6.7,4.7,16.7,9.2,18.1,18.2c0.3,10.2,1.2,21.6-3.5,30.8c-0.1,0.1,0,0.3,0.2,0.3h13.4 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.3-2.9-12.9-3.9-19.8l0,0c-1.2-6-1.6-10.6,3.5-15c2.1-2,4.1-4.1,6.1-6.2c2.1-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.9-6.5,7.3-10.2,10.3c1.5-3.6,2.5-8.6,2.7-12.1c-1.3,4.2-1.5,9.5-4.3,13c-1.7,1.2-3.9,2-4.9,3.9 c-4.9-6.4-0.7-14.9-3-21.8c-0.8-2.6,0.5,3.1,0,4.4c0,3.5-1,7-1.6,10.4c-4.6-2.3-8.1-4.7-9.2-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.2,4.1,11.9c-2.4-1-5.5-3.1-7.6-4C107.4,681.1,100.2,676.2,105.4,679.9z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 486.1,
    cy: 47.3,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 489.3,
    cy: 57.9,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 497.2,
    cy: 38,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 504.6,
    cy: 42,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 502.6,
    cy: 62.6,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 499.9,
    cy: 50.7,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 511,
    cy: 51.6,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 473.6,
    cy: 51.8,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 475.3,
    cy: 60.8,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 510.3,
    cy: 61.9,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M475,52.8c6.4,4.5,15.9,8.8,17.2,17.3c0.3,9.7,1.2,20.6-3.3,29.3c-0.1,0.1,0,0.3,0.2,0.3h12.8 c0.1,0,0.2-0.1,0.2-0.3c-2.9-6-2.7-12.3-3.7-18.9l0,0c-1.1-5.8-1.5-10.1,3.3-14.3c2-1.9,3.9-3.9,5.8-5.9c2-1.4,3.2-2.4,4.1-5 c0.4-1,0.4-1.8,0.3-1.5c-1.1,4.6-6.2,7-9.7,9.8c1.5-3.4,2.4-8.2,2.6-11.5c-1.2,4-1.4,9-4.1,12.3c-1.6,1.1-3.7,1.9-4.7,3.7 c-4.6-6.1-0.7-14.2-2.8-20.8c-0.7-2.5,0.4,2.9,0,4.2c0,3.3-1,6.7-1.5,9.9c-4.4-2.2-7.7-4.4-8.8-9.5l0,0c-1-1.7-1.2-3.9-2-5.5 c0.8,3.9,1.8,7.8,3.9,11.3c-2.3-0.9-5.3-3-7.2-3.9C476.9,53.9,470.1,49.3,475,52.8z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M344.4,184.7c0.3,0.3,1.5,1.3,2.5,5.9c0,0,0.6,2.9,1.3,3.8c0.6,0.9,2,2.2,2.1,3.3s0.2,1.7,0.2,1.7 s3.4,0.4,4.7,0.2c1.3-0.2,2.1-0.4,2.1-0.4s0.1-0.3-0.3-0.8c-0.4-0.4-1.8-1.7-2.3-2c-0.5-0.4-1.9-1.7-2.9-4c-0.9-2.3-1.1-5.4-1-7.4 c0.2-2,1.3-7.1,1.3-7.1l-1.4-2.8L344.4,184.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M350.2,177c0.5,0.1,1.5,1.1,1.5,2.7c0,1.6,0.2,2.2,0.8,2.2s0.9-0.8,1-2.2s1.4-1.4,1.7-1.2 c0.3,0.2,0.6,0.4,0.4,1.9c-0.1,1.5,0.3,1.7,0.6,1.7c0.3,0,0.9,0,1-1.7c0.1-1.6,0.5-2.1,1-2.1c0.6,0,0.8,0.4,0.8,1.2 s-0.5,2.4,0.6,2.5s1-1.2,1.1-2.1c0.1-0.9,0-1.8,1.1-2.3c1.1-0.6,3.7-1,4.9-2.2l-3.2-2.6L357,172l-4.2,0.1L350.2,177z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M374.3,176.8c0.2,0.9,1,4.6,1.3,10.1s-0.3,4.8-0.2,7.1c0.2,2.4,0.9,6.7,1.5,7s4,0.3,4.5,0 c0,0,0.3-0.3,0.1-0.6s-1.1-1-1.4-1.7c-0.2-0.6-0.5-2-0.6-2.8s-0.1-2.2,0.2-2.8c0.3-0.6,1-2.2,1.1-3.2s0.6-5.7,1-7s-1.1-6.3-1.1-6.3 L374.3,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M406.3,137.7c0,0,1.5-1.5,1.7-3.1c0,0,1.5,1,1.3,3.7c0,0,2.4,1.8,4.3,4.3c2,2.5,3.2,3.7,4.5,4.3s4,2,3.6,3.6 s-0.8,3.4-2.1,3.9s-3.6,0.3-5.7,0.4c-2.2,0.1-3.7,0.4-4.1,0.5s-4.8,1.4-5.4,1.7s-1,0.6-1.3,1.1s-2.2,3.7-3.2,5.9 c-1.1,2.3-2.5,5.9-4.3,7.9c-1.7,2-3.3,3.7-5.3,5.4c0,0-0.5,0.6-0.8,3.6s-1.2,12.4-0.7,14.1c0.5,1.7,1.1,4.4,3.7,7.3 c0,0-3,0.9-4.2,0.4c-1.3-0.5-2.2-2.5-2.5-3.1s-2.5-4.3-2.7-5.6c-0.1-1.3-0.1-3.9-0.2-4.8c-0.1-0.9-0.9-5.4-1.9-7.9s-2.1-3.6-4-3.7 c-1.9-0.1-6.8-0.5-11.2-2.3s-11.2-1.9-12.4-1.4s-1,0.6-1.2,1s-1.6,4.1-6,9c0,0-1.6,1.7-1.7,2.2c-0.1,0.4-0.3,1.8-0.4,3.5 c0,1.7,0.1,5.1,1.6,7.2s3.8,5.7,3.8,5.7s-4.6,0.4-5.3,0.2c-0.7-0.2-1.7-1.6-2.4-3.1c-0.8-1.4-2.1-3.9-2.3-4.3s-0.3-1.9-0.4-2.5 c0-0.6-0.2-4.1-0.4-5s-0.5-2.6-0.1-4.1s1.1-3.5,1.2-4.7s0.5-2.4-0.1-3.1c-0.6-0.7-2.9-2.8-3.5-5.5s-0.7-4.9-0.7-4.9s0,3.9-0.8,5.9 c-0.7,2.1-1.1,2.7-1.1,2.7s-0.1,3.8-1.6,5.4c-1.4,1.7-2.8,2.3-4,1.9c0,0,1.5-0.6,2.2-2.3s1.6-4.1,2.4-5c0,0,1-1.7,1.2-3.9 c0.2-2.3,0.4-6.1,0.4-8.9s0.3-10.7,5.4-14.3s14.2-2.5,16.3-2.5c2.2,0,12.4,0.7,15,0.6c2.7-0.1,4.2-0.1,5.3-0.5s5.1-2.4,8.3-3 c3.2-0.5,7.3,0,9.6-0.2c2.3-0.2,4-1.1,4.7-1.5S403.8,137.9,406.3,137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M342.3,165.7c0.4-1.2,0.9-3,1.5-4.3c0.5-1.1,1.7-2.4,1.8-3.6c0.3-2.9-0.3-6.8-1.3-9.4 c-0.4-1.1-1.6-2.6-1.6-2.6c-1.1,0.4-2.1,0.9-3,1.5c-5.1,3.6-4.6,10-4.7,12.9c0,1.5,0.5,5.6,0.5,5.6s0.1,1.3,0.4,3.2 c0,0,2.5-0.2,3.8-0.9C340.9,167.4,341.7,167.4,342.3,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M365.7,152c0.1,0.7,2,2.6,2.9,3.6c1.2,1.2,2.4,2.6,4.1,3.3c0.7,0.3,2.6-0.2,3.5-0.3c1.7-0.3,3.9-1,5.5-1.8 c0.8-0.4,2.3-1,2.8-1.6c0.8-0.9,0.6-2.9,0.5-4.8c-0.1-1.8,0.2-3.4,0.2-5.2c0-1.3-0.1-3.4-0.1-3.4c-0.1,0-0.3,0-0.4,0.1 c-3.2,0.5-7.2,2.5-8.3,3c-1.1,0.4-2.7,0.4-5.3,0.5c-0.8,0-2.4,0-4.2-0.1C366.5,145.2,365.4,149.6,365.7,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M386.3,200.8c0.5,0.7,1.1,1.6,1.9,1.9c1.3,0.5,4.2-0.4,4.2-0.4c-0.6-0.6-1-1.3-1.4-1.9L386.3,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M342.5,201c0.6,0.9,1.2,1.6,1.7,1.8c0.7,0.2,5.3-0.2,5.3-0.2s-0.7-1-1.5-2.3 C346.8,200.5,344.7,200.7,342.5,201z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M380.5,199.4c-1.4,0.5-2.8,0.5-4.2,0.5c0.2,0.7,0.4,1.1,0.6,1.2c0.6,0.3,4,0.3,4.5,0c0,0,0.3-0.3,0.1-0.6 C381.4,200.2,380.9,199.8,380.5,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M412.6,135.7c0,0-0.4,3.3-1.4,4.9c0,0,2.1,2.5,2.8,3.6s1.7,1.7,1.4,2.7c-0.2,0.9-1.1,3.4-2.7,4.1 c-1.5,0.6-6.2-0.3-7-0.6s-1.4-0.5-1.7-1.5c-0.3-0.9-0.8-1.9-1.6-2.9s-1.3-1.6-0.8-3.1s1.7-2.5,3.1-2.8s2.5-0.8,2.5-0.8L412.6,135.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M394.1,143.3c-0.5-0.3-1.1-0.3-1.5-0.1c-0.5,0.2-0.8,0.7-1.3,1c-0.7,0.5-1.6,0.7-2.3,1.2 c-0.7,0.5-1.2,1.4-1.4,2.3c-0.2,0.9-0.2,1.8-0.3,2.7c0,0.4,0,0.8,0.1,1.2s0.4,0.7,0.7,0.9c0.4,0.1,0.8,0,1.2-0.2 c0.4-0.2,0.7-0.5,1-0.7c0.5-0.3,1.2-0.5,1.8-0.6c0.6-0.1,1.3-0.2,1.9-0.4s1.1-0.7,1.4-1.3c0.2-0.6,0.1-1.3-0.1-2 c-0.2-0.8-0.4-1.5-0.5-2.3C394.8,144.2,394.6,143.7,394.1,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M390.4,154.8c-0.9,0.6-1.7,1.4-2.5,2.3c-1.1,1.2-2.2,2.3-3.3,3.5c-0.6,0.6-1.2,1.3-1.4,2.1 c-0.2,0.7,0,1.5,0.2,2.2c0.3,1,0.5,2.1,0.8,3.1c0.2,0.6,0.3,1.2,0.6,1.8c0.3,0.5,0.8,1,1.3,1.2c0.7,0.3,1.5,0.1,2.2-0.1 c1.5-0.3,2.9-0.7,4.4-1c0.7-0.2,1.4-0.3,2-0.7c0.8-0.5,1.3-1.4,1.7-2.3c0.9-2.1,1.6-4.2,2-6.5c0.2-1.1,0.3-2.3,0.1-3.4 c-0.2-1.1-1-2.4-2.1-2.9c-1.3-0.5-2.7-0.5-4-0.2C391.7,154.1,391,154.4,390.4,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M368.4,159.9c-1-0.6-2.2-1.1-3.3-1.2c-1.2-0.1-2.5,0.2-3.3,1.1c-0.7,0.6-1.1,1.5-1.4,2.4 c-0.4,0.9-0.6,1.8-0.9,2.8c-0.1,0.6-0.2,1.1,0,1.7c0.3,0.7,1,1.1,1.7,1.5c1.7,0.8,3.5,1.4,5.3,1.8c1.4,0.3,3,0.5,4.3-0.1 c1.4-0.6,2.3-2.1,2.4-3.6c0-1.1-0.3-2.1-0.9-3c-0.3-0.4-1.8-1.7-2.2-2C369.5,160.7,368.9,160.3,368.4,159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M356.8,149.8c-1.4,0.1-2.8,0.9-3.7,2.1c-1.3,1.8-1.4,4.2-2.9,5.8c-0.3,0.3-0.7,0.6-0.7,1c0,0.6,0.5,1,1,1.2 c1,0.5,2.2,0.6,3.4,0.5c1.1-0.1,2.3-0.4,3.4-0.7c0.8-0.2,1.6-0.5,2.3-0.9c1.2-0.8,2-2.1,2.1-3.5c0.1-1.2-0.2-2.4-0.7-3.4 c-0.5-0.9-1.4-1.6-2.4-1.9C358,149.9,357.4,149.8,356.8,149.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M350.3,198.1c0.1,0.8,0.2,1.3,0.2,1.3s3.4,0.4,4.7,0.2s2.1-0.4,2.1-0.4s0.1-0.3-0.3-0.8 c-0.2-0.2-0.7-0.7-1.3-1.2C354.4,197.7,352.5,198,350.3,198.1z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M654.9,93.5c-0.2,0.2-1.2,1-2,4.7c0,0-0.5,2.3-1,3s-1.6,1.7-1.7,2.6c-0.1,0.8-0.2,1.3-0.2,1.3 s-2.7,0.3-3.7,0.2c-1-0.1-1.6-0.3-1.6-0.3s-0.1-0.3,0.2-0.6s1.4-1.3,1.8-1.6s1.5-1.4,2.3-3.2c0.7-1.8,0.9-4.3,0.8-5.9 s-1.1-5.7-1.1-5.7l1.1-2.2L654.9,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M650.3,87.4c-0.4,0.1-1.2,0.9-1.2,2.1s-0.1,1.8-0.7,1.8s-0.7-0.6-0.8-1.8c0-1.1-1.1-1.1-1.3-1 s-0.5,0.3-0.3,1.5c0.1,1.2-0.2,1.3-0.5,1.4c-0.2,0-0.7,0-0.8-1.3s-0.4-1.7-0.8-1.7c-0.4,0-0.6,0.3-0.6,1s0.4,1.9-0.5,2 s-0.8-1-0.8-1.7c-0.1-0.7,0-1.4-0.9-1.9c-0.9-0.4-2.9-0.8-3.9-1.8l2.6-2.1l5.2-0.6l3.3,0.1L650.3,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M631.1,87.1c-0.2,0.7-0.8,3.7-1,8.1s0.3,3.8,0.1,5.7s-0.7,5.4-1.2,5.6s-3.2,0.2-3.6,0c0,0-0.2-0.2-0.1-0.5 s0.9-0.8,1.1-1.3c0.2-0.5,0.4-1.6,0.4-2.2s0.1-1.8-0.1-2.3c-0.2-0.5-0.8-1.7-0.9-2.5s-0.5-4.6-0.8-5.6s0.9-5,0.9-5L631.1,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M605.5,56c0,0-1.2-1.2-1.4-2.5c0,0-1.2,0.8-1,2.9c0,0-1.9,1.4-3.5,3.4s-2.6,2.9-3.6,3.4 c-1,0.4-3.2,1.6-2.9,2.8c0.3,1.2,0.6,2.7,1.7,3.1c1.1,0.4,2.9,0.2,4.6,0.3s2.9,0.3,3.2,0.4s3.8,1.1,4.3,1.3s0.8,0.5,1,0.9 s1.7,2.9,2.6,4.7c0.8,1.8,2,4.7,3.4,6.3c1.4,1.6,2.6,3,4.3,4.3c0,0,0.4,0.5,0.7,2.9s1,9.9,0.6,11.2c-0.4,1.3-0.9,3.5-2.9,5.8 c0,0,2.4,0.7,3.4,0.3s1.8-2,2-2.4s2-3.4,2.1-4.5s0.1-3.1,0.1-3.8c0-0.7,0.7-4.3,1.5-6.3s1.6-2.9,3.2-3c1.5-0.1,5.4-0.4,8.9-1.8 c3.5-1.5,8.9-1.5,9.8-1.1s0.8,0.5,0.9,0.8c0.1,0.3,1.2,3.3,4.8,7.2c0,0,1.3,1.4,1.3,1.7c0.1,0.3,0.3,1.4,0.3,2.8s-0.1,4.1-1.2,5.7 s-3,4.5-3,4.5s3.7,0.3,4.2,0.2s1.3-1.3,1.9-2.4c0.6-1.1,1.6-3.1,1.8-3.4c0.1-0.3,0.2-1.5,0.3-2c0-0.5,0.1-3.3,0.3-4 s0.4-2.1,0.1-3.3s-0.9-2.8-1-3.7c-0.1-0.9-0.4-1.9,0.1-2.4s2.3-2.3,2.8-4.4s0.6-3.9,0.6-3.9s0,3.1,0.6,4.7s0.8,2.1,0.8,2.1 s0.1,3,1.2,4.3c1.1,1.3,2.3,1.8,3.2,1.5c0,0-1.2-0.5-1.7-1.8s-1.3-3.3-1.9-4c0,0-0.8-1.3-0.9-3.1c-0.2-1.8-0.3-4.9-0.3-7.1 s-0.2-8.5-4.3-11.4s-11.3-2-13-2s-9.8,0.6-11.9,0.5s-3.4-0.1-4.3-0.4c-0.9-0.3-4.1-1.9-6.6-2.4s-5.8,0-7.7-0.2 c-1.8-0.2-3.2-0.9-3.8-1.2S607.5,56.2,605.5,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M656.6,78.3c-0.3-1-0.7-2.4-1.2-3.5C655,74,654,73,654,72c-0.2-2.3,0.2-5.4,1-7.5c0.3-0.9,1.3-2.1,1.3-2.1 c0.9,0.3,1.7,0.7,2.4,1.2c4.1,2.9,3.7,8,3.7,10.3c0,1.2-0.4,4.5-0.4,4.5s-0.1,1.1-0.3,2.5c0,0-2-0.2-3-0.7 C657.7,79.7,657,79.7,656.6,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M637.9,67.4c-0.1,0.5-1.6,2.1-2.3,2.8c-1,1-1.9,2.1-3.3,2.6c-0.6,0.2-2.1-0.2-2.8-0.3 c-1.4-0.2-3.1-0.8-4.4-1.4c-0.6-0.3-1.8-0.8-2.3-1.3c-0.6-0.7-0.5-2.3-0.4-3.8s-0.2-2.7-0.1-4.1c0-1.1,0.1-2.7,0.1-2.7 c0.1,0,0.2,0,0.3,0c2.5,0.4,5.7,2,6.6,2.4c0.9,0.3,2.1,0.3,4.3,0.4c0.7,0,1.9,0,3.3-0.1C637.3,62,638.2,65.5,637.9,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M621.5,106.3c-0.4,0.6-0.9,1.3-1.5,1.5c-1,0.4-3.4-0.3-3.4-0.3c0.5-0.5,0.8-1,1.1-1.5L621.5,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M656.4,106.4c-0.5,0.7-1,1.3-1.3,1.4c-0.5,0.1-4.2-0.2-4.2-0.2s0.5-0.8,1.2-1.8 C652.9,106,654.6,106.2,656.4,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M626.1,105.1c1.1,0.4,2.2,0.4,3.4,0.4c-0.2,0.5-0.3,0.9-0.5,0.9c-0.5,0.2-3.2,0.2-3.6,0c0,0-0.2-0.2-0.1-0.5 C625.4,105.8,625.8,105.5,626.1,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M600.6,54.5c0,0,0.3,2.6,1.1,3.9c0,0-1.7,2-2.2,2.9c-0.6,0.9-1.3,1.4-1.1,2.1s0.9,2.7,2.1,3.2 c1.2,0.5,4.9-0.2,5.6-0.5c0.6-0.3,1.1-0.4,1.4-1.2c0.2-0.7,0.6-1.5,1.2-2.3c0.6-0.8,1.1-1.3,0.7-2.5c-0.4-1.2-1.4-2-2.4-2.2 s-2-0.6-2-0.6L600.6,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M615.3,60.5c0.4-0.2,0.8-0.3,1.2-0.1s0.7,0.5,1,0.8c0.5,0.4,1.2,0.5,1.8,0.9s1,1.1,1.1,1.8 c0.2,0.7,0.2,1.4,0.2,2.2c0,0.3,0,0.6-0.1,0.9s-0.3,0.6-0.6,0.7s-0.7,0-1-0.2s-0.5-0.4-0.8-0.6c-0.4-0.3-0.9-0.4-1.5-0.5 c-0.5-0.1-1-0.2-1.5-0.3c-0.5-0.2-0.9-0.5-1.1-1c-0.2-0.5-0.1-1.1,0.1-1.6c0.1-0.6,0.3-1.2,0.4-1.8 C614.8,61.2,614.9,60.8,615.3,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M618.3,69.7c0.7,0.5,1.4,1.1,2,1.8c0.9,0.9,1.7,1.8,2.6,2.8c0.5,0.5,1,1,1.1,1.7c0.1,0.6,0,1.2-0.2,1.7 c-0.2,0.8-0.4,1.6-0.7,2.5c-0.1,0.5-0.3,1-0.5,1.4s-0.6,0.8-1.1,1c-0.6,0.2-1.2,0.1-1.7-0.1c-1.2-0.3-2.3-0.5-3.5-0.8 c-0.6-0.1-1.1-0.3-1.6-0.6c-0.6-0.4-1-1.1-1.3-1.8c-0.7-1.6-1.3-3.4-1.6-5.1c-0.2-0.9-0.3-1.8-0.1-2.7c0.2-0.9,0.8-1.9,1.7-2.3 c1-0.4,2.2-0.4,3.2-0.2C617.2,69.1,617.8,69.3,618.3,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M635.8,73.7c0.8-0.5,1.7-0.9,2.7-1s2,0.2,2.7,0.8c0.5,0.5,0.9,1.2,1.1,1.9c0.3,0.7,0.5,1.5,0.7,2.2 c0.1,0.4,0.2,0.9,0,1.3c-0.2,0.6-0.8,0.9-1.4,1.2c-1.4,0.6-2.8,1.1-4.2,1.5c-1.1,0.3-2.4,0.4-3.4-0.1c-1.1-0.5-1.8-1.7-1.9-2.9 c0-0.8,0.2-1.7,0.7-2.4c0.2-0.3,1.5-1.3,1.8-1.6C634.9,74.4,635.3,74,635.8,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M645,65.7c1.1,0.1,2.2,0.7,2.9,1.7c1,1.4,1.1,3.4,2.3,4.6c0.2,0.2,0.5,0.5,0.6,0.8c0,0.4-0.4,0.8-0.8,0.9 c-0.8,0.4-1.8,0.5-2.7,0.4s-1.8-0.3-2.7-0.5c-0.6-0.2-1.3-0.4-1.8-0.7c-0.9-0.6-1.6-1.7-1.7-2.8c-0.1-0.9,0.1-1.9,0.6-2.7 c0.4-0.7,1.1-1.2,1.9-1.5C644,65.7,644.5,65.6,645,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M650.1,104.1c-0.1,0.6-0.1,1-0.1,1s-2.7,0.3-3.7,0.2s-1.6-0.3-1.6-0.3s-0.1-0.3,0.2-0.6 c0.2-0.2,0.6-0.6,1-0.9C646.9,103.8,648.4,104,650.1,104.1z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M563.5,98.1c0.1,0.1,0.7,0.6,1.2,2.8c0,0,0.3,1.4,0.6,1.8s0.9,1.1,1,1.6s0.1,0.8,0.1,0.8s1.6,0.2,2.2,0.1 c0.6-0.1,1-0.2,1-0.2s0.1-0.2-0.1-0.4c-0.2-0.2-0.9-0.8-1.1-1s-0.9-0.8-1.4-1.9s-0.6-2.6-0.5-3.6s0.6-3.4,0.6-3.4l-0.7-1.3 L563.5,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M577.8,94.3c0.1,0.4,0.5,2.2,0.6,4.9c0.1,2.6-0.2,2.3-0.1,3.4c0.1,1.1,0.4,3.2,0.7,3.4c0.3,0.1,1.9,0.1,2.2,0 c0,0,0.1-0.1,0.1-0.3c-0.1-0.1-0.5-0.5-0.7-0.8s-0.2-1-0.3-1.3c0-0.4-0.1-1.1,0.1-1.4c0.1-0.3,0.5-1,0.5-1.5 c0.1-0.5,0.3-2.8,0.5-3.3c0.2-0.6-0.6-3-0.6-3L577.8,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M593.2,75.6c0,0,0.7-0.7,0.8-1.5c0,0,0.7,0.5,0.6,1.8c0,0,1.1,0.9,2.1,2.1s1.5,1.8,2.2,2 c0.6,0.3,1.9,1,1.7,1.7s-0.4,1.6-1,1.9c-0.6,0.2-1.7,0.1-2.8,0.2c-1,0-1.8,0.2-2,0.2c-0.2,0.1-2.3,0.7-2.6,0.8 c-0.3,0.1-0.5,0.3-0.6,0.5s-1,1.8-1.5,2.8c-0.5,1.1-1.2,2.8-2.1,3.8c-0.8,1-1.6,1.8-2.6,2.6c0,0-0.2,0.3-0.4,1.7 c-0.2,1.4-0.6,6-0.4,6.8c0.2,0.8,0.5,2.1,1.8,3.5c0,0-1.4,0.4-2,0.2c-0.6-0.2-1.1-1.2-1.2-1.5c-0.2-0.3-1.2-2.1-1.3-2.7 s-0.1-1.9-0.1-2.3s-0.4-2.6-0.9-3.8c-0.5-1.2-1-1.7-1.9-1.8c-0.9-0.1-3.2-0.2-5.4-1.1c-2.1-0.9-5.4-0.9-5.9-0.7 c-0.6,0.3-0.5,0.3-0.6,0.5s-0.8,2-2.9,4.3c0,0-0.8,0.8-0.8,1s-0.2,0.9-0.2,1.7c0,0.8,0.1,2.5,0.8,3.5s1.8,2.7,1.8,2.7 s-2.2,0.2-2.5,0.1s-0.8-0.8-1.2-1.5s-1-1.9-1.1-2.1s-0.2-0.9-0.2-1.2c0-0.3-0.1-2-0.2-2.4c-0.1-0.4-0.2-1.3-0.1-2s0.5-1.7,0.6-2.2 c0.1-0.6,0.3-1.1-0.1-1.5c-0.3-0.3-1.4-1.4-1.7-2.7c-0.3-1.3-0.3-2.3-0.3-2.3s0,1.9-0.4,2.8c-0.4,1-0.5,1.3-0.5,1.3 s-0.1,1.8-0.8,2.6s-1.4,1.1-1.9,0.9c0,0,0.7-0.3,1.1-1.1c0.3-0.8,0.8-2,1.1-2.4c0,0,0.5-0.8,0.6-1.9s0.2-2.9,0.2-4.3 s0.1-5.1,2.6-6.9s6.8-1.2,7.8-1.2s5.9,0.3,7.2,0.3s2,0,2.6-0.3c0.5-0.2,2.5-1.2,4-1.4c1.5-0.3,3.5,0,4.6-0.1s1.9-0.5,2.3-0.7 S592,75.7,593.2,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M562.5,89c0.2-0.6,0.4-1.5,0.7-2.1c0.2-0.5,0.8-1.1,0.8-1.7c0.1-1.4-0.1-3.3-0.6-4.5 c-0.2-0.5-0.8-1.3-0.8-1.3c-0.5,0.2-1,0.4-1.4,0.7c-2.5,1.7-2.2,4.8-2.2,6.2c0,0.7,0.2,2.7,0.2,2.7s0,0.6,0.2,1.5 c0,0,1.2-0.1,1.8-0.4C561.8,89.8,562.2,89.8,562.5,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M573.7,82.4c0,0.3,1,1.2,1.4,1.7c0.6,0.6,1.1,1.3,2,1.6c0.4,0.1,1.3-0.1,1.7-0.2c0.8-0.1,1.9-0.5,2.6-0.8 c0.4-0.2,1.1-0.5,1.4-0.8c0.4-0.4,0.3-1.4,0.2-2.3s0.1-1.6,0.1-2.5c0-0.6,0-1.6-0.1-1.6s-0.1,0-0.2,0c-1.5,0.3-3.4,1.2-4,1.4 c-0.5,0.2-1.3,0.2-2.6,0.3c-0.4,0-1.1,0-2,0C574.1,79.2,573.6,81.3,573.7,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M583.6,105.9c0.2,0.4,0.5,0.8,0.9,0.9c0.6,0.2,2-0.2,2-0.2c-0.3-0.3-0.5-0.6-0.7-0.9L583.6,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M562.6,105.9c0.3,0.4,0.6,0.8,0.8,0.8c0.3,0.1,2.5-0.1,2.5-0.1s-0.3-0.5-0.7-1.1 C564.7,105.7,563.7,105.8,562.6,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M580.9,105.2c-0.7,0.2-1.3,0.2-2,0.2c0.1,0.3,0.2,0.5,0.3,0.6c0.3,0.1,1.9,0.1,2.2,0c0,0,0.1-0.1,0.1-0.3 C581.3,105.6,581,105.4,580.9,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M596.2,74.6c0,0-0.2,1.6-0.7,2.3c0,0,1,1.2,1.3,1.7s0.8,0.8,0.7,1.3s-0.6,1.6-1.3,1.9s-3-0.2-3.3-0.3 s-0.7-0.3-0.8-0.7s-0.4-0.9-0.8-1.4c-0.4-0.5-0.6-0.8-0.4-1.5c0.2-0.7,0.8-1.2,1.5-1.3s1.2-0.4,1.2-0.4L596.2,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M585.6,83.8c-0.5,0.3-0.8,0.7-1.2,1.1c-0.5,0.6-1,1.1-1.6,1.7c-0.3,0.3-0.6,0.6-0.7,1c-0.1,0.3,0,0.7,0.1,1 c0.1,0.5,0.3,1,0.4,1.5c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.3,0.4,0.5,0.6,0.6c0.3,0.1,0.7,0,1.1,0c0.7-0.2,1.4-0.3,2.1-0.5 c0.3-0.1,0.7-0.2,1-0.3c0.4-0.3,0.6-0.7,0.8-1.1c0.4-1,0.8-2,1-3.1c0.1-0.5,0.2-1.1,0.1-1.7c-0.1-0.5-0.5-1.2-1-1.4 c-0.6-0.2-1.3-0.2-1.9-0.1C586.2,83.4,585.9,83.6,585.6,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M571,85.3c-0.5-0.3-1-0.5-1.6-0.6c-0.6,0-1.2,0.1-1.6,0.5c-0.3,0.3-0.5,0.7-0.7,1.1s-0.3,0.9-0.4,1.3 c-0.1,0.3-0.1,0.6,0,0.8c0.1,0.3,0.5,0.5,0.8,0.7c0.8,0.4,1.7,0.7,2.6,0.9c0.7,0.2,1.4,0.2,2.1-0.1c0.7-0.3,1.1-1,1.1-1.8 c0-0.5-0.1-1-0.4-1.4c-0.1-0.2-0.9-0.8-1.1-1C571.5,85.6,571.2,85.4,571,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M566.4,104.6c0.1,0.4,0.1,0.6,0.1,0.6s1.6,0.2,2.2,0.1c0.6-0.1,1-0.2,1-0.2s0.1-0.2-0.1-0.4 c-0.1-0.1-0.4-0.4-0.6-0.6C568.3,104.4,567.4,104.5,566.4,104.6z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 265.5,
    cy: 89.3,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 268.3,
    cy: 98.6,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 275.2,
    cy: 81.1,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 281.7,
    cy: 84.7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 279.9,
    cy: 102.7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 277.6,
    cy: 92.3,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 287.2,
    cy: 93.1,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 254.5,
    cy: 93.2,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 256.1,
    cy: 101.1,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 286.6,
    cy: 102.1,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M255.8,94.1c5.6,3.9,13.9,7.7,15,15.1c0.2,8.5,1,18-2.9,25.6c-0.1,0.1,0,0.2,0.1,0.2h11.2 c0.1,0,0.2-0.1,0.1-0.2c-2.5-5.3-2.4-10.7-3.2-16.5l0,0c-1-5-1.3-8.8,2.9-12.5c1.7-1.7,3.4-3.4,5.1-5.2c1.7-1.2,2.8-2.1,3.6-4.4 c0.3-0.8,0.3-1.6,0.3-1.3c-1,4.1-5.4,6.1-8.5,8.6c1.3-3,2.1-7.2,2.2-10.1c-1,3.5-1.2,7.9-3.6,10.8c-1.4,1-3.2,1.6-4.1,3.3 c-4.1-5.3-0.6-12.4-2.5-18.2c-0.6-2.2,0.4,2.5,0,3.7c0,2.9-0.8,5.8-1.3,8.7c-3.9-1.9-6.8-3.9-7.7-8.3l0,0c-0.9-1.5-1.1-3.4-1.8-4.8 c0.7,3.4,1.5,6.8,3.4,9.9c-2-0.8-4.6-2.6-6.3-3.4C257.5,95.1,251.5,91,255.8,94.1z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 234.5,
    cy: 106.5,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 238,
    cy: 117.9,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 246.4,
    cy: 96.5,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 254.3,
    cy: 100.8,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 252.1,
    cy: 122.9,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 249.3,
    cy: 110.2,
    r: 7.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 109.527 350.9336)",
    className: "st17",
    cx: 261,
    cy: 111.1,
    rx: 11.7,
    ry: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 221.1,
    cy: 111.3,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 223,
    cy: 120.9,
    r: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 98.0811 359.4806)",
    className: "st17",
    cx: 260.3,
    cy: 122.1,
    rx: 4.3,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M222.7,112.4c6.8,4.8,17,9.4,18.3,18.5c0.3,10.3,1.2,21.9-3.5,31.3c-0.1,0.1,0,0.3,0.2,0.3h13.7 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.4-2.9-13.1-4-20.1l0,0c-1.2-6.1-1.6-10.8,3.6-15.2c2.1-2.1,4.2-4.2,6.2-6.3c2.1-1.5,3.4-2.6,4.4-5.4 c0.4-1,0.4-1.9,0.3-1.6c-1.2,5-6.6,7.4-10.3,10.5c1.6-3.6,2.5-8.7,2.7-12.3c-1.3,4.2-1.5,9.6-4.4,13.2c-1.8,1.2-3.9,2-5,4 c-5-6.5-0.7-15.2-3-22.2c-0.8-2.7,0.5,3.1,0,4.5c0,3.5-1,7.1-1.6,10.6c-4.7-2.3-8.3-4.7-9.3-10.1l0,0c-1.1-1.8-1.3-4.2-2.2-5.8 c0.9,4.2,1.9,8.3,4.2,12.1c-2.5-1-5.6-3.1-7.7-4.1C224.7,113.6,217.4,108.6,222.7,112.4z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 697,
    cy: 147,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 700.9,
    cy: 159.7,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 710.4,
    cy: 135.8,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 719.2,
    cy: 140.6,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 716.7,
    cy: 165.3,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 713.6,
    cy: 151.1,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 726.7,
    cy: 152.2,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 682.1,
    cy: 152.3,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 684.2,
    cy: 163.1,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 725.9,
    cy: 164.5,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M683.8,153.6c7.7,5.3,19,10.5,20.5,20.7c0.3,11.6,1.4,24.6-3.9,35c-0.1,0.1,0,0.3,0.2,0.3h15.3 c0.2,0,0.3-0.2,0.2-0.3c-3.5-7.2-3.2-14.7-4.4-22.5l0,0c-1.4-6.9-1.8-12,4-17.1c2.3-2.3,4.7-4.7,6.9-7.1c2.3-1.7,3.8-2.9,4.9-6 c0.4-1.2,0.5-2.2,0.4-1.8c-1.3,5.5-7.4,8.3-11.6,11.7c1.7-4,2.8-9.8,3.1-13.7c-1.4,4.7-1.7,10.8-4.9,14.7c-2,1.3-4.4,2.2-5.6,4.4 c-5.5-7.2-0.8-17-3.4-24.8c-0.9-3,0.5,3.5,0,5c0,4-1.2,7.9-1.8,11.9c-5.3-2.6-9.2-5.3-10.5-11.3l0,0c-1.2-2-1.4-4.7-2.4-6.5 c1,4.7,2.1,9.3,4.7,13.5c-2.8-1.1-6.3-3.5-8.7-4.6C686.1,154.9,677.9,149.4,683.8,153.6z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 456.3,
    cy: 77.5,
    r: 9.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 458.7,
    cy: 85.3,
    r: 9.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 464.4,
    cy: 70.7,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 469.8,
    cy: 73.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 468.3,
    cy: 88.7,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 466.4,
    cy: 80,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 474.4,
    cy: 80.6,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 447.2,
    cy: 80.7,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 448.5,
    cy: 87.3,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 473.9,
    cy: 88.2,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M448.2,81.5c4.7,3.3,11.6,6.4,12.5,12.6c0.2,7.1,0.8,15-2.4,21.4c0,0.1,0,0.2,0.1,0.2h9.3 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.4-2-9-2.7-13.8l0,0c-0.8-4.2-1.1-7.4,2.4-10.4c1.4-1.4,2.9-2.8,4.2-4.3c1.4-1,2.3-1.8,3-3.7 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.4-4.5,5.1-7.1,7.2c1.1-2.5,1.7-6,1.9-8.4c-0.9,2.9-1,6.6-3,9c-1.2,0.8-2.7,1.4-3.4,2.7 c-3.4-4.4-0.5-10.4-2.1-15.2c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.8-1.1,7.2c-3.2-1.6-5.6-3.2-6.4-6.9l0,0c-0.7-1.2-0.9-2.9-1.5-4 c0.6,2.9,1.3,5.7,2.9,8.2c-1.7-0.7-3.8-2.2-5.3-2.8C449.6,82.3,444.6,78.9,448.2,81.5z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 38.6,
    cy: 174.7,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 41.1,
    cy: 182.9,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 47.1,
    cy: 167.5,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 52.8,
    cy: 170.6,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 51.2,
    cy: 186.5,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 49.2,
    cy: 177.3,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 57.7,
    cy: 178,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 28.9,
    cy: 178.1,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 30.3,
    cy: 185.1,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 57.2,
    cy: 185.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M30,178.9c4.9,3.4,12.2,6.8,13.2,13.3c0.2,7.4,0.9,15.8-2.5,22.5c0,0.1,0,0.2,0.1,0.2h9.8 c0.1,0,0.2-0.1,0.1-0.2c-2.2-4.6-2.1-9.5-2.9-14.5l0,0c-0.9-4.4-1.2-7.8,2.6-11c1.5-1.5,3-3,4.5-4.5c1.5-1.1,2.5-1.9,3.2-3.9 c0.3-0.7,0.3-1.4,0.2-1.1c-0.8,3.6-4.7,5.4-7.4,7.6c1.1-2.6,1.8-6.3,2-8.8c-0.9,3-1.1,6.9-3.2,9.5c-1.3,0.8-2.8,1.4-3.6,2.9 c-3.6-4.7-0.5-10.9-2.2-16c-0.6-1.9,0.3,2.2,0,3.2c0,2.6-0.7,5.1-1.1,7.6c-3.4-1.7-6-3.4-6.7-7.3l0,0c-0.8-1.3-0.9-3-1.6-4.2 c0.7,3,1.4,6,3,8.7c-1.8-0.7-4.1-2.3-5.6-3C31.5,179.8,26.2,176.2,30,178.9z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.3,86.9h-4.2c-0.4,0-0.8-0.3-0.8-0.8V49c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1 C145.1,86.6,144.7,86.9,144.3,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.5,86.9h-4.2c-0.4,0-0.8-0.3-0.8-0.8V49c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1 C119.3,86.6,119,86.9,118.5,86.9z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M358.6,80.1h51.5c2.3-1.5,3.8-4.1,3.8-7c0-4.2-3.1-7.7-7.2-8.4c0-3-2.5-5.5-5.6-5.5c-1,0-1.9,0.3-2.7,0.7 c-2.5-5.9-8.3-10-15-10c-8.3,0-15.1,6.2-16.1,14.1c-0.8-0.2-1.6-0.3-2.5-0.3c-5.2,0-9.4,4.2-9.4,9.4 C355.4,75.9,356.6,78.4,358.6,80.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 712.1,
    y: 48.9,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 741.8,
    cy: 79.8,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 744.1,
    cy: 87.4,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 749.7,
    cy: 73.2,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 755,
    cy: 76,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 753.5,
    cy: 90.7,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 751.7,
    cy: 82.2,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 759.5,
    cy: 82.9,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 732.9,
    cy: 83,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 734.1,
    cy: 89.4,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 759,
    cy: 90.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M733.9,83.7c4.6,3.2,11.3,6.2,12.2,12.3c0.2,6.9,0.8,14.6-2.4,20.8c0,0.1,0,0.2,0.1,0.2h9.1 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.7-2.6-13.4l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.1-4.2c1.4-1,2.3-1.7,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,4.9-6.9,7c1-2.4,1.7-5.8,1.8-8.2c-0.8,2.8-1,6.4-2.9,8.8c-1.2,0.8-2.6,1.3-3.3,2.6 c-3.3-4.3-0.5-10.1-2-14.8c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.7-1.1,7.1c-3.1-1.6-5.5-3.2-6.2-6.7l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.5,2.8,8c-1.7-0.7-3.8-2.1-5.2-2.7C735.3,84.5,730.4,81.2,733.9,83.7z"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M391.6,380.5c0-2-0.1-4-0.3-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M389.9,366.1c-6.5-26.7-30.6-46.5-59.3-46.5c-7.5,0-14.8,1.4-21.4,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M305.2,325.1c-1.8,0.8-3.6,1.8-5.3,2.8"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 639.7,
    cy: 465.6,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 642.8,
    cy: 475.7,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 650.2,
    cy: 456.8,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 657.2,
    cy: 460.6,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 655.2,
    cy: 480.1,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 652.7,
    cy: 468.9,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 663.1,
    cy: 469.7,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 627.9,
    cy: 469.8,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 629.6,
    cy: 478.4,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 662.5,
    cy: 479.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M629.3,470.8c6,4.2,15,8.3,16.2,16.3c0.3,9.1,1.1,19.4-3.1,27.6c-0.1,0.1,0,0.2,0.1,0.2h12 c0.1,0,0.2-0.1,0.1-0.2c-2.7-5.7-2.6-11.6-3.5-17.8l0,0c-1.1-5.4-1.4-9.5,3.1-13.4c1.8-1.8,3.7-3.7,5.5-5.6c1.8-1.3,3-2.3,3.9-4.7 c0.3-0.9,0.4-1.7,0.3-1.4c-1,4.4-5.8,6.5-9.1,9.2c1.4-3.2,2.2-7.7,2.4-10.8c-1.1,3.7-1.3,8.5-3.9,11.6c-1.6,1-3.5,1.8-4.4,3.5 c-4.4-5.7-0.7-13.4-2.7-19.5c-0.7-2.4,0.4,2.7,0,3.9c0,3.1-0.9,6.3-1.4,9.3c-4.1-2.1-7.3-4.2-8.2-8.9l0,0c-1-1.6-1.1-3.7-1.9-5.1 c0.8,3.7,1.7,7.3,3.7,10.6c-2.2-0.9-5-2.8-6.8-3.6C631.1,471.9,624.6,467.5,629.3,470.8z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M418.7,564.4l-53.9,13.1c-1.1,0.3-2.2-0.4-2.4-1.5l-5.7-23.4l57.8-14l5.7,23.4 C420.4,563.1,419.8,564.1,418.7,564.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M414.8,541.1l-26.4,17.3l-30.8-3.4c-0.9,0.2-1.7-0.3-1.9-1.2l-3.8-15.7c-0.2-0.9,0.3-1.7,1.2-1.9l57.2-13.9 c0.9-0.2,1.7,0.3,1.9,1.2l3.8,15.7C416.2,540,415.7,540.9,414.8,541.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M412.2,523.5l3.8,15.6c0.2,0.8-0.2,1.5-0.9,1.8c-0.1,0-0.2,0.1-0.3,0.1l-26.4,17.3l-30.8-3.4 c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.4-1.6-1.2l-3.8-15.7c-0.2-0.9,0.3-1.7,1.2-1.9l57.2-13.9C411.1,522.2,412,522.7,412.2,523.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M389.9,527.3l-2.2,0.5l-0.5-2.1c-0.4-1.4-1.8-2.3-3.3-2l-7,1.7c-1.4,0.4-2.3,1.8-2,3.3l0.5,2.1l-2.2,0.5 l-0.5-2.1c-0.6-2.6,1-5.3,3.6-5.9l7-1.7c2.6-0.6,5.3,1,5.9,3.6L389.9,527.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M392.6,552.6l0.6,2.7l-4.8,3.2l-5.8-0.6l-0.6-2.6c-0.2-0.6,0.2-1.3,0.9-1.4l8.3-2 C391.8,551.5,392.4,551.9,392.6,552.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M392.5,560.1l-7,1.7c-0.7,0.2-1.5-0.3-1.7-1l-1-4.1c-0.2-0.7,0.3-1.5,1-1.7l7-1.7c0.7-0.2,1.5,0.3,1.7,1 l1,4.1C393.7,559.1,393.2,559.9,392.5,560.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M415.1,541l0.4,1.8c-0.1,0-0.2,0.1-0.3,0.1l-26.4,17.3l-30.8-3.4c-0.1,0-0.2,0-0.3,0l-0.4-1.8 c0.1,0,0.2,0,0.3,0l30.8,3.4l26.4-17.3C414.9,541.1,415,541.1,415.1,541z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "392.8,555.5 393.2,557.3 388.8,560.2 383.5,559.6 383.1,557.8 388.4,558.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M357.6,555l25.5,2.8l0.4,1.8l-25.5-2.8c-0.1,0-0.2,0-0.3,0l-0.4-1.8C357.4,555,357.5,555,357.6,555z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M415.1,541l0.4,1.8c-0.1,0-0.2,0.1-0.3,0.1l-22,14.4l-0.4-1.8l22-14.4C414.9,541.1,415,541,415.1,541z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 678.4,
    cy: 453.4,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 682.7,
    cy: 467.7,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 693.3,
    cy: 440.9,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 703.3,
    cy: 446.2,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 700.5,
    cy: 474,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 697,
    cy: 458,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 711.7,
    cy: 459.2,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 661.6,
    cy: 459.4,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 664,
    cy: 471.5,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 710.8,
    cy: 473,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M663.5,460.8c8.6,6,21.4,11.8,23.1,23.2c0.4,13,1.6,27.6-4.4,39.3c-0.1,0.2,0,0.3,0.2,0.3h17.2 c0.2,0,0.3-0.2,0.2-0.3c-3.9-8.1-3.6-16.5-5-25.3l0,0c-1.5-7.7-2-13.5,4.5-19.2c2.6-2.6,5.3-5.2,7.8-7.9c2.6-1.9,4.3-3.3,5.5-6.8 c0.5-1.3,0.5-2.4,0.4-2c-1.5,6.2-8.3,9.3-13,13.2c2-4.5,3.2-11,3.4-15.4c-1.6,5.3-1.9,12.1-5.5,16.5c-2.2,1.5-4.9,2.5-6.3,5 c-6.2-8.1-0.9-19.1-3.8-27.9c-1-3.4,0.6,3.9,0,5.6c0,4.5-1.3,8.9-2,13.3c-5.9-2.9-10.4-5.9-11.7-12.7l0,0c-1.4-2.3-1.6-5.3-2.7-7.3 c1.1,5.3,2.4,10.4,5.3,15.2c-3.1-1.3-7.1-4-9.7-5.2C666.1,462.3,656.9,456,663.5,460.8z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M271.4,334.5l-1.7,1.7l1.7,1.7l0.8-0.7l1,3.6l-1.6,1.6l1.7,1.7l0.7-0.7l1.3,4.7l-5.3,5.2 c-2.3,2.4-1.7,4-1.6,4.5l0,0l0.1,0.1l0.1,0.1l0,0c0.4,0.3,2.1,0.8,4.5-1.5l5.3-5.2l4.7,1.4l-0.7,0.7l1.6,1.7l1.6-1.6l3.7,1.1 l-0.8,0.8l1.6,1.7l1.8-1.7l5.2,1.6l1.5-1.5L288,350l-4-4.1c0.6-0.6,1-1,1-1l6.8-8.1l7.3,1.2l1.2-1.3l-6.2-3.2l2.4-2.3l-0.4-0.4 l-2.4,2.3l-3.2-6.3l-1.2,1.2l0.9,7.2l-8.2,6.7c0,0-0.4,0.4-1.1,1.1l-4-4.1l-5.2-10.8l-1.5,1.5L271.4,334.5z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M692.6,260.9h38.5c1.7-1.1,2.8-3.1,2.8-5.3c0-3.2-2.3-5.8-5.4-6.2c0-2.3-1.9-4.1-4.2-4.1c-0.7,0-1.4,0.2-2,0.5 c-1.8-4.4-6.2-7.5-11.2-7.5c-6.2,0-11.3,4.6-12,10.6c-0.6-0.2-1.2-0.3-1.9-0.3c-3.9,0-7,3.1-7,7 C690.2,257.8,691.2,259.7,692.6,260.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M698.2,384.3h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C700.2,381.6,699.4,383.2,698.2,384.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M536.8,663.2h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C538.8,660.5,538,662.1,536.8,663.2z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 369.4,
    y1: 3082.2,
    x2: 369.4,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M369.4,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C377.4,3109.2,373.9,3103.7,369.4,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3064.4,367.8,3065.3,369.1,3064.8 C369,3064.8,369,3064.8,369.1,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3064.4,370.9,3065.3,369.6,3064.8 L369.6,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.3,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C370.6,3061.4,370.6,3062.6,369.3,3063.1 C369.3,3063.2,369.3,3063.2,369.3,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3066.9,367.8,3067.8,369.1,3067.3 C369,3067.3,369,3067.3,369.1,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3066.9,370.9,3067.8,369.6,3067.3 L369.6,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3069.4,367.8,3070.3,369.1,3069.8 C369,3069.8,369,3069.8,369.1,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3069.4,370.9,3070.3,369.6,3069.8 L369.6,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3071.9,367.8,3072.8,369.1,3072.3 C369,3072.3,369.1,3072.3,369.1,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3071.9,370.9,3072.7,369.6,3072.3 L369.6,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3074.4,367.8,3075.2,369.1,3074.8 C369,3074.8,369.1,3074.8,369.1,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3074.4,370.9,3075.2,369.6,3074.8 L369.6,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3076.9,367.8,3077.7,369.1,3077.2 C369,3077.3,369.1,3077.3,369.1,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3076.9,370.9,3077.7,369.6,3077.2 C369.6,3077.3,369.6,3077.3,369.6,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3079.4,367.8,3080.2,369.1,3079.7 C369,3079.8,369.1,3079.8,369.1,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3079.4,370.9,3080.2,369.6,3079.7 C369.6,3079.8,369.6,3079.8,369.6,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.1,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C366.9,3081.9,367.8,3082.7,369.1,3082.2 C369,3082.3,369.1,3082.3,369.1,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M369.6,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C371.8,3081.9,370.9,3082.7,369.6,3082.2 C369.6,3082.3,369.6,3082.3,369.6,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M369.3,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C370.7,3088.9,370.1,3089.1,369.3,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M363.5,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S363.7,3085.1,363.5,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M369.3,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C370.7,3093.6,370.1,3093.9,369.3,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M363.5,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S363.7,3089.9,363.5,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 382.8,
    y1: 3082.2,
    x2: 382.8,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M382.8,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C390.9,3109.2,387.3,3103.7,382.8,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3064.4,381.2,3065.3,382.5,3064.8 C382.4,3064.8,382.5,3064.8,382.5,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3064.4,384.3,3065.3,383,3064.8 L383,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.7,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C384,3061.4,384,3062.6,382.7,3063.1 C382.8,3063.2,382.7,3063.2,382.7,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3066.9,381.2,3067.8,382.5,3067.3 C382.4,3067.3,382.5,3067.3,382.5,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3066.9,384.3,3067.8,383,3067.3 L383,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3069.4,381.2,3070.3,382.5,3069.8 L382.5,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3069.4,384.3,3070.3,383,3069.8 L383,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3071.9,381.2,3072.8,382.5,3072.3 L382.5,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3071.9,384.3,3072.7,383,3072.3 L383,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3074.4,381.2,3075.2,382.5,3074.8 L382.5,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3074.4,384.3,3075.2,383,3074.8 L383,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3076.9,381.2,3077.7,382.5,3077.2 C382.5,3077.3,382.5,3077.3,382.5,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3076.9,384.3,3077.7,383,3077.2 C383,3077.3,383,3077.3,383,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3079.4,381.2,3080.2,382.5,3079.7 C382.5,3079.8,382.5,3079.8,382.5,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3079.4,384.3,3080.2,383,3079.7 C383,3079.8,383,3079.8,383,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M382.5,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C380.3,3081.9,381.2,3082.7,382.5,3082.2 C382.5,3082.3,382.5,3082.3,382.5,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C385.2,3081.9,384.3,3082.7,383,3082.2 C383,3082.3,383,3082.3,383,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M382.7,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S383.5,3089.1,382.7,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M376.9,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S377.1,3085.1,376.9,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M382.7,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C384.1,3093.6,383.5,3093.9,382.7,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M376.9,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S377.1,3089.9,376.9,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 396.2,
    y1: 3082.2,
    x2: 396.2,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M396.3,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C404.3,3109.2,400.8,3103.7,396.3,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3064.4,394.6,3065.3,395.9,3064.8 L395.9,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3064.4,397.7,3065.3,396.4,3064.8 C396.5,3064.8,396.4,3064.8,396.4,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.1,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C397.4,3061.4,397.4,3062.6,396.1,3063.1 C396.2,3063.2,396.2,3063.2,396.1,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3066.9,394.6,3067.8,395.9,3067.3 L395.9,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3066.9,397.7,3067.8,396.4,3067.3 C396.5,3067.3,396.4,3067.3,396.4,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3069.4,394.6,3070.3,395.9,3069.8 L395.9,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3069.4,397.7,3070.3,396.4,3069.8 C396.5,3069.8,396.4,3069.8,396.4,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3071.9,394.6,3072.8,395.9,3072.3 L395.9,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3071.9,397.7,3072.7,396.4,3072.3 C396.5,3072.3,396.4,3072.3,396.4,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3074.4,394.6,3075.2,395.9,3074.8 L395.9,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3074.4,397.7,3075.2,396.4,3074.8 C396.5,3074.8,396.4,3074.8,396.4,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3076.9,394.6,3077.7,395.9,3077.2 C395.9,3077.3,395.9,3077.3,395.9,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3076.9,397.7,3077.7,396.4,3077.2 C396.5,3077.3,396.4,3077.3,396.4,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3079.4,394.6,3080.2,395.9,3079.7 C395.9,3079.8,395.9,3079.8,395.9,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3079.4,397.7,3080.2,396.4,3079.7 C396.5,3079.8,396.4,3079.8,396.4,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M395.9,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C393.7,3081.9,394.6,3082.7,395.9,3082.2 C395.9,3082.3,395.9,3082.3,395.9,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M396.4,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C398.6,3081.9,397.7,3082.7,396.4,3082.2 C396.5,3082.3,396.4,3082.3,396.4,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M396.2,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C397.5,3088.9,396.9,3089.1,396.2,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M390.3,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S390.6,3085.1,390.3,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M396.2,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C397.5,3093.6,396.9,3093.9,396.2,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M390.3,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S390.6,3089.9,390.3,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 409.6,
    y1: 3082.2,
    x2: 409.6,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M409.7,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C417.7,3109.2,414.2,3103.7,409.7,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3064.4,408,3065.3,409.3,3064.8 L409.3,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3064.4,411.2,3065.3,409.9,3064.8 L409.9,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.6,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C410.9,3061.4,410.8,3062.6,409.6,3063.1 C409.6,3063.2,409.6,3063.2,409.6,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3066.9,408,3067.8,409.3,3067.3 L409.3,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3066.9,411.2,3067.8,409.9,3067.3 L409.9,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3069.4,408,3070.3,409.3,3069.8 L409.3,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3069.4,411.2,3070.3,409.9,3069.8 L409.9,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3071.9,408,3072.8,409.3,3072.3 L409.3,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3071.9,411.2,3072.7,409.9,3072.3 L409.9,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3074.4,408,3075.2,409.3,3074.8 L409.3,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3074.4,411.2,3075.2,409.9,3074.8 L409.9,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3076.9,408,3077.7,409.3,3077.2 C409.3,3077.3,409.3,3077.3,409.3,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3076.9,411.2,3077.7,409.9,3077.2 C409.9,3077.3,409.9,3077.3,409.9,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3079.4,408,3080.2,409.3,3079.7 C409.3,3079.8,409.3,3079.8,409.3,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3079.4,411.2,3080.2,409.9,3079.7 C409.9,3079.8,409.9,3079.8,409.9,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.3,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C407.2,3081.9,408,3082.7,409.3,3082.2 C409.3,3082.3,409.3,3082.3,409.3,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M409.9,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C412,3081.9,411.2,3082.7,409.9,3082.2 C409.9,3082.3,409.9,3082.3,409.9,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M409.6,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S410.3,3089.1,409.6,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M403.7,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C404.3,3085.7,404,3085.1,403.7,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M409.6,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C411,3093.6,410.3,3093.9,409.6,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M403.7,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C404.3,3090.5,404,3089.9,403.7,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 423.1,
    y1: 3082.2,
    x2: 423.1,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M423.1,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C431.1,3109.2,427.6,3103.7,423.1,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3064.4,421.5,3065.3,422.8,3064.8 C422.7,3064.8,422.7,3064.8,422.8,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.4,3064.4,424.6,3065.3,423.3,3064.8 L423.3,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C424.3,3061.4,424.2,3062.6,423,3063.1 C423,3063.2,423,3063.2,423,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3066.9,421.5,3067.8,422.8,3067.3 C422.7,3067.3,422.7,3067.3,422.8,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.4,3066.9,424.6,3067.8,423.3,3067.3 L423.3,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3069.4,421.5,3070.3,422.8,3069.8 C422.7,3069.8,422.7,3069.8,422.8,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.4,3069.4,424.6,3070.3,423.3,3069.8 L423.3,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3071.9,421.5,3072.8,422.8,3072.3 C422.7,3072.3,422.7,3072.3,422.8,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.4,3071.9,424.6,3072.7,423.3,3072.3 L423.3,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3074.4,421.5,3075.2,422.8,3074.8 C422.7,3074.8,422.7,3074.8,422.8,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.5,3074.4,424.6,3075.2,423.3,3074.8 L423.3,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3076.9,421.5,3077.7,422.8,3077.2 C422.7,3077.3,422.7,3077.3,422.8,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.5,3076.9,424.6,3077.7,423.3,3077.2 C423.3,3077.3,423.3,3077.3,423.3,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3079.4,421.5,3080.2,422.8,3079.7 C422.7,3079.8,422.7,3079.8,422.8,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.5,3079.4,424.6,3080.2,423.3,3079.7 C423.3,3079.8,423.3,3079.8,423.3,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M422.8,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C420.6,3081.9,421.5,3082.7,422.8,3082.2 C422.7,3082.3,422.7,3082.3,422.8,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M423.3,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C425.5,3081.9,424.6,3082.7,423.3,3082.2 C423.3,3082.3,423.3,3082.3,423.3,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M423,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S423.8,3089.1,423,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M417.2,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C417.8,3085.7,417.4,3085.1,417.2,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M423,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C424.4,3093.6,423.8,3093.9,423,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M417.2,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C417.8,3090.5,417.4,3089.9,417.2,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 436.5,
    y1: 3082.2,
    x2: 436.5,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M436.5,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C444.6,3109.2,441,3103.7,436.5,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3064.4,434.9,3065.3,436.2,3064.8 C436.1,3064.8,436.2,3064.8,436.2,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3064.4,438,3065.3,436.7,3064.8 L436.7,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.4,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C437.7,3061.4,437.7,3062.6,436.4,3063.1 C436.5,3063.2,436.4,3063.2,436.4,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3066.9,434.9,3067.8,436.2,3067.3 C436.1,3067.3,436.2,3067.3,436.2,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3066.9,438,3067.8,436.7,3067.3 L436.7,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3069.4,434.9,3070.3,436.2,3069.8 C436.1,3069.8,436.2,3069.8,436.2,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3069.4,438,3070.3,436.7,3069.8 L436.7,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3071.9,434.9,3072.8,436.2,3072.3 C436.1,3072.3,436.2,3072.3,436.2,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3071.9,438,3072.7,436.7,3072.3 L436.7,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3074.4,434.9,3075.2,436.2,3074.8 C436.1,3074.8,436.2,3074.8,436.2,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3074.4,438,3075.2,436.7,3074.8 L436.7,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3076.9,434.9,3077.7,436.2,3077.2 C436.1,3077.3,436.2,3077.3,436.2,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3076.9,438,3077.7,436.7,3077.2 C436.7,3077.3,436.7,3077.3,436.7,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3079.4,434.9,3080.2,436.2,3079.7 C436.1,3079.8,436.2,3079.8,436.2,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3079.4,438,3080.2,436.7,3079.7 C436.7,3079.8,436.7,3079.8,436.7,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.2,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C434,3081.9,434.9,3082.7,436.2,3082.2 C436.1,3082.3,436.2,3082.3,436.2,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M436.7,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C438.9,3081.9,438,3082.7,436.7,3082.2 C436.7,3082.3,436.7,3082.3,436.7,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M436.4,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S437.2,3089.1,436.4,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M430.6,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S430.8,3085.1,430.6,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M436.4,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C437.8,3093.6,437.2,3093.9,436.4,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M430.6,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S430.8,3089.9,430.6,3089.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 376.1,
    y1: 3091.1,
    x2: 376.1,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M376.2,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C384.2,3118.1,380.7,3112.5,376.2,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3073.3,374.5,3074.1,375.8,3073.7 L375.8,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3073.3,377.7,3074.1,376.4,3073.7 L376.4,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.1,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C377.3,3070.2,377.3,3071.5,376.1,3072L376.1,3072 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3075.8,374.5,3076.6,375.8,3076.1 C375.8,3076.2,375.8,3076.2,375.8,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3075.8,377.7,3076.6,376.4,3076.1 C376.4,3076.2,376.4,3076.2,376.4,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3078.3,374.5,3079.1,375.8,3078.6 C375.8,3078.7,375.8,3078.7,375.8,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3078.3,377.7,3079.1,376.4,3078.6 C376.4,3078.7,376.4,3078.7,376.4,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3080.8,374.5,3081.6,375.8,3081.1 C375.8,3081.2,375.8,3081.2,375.8,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3080.8,377.7,3081.6,376.4,3081.1 C376.4,3081.2,376.4,3081.2,376.4,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3083.3,374.5,3084.1,375.8,3083.6 C375.8,3083.7,375.8,3083.7,375.8,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3083.3,377.7,3084.1,376.4,3083.6 C376.4,3083.7,376.4,3083.7,376.4,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3085.8,374.5,3086.6,375.8,3086.1 C375.8,3086.2,375.8,3086.2,375.8,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3085.8,377.7,3086.6,376.4,3086.1 C376.4,3086.2,376.4,3086.2,376.4,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3088.3,374.5,3089.1,375.8,3088.6 C375.8,3088.7,375.8,3088.7,375.8,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3088.3,377.7,3089.1,376.4,3088.6 C376.4,3088.7,376.4,3088.7,376.4,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M375.8,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C373.7,3090.8,374.5,3091.6,375.8,3091.1 C375.8,3091.2,375.8,3091.2,375.8,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M376.4,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C378.5,3090.8,377.7,3091.6,376.4,3091.1 C376.4,3091.2,376.4,3091.2,376.4,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M376.1,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S376.8,3098,376.1,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M370.2,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C370.8,3094.6,370.5,3094,370.2,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M376.1,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S376.8,3102.8,376.1,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M370.2,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C370.8,3099.3,370.5,3098.8,370.2,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 389.6,
    y1: 3091.1,
    x2: 389.6,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M389.6,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C397.6,3118.1,394.1,3112.5,389.6,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3073.3,388,3074.1,389.3,3073.7 C389.2,3073.7,389.2,3073.7,389.3,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C391.9,3073.3,391.1,3074.1,389.8,3073.7 L389.8,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.5,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C390.8,3070.2,390.7,3071.5,389.5,3072L389.5,3072 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3075.8,388,3076.6,389.3,3076.1 C389.2,3076.2,389.2,3076.2,389.3,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C391.9,3075.8,391.1,3076.6,389.8,3076.1 C389.8,3076.2,389.8,3076.2,389.8,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3078.3,388,3079.1,389.3,3078.6 C389.2,3078.7,389.2,3078.7,389.3,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C391.9,3078.3,391.1,3079.1,389.8,3078.6 C389.8,3078.7,389.8,3078.7,389.8,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3080.8,388,3081.6,389.3,3081.1 C389.2,3081.2,389.2,3081.2,389.3,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C391.9,3080.8,391.1,3081.6,389.8,3081.1 C389.8,3081.2,389.8,3081.2,389.8,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3083.3,388,3084.1,389.3,3083.6 C389.2,3083.7,389.2,3083.7,389.3,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C391.9,3083.3,391.1,3084.1,389.8,3083.6 C389.8,3083.7,389.8,3083.7,389.8,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3085.8,388,3086.6,389.3,3086.1 C389.2,3086.2,389.2,3086.2,389.3,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C391.9,3085.8,391.1,3086.6,389.8,3086.1 C389.8,3086.2,389.8,3086.2,389.8,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3088.3,388,3089.1,389.3,3088.6 C389.2,3088.7,389.2,3088.7,389.3,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C392,3088.3,391.1,3089.1,389.8,3088.6 C389.8,3088.7,389.8,3088.7,389.8,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.3,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C387.1,3090.8,388,3091.6,389.3,3091.1 C389.2,3091.2,389.2,3091.2,389.3,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M389.8,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C392,3090.8,391.1,3091.6,389.8,3091.1 C389.8,3091.2,389.8,3091.2,389.8,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M389.5,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S390.3,3098,389.5,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M383.7,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C384.3,3094.6,383.9,3094,383.7,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M389.5,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S390.3,3102.8,389.5,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M383.7,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C384.3,3099.3,383.9,3098.8,383.7,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 403,
    y1: 3091.1,
    x2: 403,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M403,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H403h11.1c0.4,0,0.6-0.5,0.2-0.7 C411.1,3118.1,407.5,3112.5,403,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3073.3,401.4,3074.1,402.7,3073.7 C402.6,3073.7,402.7,3073.7,402.7,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3073.3,404.5,3074.1,403.2,3073.7 L403.2,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.9,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C404.2,3070.2,404.2,3071.5,402.9,3072 C403,3072,402.9,3072,402.9,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3075.8,401.4,3076.6,402.7,3076.1 C402.6,3076.2,402.7,3076.2,402.7,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3075.8,404.5,3076.6,403.2,3076.1 C403.2,3076.2,403.2,3076.2,403.2,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3078.3,401.4,3079.1,402.7,3078.6 C402.6,3078.7,402.7,3078.7,402.7,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3078.3,404.5,3079.1,403.2,3078.6 C403.2,3078.7,403.2,3078.7,403.2,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3080.8,401.4,3081.6,402.7,3081.1 C402.6,3081.2,402.7,3081.2,402.7,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3080.8,404.5,3081.6,403.2,3081.1 C403.2,3081.2,403.2,3081.2,403.2,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3083.3,401.4,3084.1,402.7,3083.6 C402.6,3083.7,402.7,3083.7,402.7,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3083.3,404.5,3084.1,403.2,3083.6 C403.2,3083.7,403.2,3083.7,403.2,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3085.8,401.4,3086.6,402.7,3086.1 C402.6,3086.2,402.7,3086.2,402.7,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3085.8,404.5,3086.6,403.2,3086.1 C403.2,3086.2,403.2,3086.2,403.2,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3088.3,401.4,3089.1,402.7,3088.6 C402.6,3088.7,402.7,3088.7,402.7,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3088.3,404.5,3089.1,403.2,3088.6 C403.2,3088.7,403.2,3088.7,403.2,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M402.7,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C400.5,3090.8,401.4,3091.6,402.7,3091.1 C402.6,3091.2,402.7,3091.2,402.7,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M403.2,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C405.4,3090.8,404.5,3091.6,403.2,3091.1 C403.2,3091.2,403.2,3091.2,403.2,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M402.9,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S403.7,3098,402.9,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M397.1,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S397.3,3094,397.1,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M402.9,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S403.7,3102.8,402.9,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M397.1,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C397.7,3099.3,397.3,3098.8,397.1,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 416.4,
    y1: 3091.1,
    x2: 416.4,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M416.5,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C424.5,3118.1,420.9,3112.5,416.5,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3073.3,414.8,3074.1,416.1,3073.7 L416.1,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3073.3,417.9,3074.1,416.6,3073.7 C416.7,3073.7,416.6,3073.7,416.6,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.3,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C417.6,3070.2,417.6,3071.5,416.3,3072 C416.4,3072,416.4,3072,416.3,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3075.8,414.8,3076.6,416.1,3076.1 C416.1,3076.2,416.1,3076.2,416.1,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3075.8,417.9,3076.6,416.6,3076.1 C416.7,3076.2,416.6,3076.2,416.6,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3078.3,414.8,3079.1,416.1,3078.6 C416.1,3078.7,416.1,3078.7,416.1,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3078.3,417.9,3079.1,416.6,3078.6 C416.7,3078.7,416.6,3078.7,416.6,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3080.8,414.8,3081.6,416.1,3081.1 C416.1,3081.2,416.1,3081.2,416.1,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3080.8,417.9,3081.6,416.6,3081.1 C416.7,3081.2,416.6,3081.2,416.6,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3083.3,414.8,3084.1,416.1,3083.6 C416.1,3083.7,416.1,3083.7,416.1,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3083.3,417.9,3084.1,416.6,3083.6 C416.7,3083.7,416.6,3083.7,416.6,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3085.8,414.8,3086.6,416.1,3086.1 C416.1,3086.2,416.1,3086.2,416.1,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3085.8,417.9,3086.6,416.6,3086.1 C416.7,3086.2,416.6,3086.2,416.6,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3088.3,414.8,3089.1,416.1,3088.6 C416.1,3088.7,416.1,3088.7,416.1,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3088.3,417.9,3089.1,416.6,3088.6 C416.7,3088.7,416.6,3088.7,416.6,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.1,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C413.9,3090.8,414.8,3091.6,416.1,3091.1 C416.1,3091.2,416.1,3091.2,416.1,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M416.6,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C418.8,3090.8,417.9,3091.6,416.6,3091.1 C416.7,3091.2,416.6,3091.2,416.6,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M416.4,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C417.7,3097.8,417.1,3098,416.4,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M410.5,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S410.7,3094,410.5,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M416.4,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C417.7,3102.5,417.1,3102.8,416.4,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M410.5,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C411.1,3099.3,410.7,3098.8,410.5,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 429.8,
    y1: 3091.1,
    x2: 429.8,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M429.9,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H441c0.4,0,0.6-0.5,0.2-0.7 C437.9,3118.1,434.4,3112.5,429.9,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3073.3,428.2,3074.1,429.5,3073.7 L429.5,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3073.3,431.3,3074.1,430.1,3073.7 L430.1,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.8,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C431,3070.2,431,3071.5,429.8,3072L429.8,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3075.8,428.2,3076.6,429.5,3076.1 C429.5,3076.2,429.5,3076.2,429.5,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3075.8,431.3,3076.6,430.1,3076.1 C430.1,3076.2,430.1,3076.2,430.1,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3078.3,428.2,3079.1,429.5,3078.6 C429.5,3078.7,429.5,3078.7,429.5,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3078.3,431.3,3079.1,430.1,3078.6 C430.1,3078.7,430.1,3078.7,430.1,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3080.8,428.2,3081.6,429.5,3081.1 C429.5,3081.2,429.5,3081.2,429.5,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3080.8,431.3,3081.6,430.1,3081.1 C430.1,3081.2,430.1,3081.2,430.1,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3083.3,428.2,3084.1,429.5,3083.6 C429.5,3083.7,429.5,3083.7,429.5,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3083.3,431.3,3084.1,430.1,3083.6 C430.1,3083.7,430.1,3083.7,430.1,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3085.8,428.2,3086.6,429.5,3086.1 C429.5,3086.2,429.5,3086.2,429.5,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3085.8,431.3,3086.6,430.1,3086.1 C430.1,3086.2,430.1,3086.2,430.1,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3088.3,428.2,3089.1,429.5,3088.6 C429.5,3088.7,429.5,3088.7,429.5,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3088.3,431.4,3089.1,430.1,3088.6 C430.1,3088.7,430.1,3088.7,430.1,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M429.5,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C427.4,3090.8,428.2,3091.6,429.5,3091.1 C429.5,3091.2,429.5,3091.2,429.5,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M430.1,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C432.2,3090.8,431.4,3091.6,430.1,3091.1 C430.1,3091.2,430.1,3091.2,430.1,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M429.8,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C431.2,3097.8,430.5,3098,429.8,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M423.9,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S424.2,3094,423.9,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M429.8,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C431.2,3102.5,430.5,3102.8,429.8,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M423.9,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C424.5,3099.3,424.2,3098.8,423.9,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 443.2,
    y1: 3091.1,
    x2: 443.2,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M443.3,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C451.3,3118.1,447.8,3112.5,443.3,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M442.9,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3073.3,441.7,3074.1,442.9,3073.7 L442.9,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3073.3,444.8,3074.1,443.5,3073.7 L443.5,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.2,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C444.5,3070.2,444.4,3071.5,443.2,3072L443.2,3072 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M442.9,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3075.8,441.7,3076.6,442.9,3076.1 C442.9,3076.2,442.9,3076.2,442.9,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3075.8,444.8,3076.6,443.5,3076.1 C443.5,3076.2,443.5,3076.2,443.5,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M442.9,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3078.3,441.7,3079.1,442.9,3078.6 C442.9,3078.7,442.9,3078.7,442.9,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3078.3,444.8,3079.1,443.5,3078.6 C443.5,3078.7,443.5,3078.7,443.5,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M442.9,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3080.8,441.7,3081.6,442.9,3081.1 C442.9,3081.2,442.9,3081.2,442.9,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3080.8,444.8,3081.6,443.5,3081.1 C443.5,3081.2,443.5,3081.2,443.5,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M442.9,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3083.3,441.7,3084.1,442.9,3083.6 C442.9,3083.7,442.9,3083.7,442.9,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3083.3,444.8,3084.1,443.5,3083.6 C443.5,3083.7,443.5,3083.7,443.5,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M442.9,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3085.8,441.7,3086.6,442.9,3086.1 C442.9,3086.2,442.9,3086.2,442.9,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3085.8,444.8,3086.6,443.5,3086.1 C443.5,3086.2,443.5,3086.2,443.5,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3088.3,441.7,3089.1,443,3088.6 C442.9,3088.7,442.9,3088.7,443,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3088.3,444.8,3089.1,443.5,3088.6 C443.5,3088.7,443.5,3088.7,443.5,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C440.8,3090.8,441.7,3091.6,443,3091.1 C442.9,3091.2,442.9,3091.2,443,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M443.5,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C445.6,3090.8,444.8,3091.6,443.5,3091.1 C443.5,3091.2,443.5,3091.2,443.5,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M443.2,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S444,3098,443.2,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M437.4,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S437.6,3094,437.4,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M443.2,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S444,3102.8,443.2,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M437.4,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C438,3099.3,437.6,3098.8,437.4,3098.1z"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 290,
    y1: 3082.2,
    x2: 290,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M290.1,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C298.1,3109.2,294.6,3103.7,290.1,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.5,3064.4,288.4,3065.3,289.7,3064.8 L289.7,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3064.4,291.5,3065.3,290.2,3064.8 C290.3,3064.8,290.3,3064.8,290.2,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.9,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C291.2,3061.4,291.2,3062.6,289.9,3063.1 C290,3063.2,290,3063.2,289.9,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.5,3066.9,288.4,3067.8,289.7,3067.3 L289.7,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3066.9,291.5,3067.8,290.2,3067.3 C290.3,3067.3,290.3,3067.3,290.2,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.5,3069.4,288.4,3070.3,289.7,3069.8 L289.7,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3069.4,291.5,3070.3,290.2,3069.8 C290.3,3069.8,290.3,3069.8,290.2,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.5,3071.9,288.4,3072.8,289.7,3072.3 L289.7,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3071.9,291.5,3072.7,290.2,3072.3 C290.3,3072.3,290.3,3072.3,290.2,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.6,3074.4,288.4,3075.2,289.7,3074.8 L289.7,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3074.4,291.5,3075.2,290.2,3074.8 C290.3,3074.8,290.3,3074.8,290.2,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.6,3076.9,288.4,3077.7,289.7,3077.2 C289.7,3077.3,289.7,3077.3,289.7,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3076.9,291.5,3077.7,290.2,3077.2 C290.3,3077.3,290.3,3077.3,290.2,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.6,3079.4,288.4,3080.2,289.7,3079.7 C289.7,3079.8,289.7,3079.8,289.7,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3079.4,291.5,3080.2,290.2,3079.7 C290.3,3079.8,290.3,3079.8,290.2,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M289.7,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C287.6,3081.9,288.4,3082.7,289.7,3082.2 C289.7,3082.3,289.7,3082.3,289.7,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M290.2,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C292.4,3081.9,291.5,3082.7,290.2,3082.2 C290.3,3082.3,290.3,3082.3,290.2,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M290,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S290.7,3089.1,290,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M284.1,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S284.4,3085.1,284.1,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M290,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C291.4,3093.6,290.7,3093.9,290,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M284.1,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S284.4,3089.9,284.1,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 303.4,
    y1: 3082.2,
    x2: 303.4,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M303.5,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C311.5,3109.2,308,3103.7,303.5,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3064.4,301.8,3065.3,303.1,3064.8 L303.1,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3064.4,305,3065.3,303.7,3064.8 L303.7,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.4,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C304.7,3061.4,304.6,3062.6,303.4,3063.1 C303.4,3063.2,303.4,3063.2,303.4,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3066.9,301.8,3067.8,303.1,3067.3 L303.1,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3066.9,305,3067.8,303.7,3067.3 L303.7,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3069.4,301.8,3070.3,303.1,3069.8 L303.1,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3069.4,305,3070.3,303.7,3069.8 L303.7,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3071.9,301.8,3072.8,303.1,3072.3 L303.1,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3071.9,305,3072.7,303.7,3072.3 L303.7,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3074.4,301.8,3075.2,303.1,3074.8 L303.1,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3074.4,305,3075.2,303.7,3074.8 L303.7,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3076.9,301.8,3077.7,303.1,3077.2 C303.1,3077.3,303.1,3077.3,303.1,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3076.9,305,3077.7,303.7,3077.2 C303.7,3077.3,303.7,3077.3,303.7,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3079.4,301.8,3080.2,303.1,3079.7 C303.1,3079.8,303.1,3079.8,303.1,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3079.4,305,3080.2,303.7,3079.7 C303.7,3079.8,303.7,3079.8,303.7,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.1,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C301,3081.9,301.8,3082.7,303.1,3082.2 C303.1,3082.3,303.1,3082.3,303.1,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M303.7,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C305.8,3081.9,305,3082.7,303.7,3082.2 C303.7,3082.3,303.7,3082.3,303.7,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M303.4,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S304.2,3089.1,303.4,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M297.6,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C298.1,3085.7,297.8,3085.1,297.6,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M303.4,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C304.8,3093.6,304.2,3093.9,303.4,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M297.6,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C298.1,3090.5,297.8,3089.9,297.6,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 316.9,
    y1: 3082.2,
    x2: 316.9,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M316.9,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H328c0.4,0,0.6-0.5,0.2-0.7 C324.9,3109.2,321.4,3103.7,316.9,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3064.4,315.3,3065.3,316.6,3064.8 C316.5,3064.8,316.6,3064.8,316.6,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3064.4,318.4,3065.3,317.1,3064.8 L317.1,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.8,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C318.1,3061.4,318.1,3062.6,316.8,3063.1 C316.9,3063.2,316.8,3063.2,316.8,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3066.9,315.3,3067.8,316.6,3067.3 C316.5,3067.3,316.6,3067.3,316.6,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3066.9,318.4,3067.8,317.1,3067.3 L317.1,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3069.4,315.3,3070.3,316.6,3069.8 C316.5,3069.8,316.6,3069.8,316.6,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3069.4,318.4,3070.3,317.1,3069.8 L317.1,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3071.9,315.3,3072.8,316.6,3072.3 C316.5,3072.3,316.6,3072.3,316.6,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3071.9,318.4,3072.7,317.1,3072.3 L317.1,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3074.4,315.3,3075.2,316.6,3074.8 C316.5,3074.8,316.6,3074.8,316.6,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3074.4,318.4,3075.2,317.1,3074.8 L317.1,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3076.9,315.3,3077.7,316.6,3077.2 C316.5,3077.3,316.6,3077.3,316.6,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3076.9,318.4,3077.7,317.1,3077.2 C317.1,3077.3,317.1,3077.3,317.1,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3079.4,315.3,3080.2,316.6,3079.7 C316.5,3079.8,316.6,3079.8,316.6,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3079.4,318.4,3080.2,317.1,3079.7 C317.1,3079.8,317.1,3079.8,317.1,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M316.6,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C314.4,3081.9,315.3,3082.7,316.6,3082.2 C316.5,3082.3,316.6,3082.3,316.6,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.1,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C319.3,3081.9,318.4,3082.7,317.1,3082.2 C317.1,3082.3,317.1,3082.3,317.1,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M316.8,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C318.2,3088.9,317.6,3089.1,316.8,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M311,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S311.2,3085.1,311,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M316.8,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C318.2,3093.6,317.6,3093.9,316.8,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M311,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S311.2,3089.9,311,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 330.3,
    y1: 3082.2,
    x2: 330.3,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M330.3,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C338.4,3109.2,334.8,3103.7,330.3,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3064.4,328.7,3065.3,330,3064.8 L330,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3064.4,331.8,3065.3,330.5,3064.8 L330.5,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.2,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C331.5,3061.4,331.5,3062.6,330.2,3063.1 C330.3,3063.2,330.2,3063.2,330.2,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3066.9,328.7,3067.8,330,3067.3 L330,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3066.9,331.8,3067.8,330.5,3067.3 L330.5,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3069.4,328.7,3070.3,330,3069.8 L330,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3069.4,331.8,3070.3,330.5,3069.8 L330.5,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3071.9,328.7,3072.8,330,3072.3 L330,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3071.9,331.8,3072.7,330.5,3072.3 L330.5,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3074.4,328.7,3075.2,330,3074.8 L330,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3074.4,331.8,3075.2,330.5,3074.8 L330.5,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3076.9,328.7,3077.7,330,3077.2 C330,3077.3,330,3077.3,330,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3076.9,331.8,3077.7,330.5,3077.2 C330.6,3077.3,330.5,3077.3,330.5,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3079.4,328.7,3080.2,330,3079.7 C330,3079.8,330,3079.8,330,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3079.4,331.8,3080.2,330.5,3079.7 C330.6,3079.8,330.5,3079.8,330.5,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C327.8,3081.9,328.7,3082.7,330,3082.2 C330,3082.3,330,3082.3,330,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M330.5,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C332.7,3081.9,331.8,3082.7,330.5,3082.2 C330.6,3082.3,330.5,3082.3,330.5,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M330.3,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C331.6,3088.9,331,3089.1,330.3,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M324.4,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S324.6,3085.1,324.4,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M330.3,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C331.6,3093.6,331,3093.9,330.3,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M324.4,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S324.6,3089.9,324.4,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 343.7,
    y1: 3082.2,
    x2: 343.7,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M343.8,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C351.8,3109.2,348.3,3103.7,343.8,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3064.4,342.1,3065.3,343.4,3064.8 L343.4,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3064.4,345.2,3065.3,343.9,3064.8 C344,3064.8,343.9,3064.8,343.9,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.6,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C344.9,3061.4,344.9,3062.6,343.6,3063.1 C343.7,3063.2,343.7,3063.2,343.6,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3066.9,342.1,3067.8,343.4,3067.3 L343.4,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3066.9,345.2,3067.8,343.9,3067.3 C344,3067.3,343.9,3067.3,343.9,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3069.4,342.1,3070.3,343.4,3069.8 L343.4,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3069.4,345.2,3070.3,343.9,3069.8 C344,3069.8,343.9,3069.8,343.9,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3071.9,342.1,3072.8,343.4,3072.3 L343.4,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3071.9,345.2,3072.7,343.9,3072.3 C344,3072.3,343.9,3072.3,343.9,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3074.4,342.1,3075.2,343.4,3074.8 L343.4,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3074.4,345.2,3075.2,343.9,3074.8 C344,3074.8,344,3074.8,343.9,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3076.9,342.1,3077.7,343.4,3077.2 C343.4,3077.3,343.4,3077.3,343.4,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3076.9,345.2,3077.7,343.9,3077.2 C344,3077.3,344,3077.3,343.9,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3079.4,342.1,3080.2,343.4,3079.7 C343.4,3079.8,343.4,3079.8,343.4,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3079.4,345.2,3080.2,343.9,3079.7 C344,3079.8,344,3079.8,343.9,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.4,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C341.2,3081.9,342.1,3082.7,343.4,3082.2 C343.4,3082.3,343.4,3082.3,343.4,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M343.9,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C346.1,3081.9,345.2,3082.7,343.9,3082.2 C344,3082.3,344,3082.3,343.9,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M343.7,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S344.4,3089.1,343.7,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M337.8,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S338.1,3085.1,337.8,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M343.7,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C345.1,3093.6,344.4,3093.9,343.7,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M337.8,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S338.1,3089.9,337.8,3089.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 357.1,
    y1: 3082.2,
    x2: 357.1,
    y2: 3103.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M357.2,3103.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C365.2,3109.2,361.7,3103.7,357.2,3103.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3064.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3064.4,355.5,3065.3,356.8,3064.8 L356.8,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3064.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3064.4,358.7,3065.3,357.4,3064.8 L357.4,3064.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.1,3063.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C358.4,3061.4,358.3,3062.6,357.1,3063.1 C357.1,3063.2,357.1,3063.2,357.1,3063.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3067.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3066.9,355.5,3067.8,356.8,3067.3 L356.8,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3067.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3066.9,358.7,3067.8,357.4,3067.3 L357.4,3067.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3069.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3069.4,355.5,3070.3,356.8,3069.8 L356.8,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3069.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3069.4,358.7,3070.3,357.4,3069.8 L357.4,3069.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3072.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3071.9,355.5,3072.8,356.8,3072.3 L356.8,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3072.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3071.9,358.7,3072.7,357.4,3072.3 L357.4,3072.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3074.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3074.4,355.5,3075.2,356.8,3074.8 L356.8,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3074.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3074.4,358.7,3075.2,357.4,3074.8 L357.4,3074.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3077.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3076.9,355.5,3077.7,356.8,3077.2 C356.8,3077.3,356.8,3077.3,356.8,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3077.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3076.9,358.7,3077.7,357.4,3077.2 C357.4,3077.3,357.4,3077.3,357.4,3077.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3079.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3079.4,355.5,3080.2,356.8,3079.7 C356.8,3079.8,356.8,3079.8,356.8,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3079.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3079.4,358.7,3080.2,357.4,3079.7 C357.4,3079.8,357.4,3079.8,357.4,3079.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M356.8,3082.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C354.7,3081.9,355.5,3082.7,356.8,3082.2 C356.8,3082.3,356.8,3082.3,356.8,3082.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M357.4,3082.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C359.5,3081.9,358.7,3082.7,357.4,3082.2 C357.4,3082.3,357.4,3082.3,357.4,3082.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M357.1,3089.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S357.9,3089.1,357.1,3089.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M351.3,3084.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C351.8,3085.7,351.5,3085.1,351.3,3084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M357.1,3094c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C358.5,3093.6,357.9,3093.9,357.1,3094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M351.3,3089.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C351.8,3090.5,351.5,3089.9,351.3,3089.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 296.8,
    y1: 3091.1,
    x2: 296.8,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M296.8,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C304.9,3118.1,301.3,3112.5,296.8,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3073.3,295.2,3074.1,296.5,3073.7 L296.5,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3073.3,298.3,3074.1,297,3073.7 L297,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.7,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C298,3070.2,298,3071.5,296.7,3072 C296.8,3072,296.7,3072,296.7,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3075.8,295.2,3076.6,296.5,3076.1 C296.5,3076.2,296.5,3076.2,296.5,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3075.8,298.3,3076.6,297,3076.1 C297,3076.2,297,3076.2,297,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3078.3,295.2,3079.1,296.5,3078.6 C296.5,3078.7,296.5,3078.7,296.5,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3078.3,298.3,3079.1,297,3078.6 C297,3078.7,297,3078.7,297,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3080.8,295.2,3081.6,296.5,3081.1 C296.5,3081.2,296.5,3081.2,296.5,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3080.8,298.3,3081.6,297,3081.1 C297,3081.2,297,3081.2,297,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3083.3,295.2,3084.1,296.5,3083.6 C296.5,3083.7,296.5,3083.7,296.5,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3083.3,298.3,3084.1,297,3083.6 C297,3083.7,297,3083.7,297,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3085.8,295.2,3086.6,296.5,3086.1 C296.5,3086.2,296.5,3086.2,296.5,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3085.8,298.3,3086.6,297,3086.1 C297,3086.2,297,3086.2,297,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3088.3,295.2,3089.1,296.5,3088.6 C296.5,3088.7,296.5,3088.7,296.5,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3088.3,298.3,3089.1,297,3088.6 C297,3088.7,297,3088.7,297,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M296.5,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C294.3,3090.8,295.2,3091.6,296.5,3091.1 C296.5,3091.2,296.5,3091.2,296.5,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M297,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C299.2,3090.8,298.3,3091.6,297,3091.1 C297.1,3091.2,297,3091.2,297,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M296.8,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C298.1,3097.8,297.5,3098,296.8,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M290.9,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S291.1,3094,290.9,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M296.8,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C298.1,3102.5,297.5,3102.8,296.8,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M290.9,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C291.5,3099.3,291.1,3098.8,290.9,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 310.2,
    y1: 3091.1,
    x2: 310.2,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M310.3,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C318.3,3118.1,314.8,3112.5,310.3,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3073.3,308.6,3074.1,309.9,3073.7 L309.9,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3073.3,311.7,3074.1,310.4,3073.7 C310.5,3073.7,310.4,3073.7,310.4,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.1,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C311.4,3070.2,311.4,3071.5,310.1,3072 C310.2,3072,310.2,3072,310.1,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3075.8,308.6,3076.6,309.9,3076.1 C309.9,3076.2,309.9,3076.2,309.9,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3075.8,311.7,3076.6,310.4,3076.1 C310.5,3076.2,310.4,3076.2,310.4,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3078.3,308.6,3079.1,309.9,3078.6 C309.9,3078.7,309.9,3078.7,309.9,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3078.3,311.7,3079.1,310.4,3078.6 C310.5,3078.7,310.4,3078.7,310.4,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3080.8,308.6,3081.6,309.9,3081.1 C309.9,3081.2,309.9,3081.2,309.9,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3080.8,311.7,3081.6,310.4,3081.1 C310.5,3081.2,310.4,3081.2,310.4,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3083.3,308.6,3084.1,309.9,3083.6 C309.9,3083.7,309.9,3083.7,309.9,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3083.3,311.7,3084.1,310.4,3083.6 C310.5,3083.7,310.4,3083.7,310.4,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3085.8,308.6,3086.6,309.9,3086.1 C309.9,3086.2,309.9,3086.2,309.9,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3085.8,311.7,3086.6,310.4,3086.1 C310.5,3086.2,310.4,3086.2,310.4,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3088.3,308.6,3089.1,309.9,3088.6 C309.9,3088.7,309.9,3088.7,309.9,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3088.3,311.7,3089.1,310.4,3088.6 C310.5,3088.7,310.4,3088.7,310.4,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M309.9,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C307.7,3090.8,308.6,3091.6,309.9,3091.1 C309.9,3091.2,309.9,3091.2,309.9,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C312.6,3090.8,311.7,3091.6,310.4,3091.1 C310.5,3091.2,310.5,3091.2,310.4,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M310.2,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S310.9,3098,310.2,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M304.3,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S304.6,3094,304.3,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M310.2,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S310.9,3102.8,310.2,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M304.3,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C304.9,3099.3,304.6,3098.8,304.3,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 323.6,
    y1: 3091.1,
    x2: 323.6,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M323.7,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C331.7,3118.1,328.2,3112.5,323.7,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3073.3,322,3074.1,323.3,3073.7 L323.3,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3073.3,325.2,3074.1,323.9,3073.7 L323.9,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.6,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C324.9,3070.2,324.8,3071.5,323.6,3072L323.6,3072 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3075.8,322,3076.6,323.3,3076.1 C323.3,3076.2,323.3,3076.2,323.3,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3075.8,325.2,3076.6,323.9,3076.1 C323.9,3076.2,323.9,3076.2,323.9,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3078.3,322,3079.1,323.3,3078.6 C323.3,3078.7,323.3,3078.7,323.3,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3078.3,325.2,3079.1,323.9,3078.6 C323.9,3078.7,323.9,3078.7,323.9,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3080.8,322,3081.6,323.3,3081.1 C323.3,3081.2,323.3,3081.2,323.3,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3080.8,325.2,3081.6,323.9,3081.1 C323.9,3081.2,323.9,3081.2,323.9,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3083.3,322,3084.1,323.3,3083.6 C323.3,3083.7,323.3,3083.7,323.3,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3083.3,325.2,3084.1,323.9,3083.6 C323.9,3083.7,323.9,3083.7,323.9,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3085.8,322,3086.6,323.3,3086.1 C323.3,3086.2,323.3,3086.2,323.3,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3085.8,325.2,3086.6,323.9,3086.1 C323.9,3086.2,323.9,3086.2,323.9,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3088.3,322,3089.1,323.3,3088.6 C323.3,3088.7,323.3,3088.7,323.3,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3088.3,325.2,3089.1,323.9,3088.6 C323.9,3088.7,323.9,3088.7,323.9,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.3,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C321.2,3090.8,322,3091.6,323.3,3091.1 C323.3,3091.2,323.3,3091.2,323.3,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M323.9,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C326,3090.8,325.2,3091.6,323.9,3091.1 C323.9,3091.2,323.9,3091.2,323.9,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M323.6,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S324.4,3098,323.6,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M317.8,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C318.3,3094.6,318,3094,317.8,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M323.6,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S324.4,3102.8,323.6,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M317.8,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C318.3,3099.3,318,3098.8,317.8,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 337.1,
    y1: 3091.1,
    x2: 337.1,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M337.1,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C345.1,3118.1,341.6,3112.5,337.1,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3073.3,335.5,3074.1,336.8,3073.7 C336.7,3073.7,336.7,3073.7,336.8,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3073.3,338.6,3074.1,337.3,3073.7 L337.3,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C338.3,3070.2,338.3,3071.5,337,3072L337,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3075.8,335.5,3076.6,336.8,3076.1 C336.7,3076.2,336.7,3076.2,336.8,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3075.8,338.6,3076.6,337.3,3076.1 C337.3,3076.2,337.3,3076.2,337.3,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3078.3,335.5,3079.1,336.8,3078.6 C336.7,3078.7,336.7,3078.7,336.8,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3078.3,338.6,3079.1,337.3,3078.6 C337.3,3078.7,337.3,3078.7,337.3,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3080.8,335.5,3081.6,336.8,3081.1 C336.7,3081.2,336.7,3081.2,336.8,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3080.8,338.6,3081.6,337.3,3081.1 C337.3,3081.2,337.3,3081.2,337.3,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3083.3,335.5,3084.1,336.8,3083.6 C336.7,3083.7,336.7,3083.7,336.8,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3083.3,338.6,3084.1,337.3,3083.6 C337.3,3083.7,337.3,3083.7,337.3,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3085.8,335.5,3086.6,336.8,3086.1 C336.7,3086.2,336.8,3086.2,336.8,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3085.8,338.6,3086.6,337.3,3086.1 C337.3,3086.2,337.3,3086.2,337.3,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3088.3,335.5,3089.1,336.8,3088.6 C336.7,3088.7,336.8,3088.7,336.8,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3088.3,338.6,3089.1,337.3,3088.6 C337.3,3088.7,337.3,3088.7,337.3,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M336.8,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C334.6,3090.8,335.5,3091.6,336.8,3091.1 C336.7,3091.2,336.8,3091.2,336.8,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M337.3,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C339.5,3090.8,338.6,3091.6,337.3,3091.1 C337.3,3091.2,337.3,3091.2,337.3,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M337,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S337.8,3098,337,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M331.2,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C331.8,3094.6,331.4,3094,331.2,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M337,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S337.8,3102.8,337,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M331.2,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C331.8,3099.3,331.4,3098.8,331.2,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 350.5,
    y1: 3091.1,
    x2: 350.5,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M350.5,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C358.6,3118.1,355,3112.5,350.5,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3073.3,348.9,3074.1,350.2,3073.7 C350.1,3073.7,350.2,3073.7,350.2,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3073.3,352,3074.1,350.7,3073.7 L350.7,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.4,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C351.7,3070.2,351.7,3071.5,350.4,3072 C350.5,3072,350.4,3072,350.4,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3075.8,348.9,3076.6,350.2,3076.1 C350.1,3076.2,350.2,3076.2,350.2,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3075.8,352,3076.6,350.7,3076.1 C350.7,3076.2,350.7,3076.2,350.7,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3078.3,348.9,3079.1,350.2,3078.6 C350.1,3078.7,350.2,3078.7,350.2,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3078.3,352,3079.1,350.7,3078.6 C350.7,3078.7,350.7,3078.7,350.7,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3080.8,348.9,3081.6,350.2,3081.1 C350.1,3081.2,350.2,3081.2,350.2,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3080.8,352,3081.6,350.7,3081.1 C350.7,3081.2,350.7,3081.2,350.7,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3083.3,348.9,3084.1,350.2,3083.6 C350.1,3083.7,350.2,3083.7,350.2,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3083.3,352,3084.1,350.7,3083.6 C350.7,3083.7,350.7,3083.7,350.7,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3085.8,348.9,3086.6,350.2,3086.1 C350.2,3086.2,350.2,3086.2,350.2,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3085.8,352,3086.6,350.7,3086.1 C350.7,3086.2,350.7,3086.2,350.7,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3088.3,348.9,3089.1,350.2,3088.6 C350.2,3088.7,350.2,3088.7,350.2,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3088.3,352,3089.1,350.7,3088.6 C350.7,3088.7,350.7,3088.7,350.7,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.2,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C348,3090.8,348.9,3091.6,350.2,3091.1 C350.2,3091.2,350.2,3091.2,350.2,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M350.7,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C352.9,3090.8,352,3091.6,350.7,3091.1 C350.7,3091.2,350.7,3091.2,350.7,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M350.4,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S351.2,3098,350.4,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M344.6,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S344.8,3094,344.6,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M350.4,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S351.2,3102.8,350.4,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M344.6,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C345.2,3099.3,344.8,3098.8,344.6,3098.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 363.9,
    y1: 3091.1,
    x2: 363.9,
    y2: 3112.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M364,3112.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H364h11c0.4,0,0.6-0.5,0.2-0.7 C372,3118.1,368.5,3112.5,364,3112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3073.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3073.3,362.3,3074.1,363.6,3073.7 L363.6,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3073.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3073.3,365.4,3074.1,364.1,3073.7 C364.2,3073.7,364.1,3073.7,364.1,3073.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.8,3072c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C365.1,3070.2,365.1,3071.5,363.8,3072 C363.9,3072,363.9,3072,363.8,3072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3076.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3075.8,362.3,3076.6,363.6,3076.1 C363.6,3076.2,363.6,3076.2,363.6,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3076.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3075.8,365.4,3076.6,364.1,3076.1 C364.2,3076.2,364.1,3076.2,364.1,3076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3078.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3078.3,362.3,3079.1,363.6,3078.6 C363.6,3078.7,363.6,3078.7,363.6,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3078.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3078.3,365.4,3079.1,364.1,3078.6 C364.2,3078.7,364.1,3078.7,364.1,3078.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3081.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3080.8,362.3,3081.6,363.6,3081.1 C363.6,3081.2,363.6,3081.2,363.6,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3081.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3080.8,365.4,3081.6,364.1,3081.1 C364.2,3081.2,364.1,3081.2,364.1,3081.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3083.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3083.3,362.3,3084.1,363.6,3083.6 C363.6,3083.7,363.6,3083.7,363.6,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3083.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3083.3,365.4,3084.1,364.1,3083.6 C364.2,3083.7,364.1,3083.7,364.1,3083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3086.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3085.8,362.3,3086.6,363.6,3086.1 C363.6,3086.2,363.6,3086.2,363.6,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3086.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3085.8,365.4,3086.6,364.1,3086.1 C364.2,3086.2,364.1,3086.2,364.1,3086.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3088.6c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3088.3,362.3,3089.1,363.6,3088.6 C363.6,3088.7,363.6,3088.7,363.6,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3088.6c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3088.3,365.4,3089.1,364.1,3088.6 C364.2,3088.7,364.1,3088.7,364.1,3088.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M363.6,3091.1c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C361.4,3090.8,362.3,3091.6,363.6,3091.1 C363.6,3091.2,363.6,3091.2,363.6,3091.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M364.1,3091.1c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C366.3,3090.8,365.4,3091.6,364.1,3091.1 C364.2,3091.2,364.1,3091.2,364.1,3091.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M363.9,3098.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C365.2,3097.8,364.6,3098,363.9,3098.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M358,3093.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S358.3,3094,358,3093.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M363.9,3102.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C365.2,3102.5,364.6,3102.8,363.9,3102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M358,3098.1c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C358.6,3099.3,358.3,3098.8,358,3098.1z"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 231.5,
    cy: 1284.4,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 234.5,
    cy: 1294.5,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 242,
    cy: 1275.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 248.9,
    cy: 1279.4,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 247,
    cy: 1298.9,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 244.5,
    cy: 1287.7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 254.9,
    cy: 1288.5,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 219.7,
    cy: 1288.6,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 221.3,
    cy: 1297.2,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 254.2,
    cy: 1298.2,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M221,1289.6c6,4.2,15,8.3,16.2,16.3c0.3,9.1,1.1,19.4-3.1,27.6c-0.1,0.1,0,0.2,0.1,0.2h12 c0.1,0,0.2-0.1,0.1-0.2c-2.7-5.7-2.6-11.6-3.5-17.8l0,0c-1.1-5.4-1.4-9.5,3.1-13.4c1.8-1.8,3.7-3.7,5.5-5.6c1.8-1.3,3-2.3,3.9-4.7 c0.3-0.9,0.4-1.7,0.3-1.4c-1,4.4-5.8,6.5-9.1,9.2c1.4-3.2,2.2-7.7,2.4-10.8c-1.1,3.7-1.3,8.5-3.9,11.6c-1.6,1-3.5,1.8-4.4,3.5 c-4.4-5.7-0.7-13.4-2.7-19.5c-0.7-2.4,0.4,2.7,0,3.9c0,3.1-0.9,6.3-1.4,9.3c-4.1-2.1-7.3-4.2-8.2-8.9l0,0c-1-1.6-1.1-3.7-1.9-5.1 c0.8,3.7,1.7,7.3,3.7,10.6c-2.2-0.9-5-2.8-6.8-3.6C222.9,1290.7,216.4,1286.3,221,1289.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 654.2,
    y: 2594.4,
    width: 95.8,
    height: 560
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "st40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2605.3,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.6,
    y: 2605.3,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.2,
    y: 2605.2,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.4,
    y: 2605.3,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.3,
    y: 2605.3,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 703.5,
    y: 2605.2,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.1,
    y: 2605.3,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.2,
    y: 2605.3,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724.2,
    y: 2605.2,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.3,
    y: 2605.3,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.9,
    y: 2605.3,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756,
    y: 2605.3,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.1,
    y: 2605.2,
    className: "st16",
    width: 4.9,
    height: 178.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 654.2,
    y: 2594.4,
    width: 95.8,
    height: 560
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2792.2,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2803.3,
    className: "st5",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2807.9,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2819.1,
    className: "st5",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2824,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2835.2,
    className: "st5",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2839.8,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2855.8,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.5,
    y: 2850.9,
    className: "st5",
    width: 106.7,
    height: 4.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 654.2,
    y: 2594.4,
    width: 95.8,
    height: 560
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 681.1,
    cy: 3081,
    r: 15.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 685.2,
    cy: 3094.4,
    r: 15.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 695.1,
    cy: 3069.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 704.4,
    cy: 3074.3,
    r: 9.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 701.8,
    cy: 3100.3,
    r: 9.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 698.5,
    cy: 3085.3,
    r: 9.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 712.4,
    cy: 3086.4,
    r: 13.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 665.4,
    cy: 3086.6,
    r: 8.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 667.6,
    cy: 3098,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 711.5,
    cy: 3099.4,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M667.2,3087.9c8.1,5.6,20,11,21.6,21.7c0.3,12.2,1.5,25.9-4.2,36.8c-0.1,0.2,0,0.3,0.2,0.3h16.1 c0.2,0,0.3-0.2,0.2-0.3c-3.7-7.6-3.4-15.4-4.7-23.7l0,0c-1.4-7.2-1.9-12.7,4.2-18c2.5-2.4,4.9-4.9,7.3-7.4c2.5-1.8,4-3.1,5.2-6.3 c0.5-1.2,0.5-2.3,0.4-1.9c-1.4,5.8-7.8,8.7-12.2,12.3c1.8-4.3,3-10.3,3.2-14.4c-1.5,5-1.7,11.3-5.2,15.5 c-2.1,1.4-4.6,2.4-5.9,4.7c-5.8-7.6-0.9-17.9-3.5-26.1c-0.9-3.1,0.6,3.7,0,5.3c0,4.2-1.2,8.4-1.9,12.5c-5.5-2.7-9.7-5.6-11-11.9 l0,0c-1.3-2.1-1.5-5-2.5-6.9c1.1,4.9,2.2,9.8,4.9,14.2c-2.9-1.2-6.6-3.7-9.1-4.8C669.6,3089.3,661,3083.5,667.2,3087.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: 654.2,
    y: 2594.4,
    width: 95.8,
    height: 560
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 722.5,
    cy: 3105.1,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 725.6,
    cy: 3115.1,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 733,
    cy: 3096.3,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 740,
    cy: 3100.1,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 738,
    cy: 3119.5,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 735.6,
    cy: 3108.3,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 745.9,
    cy: 3109.1,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 710.7,
    cy: 3109.3,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 712.4,
    cy: 3117.8,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 745.3,
    cy: 3118.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M712.1,3110.3c6,4.2,15,8.3,16.2,16.3c0.3,9.1,1.1,19.4-3.1,27.6c-0.1,0.1,0,0.2,0.1,0.2h12 c0.1,0,0.2-0.1,0.1-0.2c-2.7-5.7-2.6-11.6-3.5-17.8l0,0c-1.1-5.4-1.4-9.5,3.1-13.4c1.8-1.8,3.7-3.7,5.5-5.6 c1.8-1.3,3-2.3,3.9-4.7c0.3-0.9,0.4-1.7,0.3-1.4c-1,4.4-5.8,6.5-9.1,9.2c1.4-3.2,2.2-7.7,2.4-10.8c-1.1,3.7-1.3,8.5-3.9,11.6 c-1.6,1-3.5,1.8-4.4,3.5c-4.4-5.7-0.7-13.4-2.7-19.5c-0.7-2.4,0.4,2.7,0,3.9c0,3.1-0.9,6.3-1.4,9.3c-4.1-2.1-7.3-4.2-8.2-8.9l0,0 c-1-1.6-1.1-3.7-1.9-5.1c0.8,3.7,1.7,7.3,3.7,10.6c-2.2-0.9-5-2.8-6.8-3.6C713.9,3111.3,707.4,3106.9,712.1,3110.3z"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 128.8,
    cy: 3019.3,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 133.1,
    cy: 3033.4,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 143.5,
    cy: 3007,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 153.3,
    cy: 3012.3,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 150.6,
    cy: 3039.6,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 147.1,
    cy: 3023.9,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 161.6,
    cy: 3025.1,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 112.3,
    cy: 3025.2,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 114.6,
    cy: 3037.2,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 160.7,
    cy: 3038.7,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M114.2,3026.6c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3h16.9 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C116.8,3028.1,107.7,3022,114.2,3026.6z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 497.5,
    cy: 2199.6,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 501.8,
    cy: 2213.7,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 512.2,
    cy: 2187.3,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 522,
    cy: 2192.6,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 519.3,
    cy: 2219.9,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 515.8,
    cy: 2204.1,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 530.3,
    cy: 2205.3,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 481,
    cy: 2205.5,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 483.3,
    cy: 2217.5,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 529.4,
    cy: 2219,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M482.9,2206.9c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3h16.9 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C485.5,2208.4,476.4,2202.2,482.9,2206.9z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 678.7,
    cy: 2372.8,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 683,
    cy: 2386.9,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 693.4,
    cy: 2360.5,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 703.2,
    cy: 2365.8,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 700.4,
    cy: 2393.1,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 697,
    cy: 2377.4,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 711.5,
    cy: 2378.6,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 662.2,
    cy: 2378.7,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 664.5,
    cy: 2390.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 710.6,
    cy: 2392.2,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M664.1,2380.1c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3h16.9 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C666.6,2381.6,657.5,2375.4,664.1,2380.1z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M557.6,2334.9v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C558,2335.7,557.6,2335.4,557.6,2334.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M557.6,2309.2v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C558,2309.9,557.6,2309.6,557.6,2309.2z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M460.7,2334.9v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C461,2335.7,460.7,2335.4,460.7,2334.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M460.7,2309.2v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C461,2309.9,460.7,2309.6,460.7,2309.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 692.7,
    y: 1189.5,
    width: 57.3,
    height: 891.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 792.9,
    y: 1603.4,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.9,
    y: 1603.5,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.1,
    y: 1603.5,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 772.2,
    y: 1603.4,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761,
    y: 1603.5,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.1,
    y: 1603.4,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.3,
    y: 1603.4,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740.3,
    y: 1603.5,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 729.2,
    y: 1603.4,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724.3,
    y: 1603.4,
    className: "st16",
    width: 4.9,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713.4,
    y: 1603.5,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1603.4,
    className: "st15",
    width: 11.2,
    height: 178.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.5,
    y: 1603.4,
    className: "st16",
    width: 4.9,
    height: 178.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: 692.7,
    y: 1189.5,
    width: 57.3,
    height: 891.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1477.3,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1488.5,
    className: "st5",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1493.1,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1504.2,
    className: "st5",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1509.1,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1520.4,
    className: "st5",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1524.9,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1541,
    className: "st4",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1536.1,
    className: "st5",
    width: 106.7,
    height: 4.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: 692.7,
    y: 1189.5,
    width: 57.3,
    height: 891.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "st46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1791,
    className: "st13",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1802.1,
    className: "st14",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1806.7,
    className: "st13",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1818,
    className: "st14",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1822.9,
    className: "st13",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1834,
    className: "st14",
    width: 106.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1838.6,
    className: "st13",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1854.6,
    className: "st13",
    width: 106.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.4,
    y: 1849.8,
    className: "st14",
    width: 106.7,
    height: 4.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: 692.7,
    y: 1189.5,
    width: 57.3,
    height: 891.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M732.8,1940.3H760c1.2-0.8,2-2.2,2-3.7c0-2.2-1.6-4.1-3.8-4.4c0-1.6-1.3-2.9-2.9-2.9c-0.5,0-1,0.1-1.4,0.4 c-1.3-3.1-4.4-5.3-7.9-5.3c-4.4,0-7.9,3.2-8.5,7.4c-0.4-0.1-0.9-0.2-1.3-0.2c-2.7,0-4.9,2.2-4.9,4.9 C731.1,1938.1,731.7,1939.4,732.8,1940.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: 692.7,
    y: 1189.5,
    width: 57.3,
    height: 891.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 743.8,
    cy: 1244.9,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 739.5,
    cy: 1259,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 729.1,
    cy: 1232.6,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 719.3,
    cy: 1237.9,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 722.1,
    cy: 1265.1,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 725.5,
    cy: 1249.4,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 711,
    cy: 1250.6,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 760.3,
    cy: 1250.8,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 758,
    cy: 1262.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 711.9,
    cy: 1264.2,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M758.4,1252.2c-8.5,5.9-21,11.6-22.7,22.8c-0.4,12.8-1.5,27.1,4.4,38.7c0.1,0.2,0,0.3-0.2,0.3H723 c-0.2,0-0.3-0.2-0.2-0.3c3.8-8,3.6-16.2,4.9-24.9l0,0c1.5-7.6,2-13.3-4.4-18.9c-2.6-2.6-5.2-5.2-7.6-7.8 c-2.6-1.9-4.2-3.2-5.4-6.7c-0.5-1.3-0.5-2.4-0.4-2c1.4,6.1,8.1,9.2,12.8,12.9c-1.9-4.5-3.1-10.8-3.4-15.2 c1.6,5.2,1.8,11.9,5.4,16.3c2.2,1.5,4.9,2.5,6.2,4.9c6.1-8,0.9-18.8,3.7-27.4c1-3.3-0.6,3.8,0,5.5c0,4.4,1.3,8.8,2,13.1 c5.8-2.9,10.2-5.8,11.5-12.5l0,0c1.3-2.2,1.6-5.2,2.7-7.2c-1.1,5.2-2.3,10.2-5.2,14.9c3.1-1.2,7-3.9,9.6-5.1 C755.9,1253.7,765,1247.5,758.4,1252.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: 692.7,
    y: 1189.5,
    width: 57.3,
    height: 891.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M735.8,1974.7h-37.4c-1.7-1.1-2.7-3-2.7-5.1c0-3.1,2.3-5.6,5.2-6.1c0-2.2,1.8-4,4-4c0.7,0,1.4,0.2,2,0.5 c1.8-4.3,6-7.3,10.9-7.3c6,0,10.9,4.5,11.7,10.2c0.6-0.2,1.2-0.2,1.8-0.2c3.8,0,6.8,3,6.8,6.8 C738.1,1971.6,737.2,1973.4,735.8,1974.7z"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 112.3,
    cy: 1395.4,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 116.5,
    cy: 1409.4,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 127,
    cy: 1383.1,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 136.7,
    cy: 1388.4,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 134,
    cy: 1415.6,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 130.5,
    cy: 1399.9,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 145.1,
    cy: 1401.1,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 95.7,
    cy: 1401.3,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 98.1,
    cy: 1413.2,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 144.1,
    cy: 1414.7,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M97.6,1402.7c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3H133 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C100.2,1404.1,91.1,1398,97.6,1402.7z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 377.7,
    cy: 1142.3,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 382,
    cy: 1156.3,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 392.4,
    cy: 1129.9,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 402.2,
    cy: 1135.2,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 399.5,
    cy: 1162.5,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 396,
    cy: 1146.8,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 410.5,
    cy: 1148,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 361.2,
    cy: 1148.1,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 363.5,
    cy: 1160.1,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 409.6,
    cy: 1161.6,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M363.1,1149.6c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3h16.9 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C365.6,1151,356.6,1144.9,363.1,1149.6z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 176.4,
    cy: 1562.1,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 181.5,
    cy: 1578.9,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 194,
    cy: 1547.4,
    r: 8.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 205.7,
    cy: 1553.7,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 202.4,
    cy: 1586.3,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 198.3,
    cy: 1567.5,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 215.6,
    cy: 1568.9,
    r: 17.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 156.7,
    cy: 1569.1,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 159.5,
    cy: 1583.4,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 214.6,
    cy: 1585.2,
    r: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M158.9,1570.8c10.1,7,25.1,13.8,27.1,27.3c0.4,15.2,1.8,32.4-5.2,46.2c-0.1,0.2,0,0.4,0.2,0.4h20.2 c0.2,0,0.3-0.2,0.3-0.4c-4.6-9.5-4.3-19.4-5.8-29.8l0,0c-1.8-9.1-2.4-15.9,5.3-22.5c3.1-3.1,6.2-6.2,9.1-9.3c3.1-2.2,5-3.9,6.5-8 c0.6-1.5,0.6-2.9,0.5-2.3c-1.7,7.3-9.7,11-15.3,15.5c2.3-5.3,3.7-12.9,4-18.1c-1.9,6.2-2.2,14.2-6.5,19.4c-2.6,1.7-5.8,3-7.4,5.9 c-7.3-9.6-1.1-22.4-4.4-32.8c-1.1-3.9,0.7,4.6,0,6.6c0,5.2-1.5,10.5-2.3,15.6c-6.9-3.4-12.2-7-13.8-14.9l0,0 c-1.6-2.7-1.9-6.2-3.2-8.6c1.3,6.2,2.8,12.2,6.2,17.8c-3.7-1.5-8.3-4.7-11.4-6.1C162,1572.6,151.2,1565.2,158.9,1570.8z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 638.6,
    cy: 2387.2,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 642.9,
    cy: 2401.3,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 653.3,
    cy: 2374.9,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 663.1,
    cy: 2380.2,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 660.3,
    cy: 2407.5,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 656.9,
    cy: 2391.8,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 671.4,
    cy: 2393,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 622.1,
    cy: 2393.1,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 624.4,
    cy: 2405.1,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 670.5,
    cy: 2406.6,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M624,2394.5c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3h16.9 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C626.5,2396,617.5,2389.9,624,2394.5z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 110.5,
    cy: 1564.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 112.8,
    cy: 1572.6,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 118.5,
    cy: 1558.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 123.8,
    cy: 1561.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 122.3,
    cy: 1575.9,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 120.4,
    cy: 1567.4,
    r: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.327800e-02 -0.9994 0.9994 3.327800e-02 -1443.1011 1644.0491)",
    className: "st17",
    cx: 128.3,
    cy: 1568,
    rx: 7.9,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 101.5,
    cy: 1568.1,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 102.8,
    cy: 1574.6,
    r: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.327810e-02 -0.9994 0.9994 3.327810e-02 -1450.9803 1650.7029)",
    className: "st17",
    cx: 127.8,
    cy: 1575.4,
    rx: 2.9,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M102.5,1568.9c4.6,3.2,11.4,6.3,12.3,12.4c0.2,6.9,0.8,14.7-2.4,21c0,0.1,0,0.2,0.1,0.2h9.2 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.8-2.7-13.5l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.2-4.2c1.4-1,2.3-1.8,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,5-6.9,7c1-2.4,1.7-5.9,1.8-8.2c-0.9,2.8-1,6.5-2.9,8.8c-1.2,0.8-2.6,1.3-3.4,2.7 c-3.3-4.3-0.5-10.2-2-14.9c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.8-1.1,7.1c-3.2-1.6-5.5-3.2-6.3-6.8l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.6,2.8,8.1c-1.7-0.7-3.8-2.1-5.2-2.8C103.9,1569.7,99,1566.4,102.5,1568.9z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 386.6,
    cy: 2684.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 388.9,
    cy: 2692.5,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 394.6,
    cy: 2678.1,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 399.9,
    cy: 2681,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 398.4,
    cy: 2695.8,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 396.5,
    cy: 2687.3,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 404.4,
    cy: 2687.9,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 377.6,
    cy: 2688,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 378.9,
    cy: 2694.5,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 403.9,
    cy: 2695.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M378.6,2688.8c4.6,3.2,11.4,6.3,12.3,12.4c0.2,6.9,0.8,14.7-2.4,21c0,0.1,0,0.2,0.1,0.2h9.2 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.8-2.7-13.5l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.2-4.2c1.4-1,2.3-1.8,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,5-6.9,7c1-2.4,1.7-5.9,1.8-8.2c-0.9,2.8-1,6.5-2.9,8.8c-1.2,0.8-2.6,1.3-3.4,2.7 c-3.3-4.3-0.5-10.2-2-14.9c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.8-1.1,7.1c-3.2-1.6-5.5-3.2-6.3-6.8l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.6,2.8,8.1c-1.7-0.7-3.8-2.1-5.2-2.8C380,2689.6,375.1,2686.2,378.6,2688.8z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 273.4,
    cy: 1322.3,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 275.8,
    cy: 1329.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 281.4,
    cy: 1315.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 286.7,
    cy: 1318.5,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 285.2,
    cy: 1333.3,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 283.4,
    cy: 1324.8,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 291.3,
    cy: 1325.4,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 264.5,
    cy: 1325.5,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 265.7,
    cy: 1332,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 290.8,
    cy: 1332.8,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M265.5,1326.3c4.6,3.2,11.4,6.3,12.3,12.4c0.2,6.9,0.8,14.7-2.4,21c0,0.1,0,0.2,0.1,0.2h9.2 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.8-2.7-13.5l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.2-4.2c1.4-1,2.3-1.8,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,5-6.9,7c1-2.4,1.7-5.9,1.8-8.2c-0.9,2.8-1,6.5-2.9,8.8c-1.2,0.8-2.6,1.3-3.4,2.7 c-3.3-4.3-0.5-10.2-2-14.9c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.8-1.1,7.1c-3.2-1.6-5.5-3.2-6.3-6.8l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.6,2.8,8.1c-1.7-0.7-3.8-2.1-5.2-2.8C266.9,1327.1,261.9,1323.7,265.5,1326.3z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 434.8,
    cy: 2636.2,
    rx: 17.1,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 439.2,
    cy: 2650.7,
    rx: 17.1,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 450,
    cy: 2623.5,
    rx: 7.3,
    ry: 7.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 460.1,
    cy: 2629,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 457.3,
    cy: 2657.1,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 453.7,
    cy: 2640.9,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 468.7,
    cy: 2642.1,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 417.8,
    cy: 2642.3,
    rx: 9.1,
    ry: 9.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 420.2,
    cy: 2654.6,
    rx: 6.4,
    ry: 6.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 467.8,
    cy: 2656.2,
    rx: 5.4,
    ry: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M419.7,2643.7c8.7,6.1,21.7,11.9,23.4,23.5c0.4,13.2,1.6,28-4.5,39.8c-0.1,0.2,0,0.4,0.2,0.4h17.4 c0.2,0,0.3-0.2,0.2-0.4c-4-8.2-3.7-16.7-5-25.7l0,0c-1.6-7.8-2-13.7,4.6-19.4c2.7-2.6,5.3-5.3,7.9-8c2.7-1.9,4.3-3.3,5.6-6.9 c0.5-1.3,0.5-2.5,0.4-2c-1.5,6.3-8.4,9.5-13.2,13.3c2-4.6,3.2-11.1,3.5-15.6c-1.6,5.4-1.9,12.3-5.6,16.8c-2.2,1.5-5,2.5-6.4,5.1 c-6.3-8.2-0.9-19.3-3.8-28.3c-1-3.4,0.6,4,0,5.7c0,4.5-1.3,9-2,13.5c-6-3-10.5-6-11.9-12.9l0,0c-1.4-2.3-1.6-5.4-2.8-7.4 c1.2,5.3,2.4,10.5,5.3,15.4c-3.2-1.3-7.2-4-9.9-5.2C422.4,2645.3,413,2638.9,419.7,2643.7z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 304.9,
    cy: 2254.4,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 308.2,
    cy: 2265.3,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 316.2,
    cy: 2244.9,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 323.7,
    cy: 2249,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 321.6,
    cy: 2270,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 319,
    cy: 2257.9,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 330.2,
    cy: 2258.8,
    r: 11.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 292.1,
    cy: 2259,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 293.9,
    cy: 2268.2,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 329.5,
    cy: 2269.3,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M293.6,2260.1c6.5,4.5,16.2,8.9,17.5,17.6c0.3,9.8,1.2,20.9-3.4,29.8c-0.1,0.1,0,0.3,0.2,0.3h13 c0.1,0,0.2-0.1,0.2-0.3c-3-6.1-2.8-12.5-3.8-19.2l0,0c-1.2-5.9-1.5-10.3,3.4-14.5c2-2,4-4,5.9-6c2-1.4,3.2-2.5,4.2-5.1 c0.4-1,0.4-1.9,0.3-1.5c-1.1,4.7-6.3,7.1-9.8,10c1.5-3.4,2.4-8.3,2.6-11.7c-1.2,4-1.4,9.2-4.2,12.6c-1.7,1.1-3.8,1.9-4.8,3.8 c-4.7-6.2-0.7-14.5-2.9-21.1c-0.7-2.5,0.5,3,0,4.3c0,3.4-1,6.8-1.5,10.1c-4.5-2.2-7.9-4.5-8.9-9.6l0,0c-1-1.7-1.2-4-2.1-5.6 c0.9,4,1.8,7.9,4,11.5c-2.4-1-5.4-3-7.4-3.9C295.6,2261.2,288.6,2256.4,293.6,2260.1z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 329.4,
    cy: 2989.5,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 332.7,
    cy: 3000.3,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 340.7,
    cy: 2980,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 348.2,
    cy: 2984.1,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 346.1,
    cy: 3005.1,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 343.5,
    cy: 2993,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 354.7,
    cy: 2993.9,
    r: 11.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 316.6,
    cy: 2994,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 318.4,
    cy: 3003.2,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 354,
    cy: 3004.4,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M318.1,2995.1c6.5,4.5,16.2,8.9,17.5,17.6c0.3,9.8,1.2,20.9-3.4,29.8c-0.1,0.1,0,0.3,0.2,0.3h13 c0.1,0,0.2-0.1,0.2-0.3c-3-6.1-2.8-12.5-3.8-19.2l0,0c-1.2-5.9-1.5-10.3,3.4-14.5c2-2,4-4,5.9-6c2-1.4,3.2-2.5,4.2-5.1 c0.4-1,0.4-1.9,0.3-1.5c-1.1,4.7-6.3,7.1-9.8,10c1.5-3.4,2.4-8.3,2.6-11.7c-1.2,4-1.4,9.2-4.2,12.6c-1.7,1.1-3.8,1.9-4.8,3.8 c-4.7-6.2-0.7-14.5-2.9-21.1c-0.7-2.5,0.5,3,0,4.3c0,3.4-1,6.8-1.5,10.1c-4.5-2.2-7.9-4.5-8.9-9.6l0,0c-1-1.7-1.2-4-2.1-5.6 c0.9,4,1.8,7.9,4,11.5c-2.4-1-5.4-3-7.4-3.9C320.1,2996.2,313,2991.5,318.1,2995.1z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 854.5,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 865.7,
    className: "st14",
    width: 123.9,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 870.3,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 881.5,
    className: "st14",
    width: 123.9,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 822.7,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 833.9,
    className: "st14",
    width: 123.9,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 838.5,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 849.7,
    className: "st14",
    width: 123.9,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 886.4,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 897.6,
    className: "st14",
    width: 123.9,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 902.2,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 918.2,
    className: "st13",
    width: 123.9,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 913.3,
    className: "st14",
    width: 123.9,
    height: 4.9
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 969.3,
    className: "st15",
    width: 208.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 980.4,
    className: "st16",
    width: 208.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 985,
    className: "st15",
    width: 208.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 996.2,
    className: "st16",
    width: 208.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 937.4,
    className: "st15",
    width: 208.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 948.6,
    className: "st16",
    width: 208.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 953.2,
    className: "st15",
    width: 208.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 964.4,
    className: "st16",
    width: 208.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 1001.1,
    className: "st15",
    width: 208.7,
    height: 11.2
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 157.4,
    cy: 3073.7,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 160.4,
    cy: 3083.8,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 167.9,
    cy: 3064.8,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 174.9,
    cy: 3068.6,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 173,
    cy: 3088.2,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 170.5,
    cy: 3076.9,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 180.9,
    cy: 3077.8,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 145.5,
    cy: 3077.9,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 147.1,
    cy: 3086.5,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 180.3,
    cy: 3087.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M146.8,3078.9c6.1,4.2,15.1,8.3,16.3,16.4c0.3,9.2,1.1,19.5-3.1,27.8c-0.1,0.1,0,0.2,0.1,0.2h12.1 c0.1,0,0.2-0.1,0.2-0.2c-2.8-5.7-2.6-11.7-3.5-17.9l0,0c-1.1-5.5-1.4-9.6,3.2-13.6c1.9-1.8,3.7-3.7,5.5-5.6c1.9-1.3,3-2.3,3.9-4.8 c0.3-0.9,0.4-1.7,0.3-1.4c-1,4.4-5.9,6.6-9.2,9.3c1.4-3.2,2.2-7.8,2.4-10.9c-1.1,3.8-1.3,8.6-3.9,11.7c-1.6,1-3.5,1.8-4.5,3.5 c-4.4-5.8-0.7-13.5-2.7-19.7c-0.7-2.4,0.4,2.8,0,4c0,3.2-0.9,6.3-1.4,9.4c-4.2-2.1-7.3-4.2-8.3-9l0,0c-1-1.6-1.1-3.7-1.9-5.2 c0.8,3.7,1.7,7.4,3.7,10.7c-2.2-0.9-5-2.8-6.9-3.7C148.7,3080,142.1,3075.5,146.8,3078.9z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 279.2,
    cy: 2817.2,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 282.2,
    cy: 2827.4,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 289.7,
    cy: 2808.4,
    r: 5.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 296.8,
    cy: 2812.2,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 294.8,
    cy: 2831.8,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 292.3,
    cy: 2820.5,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 302.8,
    cy: 2821.4,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 267.3,
    cy: 2821.5,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 268.9,
    cy: 2830.1,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 302.1,
    cy: 2831.1,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M268.6,2822.5c6.1,4.2,15.1,8.3,16.3,16.4c0.3,9.2,1.1,19.5-3.1,27.8c-0.1,0.1,0,0.2,0.1,0.2H294 c0.1,0,0.2-0.1,0.2-0.2c-2.8-5.7-2.6-11.7-3.5-17.9l0,0c-1.1-5.5-1.4-9.6,3.2-13.6c1.9-1.8,3.7-3.7,5.5-5.6c1.9-1.3,3-2.3,3.9-4.8 c0.3-0.9,0.4-1.7,0.3-1.4c-1,4.4-5.9,6.6-9.2,9.3c1.4-3.2,2.2-7.8,2.4-10.9c-1.1,3.8-1.3,8.6-3.9,11.7c-1.6,1-3.5,1.8-4.5,3.5 c-4.4-5.8-0.7-13.5-2.7-19.7c-0.7-2.4,0.4,2.8,0,4c0,3.2-0.9,6.3-1.4,9.4c-4.2-2.1-7.3-4.2-8.3-9l0,0c-1-1.6-1.1-3.7-1.9-5.2 c0.8,3.7,1.7,7.4,3.7,10.7c-2.2-0.9-5-2.8-6.9-3.7C270.5,2823.5,263.9,2819.1,268.6,2822.5z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "tracteur_00000138567556136943183140000001585191593305905312_",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_155_00000069359916669601882930000007120359821975583639_",
    transform: "translate(40.79 22.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_274_00000098926344302595307060000006452704139338633608_",
    className: "st19",
    d: "M565.4,1411.7v-2.9l0.9-0.2 c0.1-0.5,0.2-0.9,0.3-1.4l-0.7-0.5l1.1-2.7l0.9,0.1c0.2-0.4,0.5-0.8,0.8-1.2l-0.5-0.8l2.1-2.1l0.8,0.5c0.4-0.3,0.8-0.5,1.2-0.8 l-0.1-0.9l2.7-1.1l0.5,0.7c0.5-0.1,1-0.2,1.4-0.3l0.2-0.8h2.9l0.2,0.8c0.5,0.1,0.9,0.2,1.4,0.3l0.5-0.7l2.7,1.1l-0.1,0.8 c0.4,0.2,0.8,0.5,1.2,0.8l0.7-0.4l2.1,2.1l-0.4,0.7c0.3,0.4,0.6,0.8,0.8,1.2l0.8-0.1l1.1,2.7l-0.7,0.5c0.1,0.5,0.2,1,0.3,1.5 l0.8,0.2v2.9l-0.8,0.2c-0.1,0.5-0.2,1-0.3,1.4l0.7,0.5l-1.1,2.7l-0.8-0.1c-0.3,0.4-0.5,0.8-0.8,1.2l0.4,0.7l-2.1,2.1l-0.7-0.4 c-0.4,0.3-0.8,0.6-1.2,0.8l0.1,0.8l-2.7,1.1l-0.5-0.7c-0.5,0.1-1,0.2-1.4,0.3l-0.2,0.8H577l-0.2-0.8c-0.5-0.1-0.9-0.2-1.4-0.3 l-0.5,0.7l-2.7-1.1l0.1-0.9c-0.4-0.2-0.8-0.5-1.2-0.8l-0.8,0.5l-2.1-2.1l0.5-0.8c-0.3-0.4-0.5-0.8-0.8-1.2l-0.9,0.1l-1.1-2.7 l0.7-0.5c-0.1-0.5-0.2-0.9-0.3-1.4L565.4,1411.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8862_00000039830637377746408740000004877284493243931537_",
    className: "st17",
    cx: 578.4,
    cy: 1410.2,
    rx: 5.9,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8863_00000015345965752542752830000003553726363520681877_",
    className: "st29",
    cx: 578.4,
    cy: 1410.2,
    rx: 2.2,
    ry: 2.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_275_00000068669874291876955050000006698100466824025780_",
    className: "st50",
    d: "M569.6,1417l23.5-3.1l10.2-0.5 l19.2,1.8l4.6,4.2v1.3c-6.9-4.3-16-2.3-20.3,4.6c-1.5,2.4-2.3,5.1-2.3,7.9c0,0.4,0,0.8,0.1,1.2h-12.2c-0.7-6.7-6.6-11.6-13.4-11 c-5.8,0.6-10.4,5.2-11,11h-1.7v-13.5C566.3,1418.9,567.7,1417.3,569.6,1417z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_150_00000124850873865310743970000004586339153755095723_",
    className: "st29",
    d: "M596.6,1397.3h25 c0.5,0,0.9,0.4,0.9,0.9l0,0c0,0.5-0.4,0.9-0.9,0.9h-25c-0.5,0-0.9-0.4-0.9-0.9l0,0C595.6,1397.7,596.1,1397.3,596.6,1397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_276_00000126319481263187030370000005299285321637963708_",
    className: "st17",
    d: "M622.5,1415.2l-1.2-16h-24.4l-3.8,14.7 h4.2v9.2h7c0,0,1.8-7.9,8-7.9C617.9,1415.2,622.5,1415.2,622.5,1415.2z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_65_00000043442662017346633190000005079583518079322003_",
    className: "st51",
    x1: 596.9,
    y1: 1414.4,
    x2: 599,
    y2: 1399.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_66_00000136395231024637385130000009642807164778067845_",
    className: "st51",
    x1: 612.3,
    y1: 1415.2,
    x2: 611.4,
    y2: 1399.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M622.5,1415.2L622.5,1415.2c-0.6,0-5,0-10.2,0c-6.2,0-8,7.9-8,7.9h-7v-9.2h-4.2l0,0l-23.5,3.1 c-1.9,0.3-3.3,1.9-3.3,3.7v13.5h1.7c0.6-5.8,5.2-10.4,11-11c6.7-0.7,12.7,4.3,13.4,11h12.2c0-0.4-0.1-0.8-0.1-1.2 c0-2.8,0.8-5.5,2.3-7.9c4.3-6.9,13.4-8.9,20.3-4.6v-1.3L622.5,1415.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_156_00000181805489683699147750000009167378741986646163_",
    transform: "translate(4.138 27.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_277_00000069360205984110881820000010732829159622809989_",
    className: "st19",
    d: "M565.4,1409.1v-2.4l0.7-0.2 c0.1-0.4,0.1-0.7,0.2-1.1l-0.6-0.4l0.9-2.2l0.7,0.1c0.2-0.3,0.4-0.7,0.7-1l-0.4-0.6l1.7-1.7l0.6,0.4c0.3-0.2,0.6-0.4,1-0.6 l-0.1-0.7l2.2-0.9l0.4,0.6c0.4-0.1,0.8-0.2,1.2-0.2l0.2-0.7h2.4l0.2,0.7c0.4,0.1,0.8,0.1,1.1,0.2l0.4-0.6l2.2,0.9l-0.1,0.7 c0.4,0.2,0.7,0.4,1,0.7l0.6-0.4l1.7,1.7l-0.4,0.6c0.2,0.3,0.5,0.6,0.7,1l0.7-0.1l0.9,2.2l-0.5,0.4c0.1,0.4,0.2,0.8,0.2,1.2 l0.7,0.2v2.4l-0.7,0.2c-0.1,0.4-0.1,0.8-0.2,1.2l0.5,0.4l-0.9,2.2l-0.7-0.1c-0.2,0.4-0.4,0.7-0.7,1l0.4,0.6l-1.7,1.7l-0.6-0.4 c-0.3,0.2-0.6,0.5-1,0.7l0.1,0.7l-2.2,0.9l-0.4-0.6c-0.4,0.1-0.8,0.2-1.2,0.2l-0.2,0.7h-2.4l-0.2-0.7c-0.4-0.1-0.8-0.1-1.1-0.2 l-0.4,0.6l-2.2-0.9l0.1-0.7c-0.3-0.2-0.7-0.4-1-0.7l-0.6,0.4l-1.7-1.7l0.4-0.6c-0.2-0.3-0.4-0.6-0.6-0.9l-0.7,0.1l-0.9-2.2 l0.6-0.4c-0.1-0.4-0.2-0.8-0.2-1.2L565.4,1409.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8864_00000078018784628017529300000002368568059743745158_",
    className: "st17",
    cx: 576,
    cy: 1407.9,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8865_00000107557420796351998410000003873975996807546779_",
    className: "st29",
    cx: 576,
    cy: 1407.9,
    rx: 1.8,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151_00000013903035436706816620000008286234440913776825_",
    x: 565.4,
    y: 1426.2,
    className: "st17",
    width: 1.8,
    height: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_278_00000071544744407666541700000016175671674634880930_",
    className: "st17",
    d: "M566.3,1420.2l5.4-0.8 c0,0-0.3,2.9-1.4,3.5c-1.3,0.5-2.6,0.8-4,1.1V1420.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_279_00000030465479868143604490000002889374013584122034_",
    className: "st19",
    d: "M586.1,1414.8l2.7-0.4v-5.2h-2.7 V1414.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_280_00000102542554654793463490000013859782708783473051_",
    className: "st19",
    d: "M586.6,1408.5h1.7l0.5,0.7h-2.7 L586.6,1408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_281_00000032635059700808740320000007756372576305596348_",
    className: "st19",
    d: "M586.7,1408.5h1.4v-2.2 c0-0.4-0.3-0.7-0.7-0.7l0,0h-1.8l0.5,1.4h0.6V1408.5z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M93.6,1323.6h41.6c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6C91,1320.2,92,1322.2,93.6,1323.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M203.4,2297.2H245c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6 C200.8,2293.8,201.8,2295.9,203.4,2297.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M477.1,2881.6h41.6c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4 c-0.8,0-1.6,0.2-2.2,0.6c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6 C474.5,2878.2,475.5,2880.2,477.1,2881.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M62.7,2968.5h41.6c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6 C60.1,2965.1,61.1,2967.1,62.7,2968.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M466.1,999.2h41.6c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6 C463.6,995.8,464.6,997.8,466.1,999.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M172.7,845.9H140c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C174.8,843.2,174,844.8,172.7,845.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M268.5,2321.8h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C270.6,2319.1,269.8,2320.7,268.5,2321.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M460,2893.3h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C462,2890.6,461.2,2892.2,460,2893.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M676.8,2723.1h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C678.8,2720.4,678.1,2722,676.8,2723.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M538.5,2444.9h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C540.5,2442.2,539.7,2443.8,538.5,2444.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M501.8,1836.3h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C503.8,1833.6,503,1835.2,501.8,1836.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M55.2,2998.4H22.5c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C57.2,2995.7,56.4,2997.3,55.2,2998.4z"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 674.6,
    y: 822.7,
    className: "st4",
    width: 11.2,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.7,
    y: 822.7,
    className: "st5",
    width: 4.9,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.7,
    y: 822.7,
    className: "st4",
    width: 11.2,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.7,
    y: 822.7,
    className: "st4",
    width: 11.2,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 822.7,
    className: "st5",
    width: 4.9,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722.8,
    y: 822.7,
    className: "st4",
    width: 11.2,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.9,
    y: 822.7,
    className: "st5",
    width: 4.9,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 822.7,
    className: "st4",
    width: 11.2,
    height: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.9,
    y: 822.7,
    className: "st5",
    width: 4.9,
    height: 106.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    y: 2580.7,
    width: 94,
    height: 167.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 2.7,
    cy: 2607.5,
    r: 11.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -1.234560e-03 1.234560e-03 1 -3.2311 9.031478e-03)",
    className: "st19",
    cx: 5.7,
    cy: 2617.2,
    rx: 11.4,
    ry: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 12.8,
    cy: 2599.1,
    r: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415429e-03 -1 1 2.415429e-03 -2583.2395 2615.9133)",
    className: "st19",
    cx: 19.5,
    cy: 2602.7,
    rx: 6.7,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415429e-03 -1 1 2.415429e-03 -2603.8352 2632.8679)",
    className: "st19",
    cx: 17.7,
    cy: 2621.5,
    rx: 6.7,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 15.3,
    cy: 2610.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 25.3,
    cy: 2611.5,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -8.6,
    cy: 2611.6,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -7,
    cy: 2619.8,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 24.6,
    cy: 2620.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-7.3,2612.6c5.8,4,14.4,8,15.6,15.7c0.3,8.8,1,18.6-3,26.6c-0.1,0.1,0,0.2,0.1,0.2H17 c0.1,0,0.2-0.1,0.1-0.2c-2.6-5.5-2.5-11.1-3.4-17.1l0,0c-1-5.2-1.4-9.1,3-13c1.8-1.8,3.6-3.5,5.3-5.4c1.8-1.3,2.9-2.2,3.7-4.6 c0.3-0.9,0.3-1.6,0.3-1.3c-1,4.2-5.6,6.3-8.8,8.9c1.3-3.1,2.1-7.4,2.3-10.4c-1.1,3.6-1.3,8.2-3.7,11.2c-1.5,1-3.3,1.7-4.3,3.4 c-4.2-5.5-0.6-12.9-2.6-18.8c-0.7-2.3,0.4,2.6,0,3.8c0,3-0.9,6-1.3,9c-4-2-7-4-7.9-8.6l0,0c-0.9-1.5-1.1-3.6-1.8-5 c0.8,3.6,1.6,7,3.6,10.2c-2.1-0.9-4.8-2.7-6.6-3.5C-5.6,2613.6-11.8,2609.3-7.3,2612.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    y: 2580.7,
    width: 94,
    height: 167.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "st53"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 36.9,
    cy: 2651,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 41.1,
    cy: 2665,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 51.6,
    cy: 2638.6,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 61.3,
    cy: 2643.9,
    r: 9.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020251e-02 1.020251e-02 0.9999 -27.2499 0.7369)",
    className: "st17",
    cx: 58.6,
    cy: 2671.2,
    rx: 9.8,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020251e-02 1.020251e-02 0.9999 -27.0899 0.7004)",
    className: "st17",
    cx: 55.1,
    cy: 2655.5,
    rx: 9.8,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 69.7,
    cy: 2656.7,
    r: 14.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415444e-03 -1 1 2.415444e-03 -2636.6411 2670.7822)",
    className: "st17",
    cx: 20.3,
    cy: 2656.9,
    rx: 8.8,
    ry: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 22.7,
    cy: 2668.8,
    r: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020253e-02 1.020253e-02 0.9999 -27.2402 0.8409)",
    className: "st17",
    cx: 68.8,
    cy: 2670.3,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M22.2,2658.3c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3h16.9 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C24.8,2659.7,15.7,2653.6,22.2,2658.3z"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 372.9,
    cy: 2932.1,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 378,
    cy: 2948.9,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 390.4,
    cy: 2917.4,
    r: 8.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 402.1,
    cy: 2923.7,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 398.8,
    cy: 2956.3,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 394.7,
    cy: 2937.5,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 412.1,
    cy: 2938.9,
    r: 17.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 353.1,
    cy: 2939.2,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 355.9,
    cy: 2953.4,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 411,
    cy: 2955.2,
    r: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M355.4,2940.8c10.1,7,25.1,13.8,27.1,27.3c0.4,15.2,1.8,32.4-5.2,46.2c-0.1,0.2,0,0.4,0.2,0.4h20.2 c0.2,0,0.3-0.2,0.3-0.4c-4.6-9.5-4.3-19.3-5.8-29.7l0,0c-1.8-9.1-2.4-15.9,5.3-22.5c3.1-3.1,6.2-6.2,9.1-9.3c3.1-2.2,5-3.9,6.5-7.9 c0.6-1.5,0.6-2.9,0.5-2.3c-1.7,7.3-9.7,11-15.2,15.5c2.3-5.3,3.7-12.9,4-18.1c-1.9,6.2-2.2,14.2-6.5,19.4c-2.6,1.7-5.8,3-7.4,5.9 c-7.3-9.6-1.1-22.4-4.4-32.7c-1.1-3.9,0.7,4.6,0,6.6c0,5.2-1.5,10.5-2.3,15.6c-6.9-3.4-12.2-7-13.8-14.9l0,0 c-1.6-2.7-1.9-6.2-3.2-8.6c1.3,6.2,2.8,12.2,6.2,17.8c-3.7-1.5-8.3-4.7-11.4-6.1C358.5,2942.6,347.6,2935.2,355.4,2940.8z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 206.6,
    y1: 879.3,
    x2: 206.6,
    y2: 900.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M206.6,900.8c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C214.6,906.3,211.1,900.8,206.6,900.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.2,861.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,861.5,205,862.4,206.2,861.9 L206.2,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,861.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,861.5,208.1,862.4,206.8,861.9 L206.8,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.5,860.2c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C207.8,858.5,207.7,859.7,206.5,860.2 C206.5,860.3,206.5,860.3,206.5,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,864.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,864,205,864.9,206.3,864.4 C206.2,864.4,206.2,864.4,206.3,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,864.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,864,208.1,864.9,206.8,864.4 L206.8,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,866.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,866.5,205,867.4,206.3,866.9 C206.2,866.9,206.2,866.9,206.3,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,866.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,866.5,208.1,867.4,206.8,866.9 L206.8,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,869.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,869,205,869.9,206.3,869.4 C206.2,869.4,206.2,869.4,206.3,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,869.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,869,208.1,869.9,206.8,869.4 L206.8,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,871.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,871.5,205,872.3,206.3,871.9 C206.2,871.9,206.2,871.9,206.3,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,871.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,871.5,208.1,872.3,206.8,871.9 L206.8,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,874.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,874,205,874.8,206.3,874.4 C206.2,874.4,206.2,874.4,206.3,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,874.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,874,208.1,874.8,206.8,874.4 L206.8,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,876.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,876.5,205,877.3,206.3,876.8 C206.2,876.9,206.2,876.9,206.3,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,876.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,876.5,208.1,877.3,206.8,876.8 C206.8,876.9,206.8,876.9,206.8,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.3,879.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C204.1,879,205,879.8,206.3,879.3 C206.2,879.4,206.2,879.4,206.3,879.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M206.8,879.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C208.9,879,208.1,879.8,206.8,879.3 C206.8,879.4,206.8,879.4,206.8,879.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M206.5,886.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S207.3,886.2,206.5,886.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M200.7,881.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C201.3,882.8,200.9,882.2,200.7,881.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M206.5,891.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S207.3,891,206.5,891.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M200.7,886.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C201.3,887.6,200.9,887,200.7,886.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 220,
    y1: 879.3,
    x2: 220,
    y2: 900.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M220,900.8c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H220h11.1c0.4,0,0.6-0.5,0.2-0.7 C228.1,906.3,224.5,900.8,220,900.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,861.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,861.5,218.4,862.4,219.7,861.9 C219.6,861.9,219.7,861.9,219.7,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,861.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,861.5,221.5,862.4,220.2,861.9 L220.2,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.9,860.2c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C221.2,858.5,221.2,859.7,219.9,860.2 C220,860.3,219.9,860.3,219.9,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,864.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,864,218.4,864.9,219.7,864.4 C219.6,864.4,219.7,864.4,219.7,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,864.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,864,221.5,864.9,220.2,864.4 L220.2,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,866.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,866.5,218.4,867.4,219.7,866.9 C219.6,866.9,219.7,866.9,219.7,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,866.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,866.5,221.5,867.4,220.2,866.9 L220.2,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,869.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,869,218.4,869.9,219.7,869.4 C219.6,869.4,219.7,869.4,219.7,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,869.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,869,221.5,869.9,220.2,869.4 L220.2,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,871.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,871.5,218.4,872.3,219.7,871.9 C219.6,871.9,219.7,871.9,219.7,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,871.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,871.5,221.5,872.3,220.2,871.9 L220.2,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,874.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,874,218.4,874.8,219.7,874.4 C219.6,874.4,219.7,874.4,219.7,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,874.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,874,221.5,874.8,220.2,874.4 L220.2,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,876.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,876.5,218.4,877.3,219.7,876.8 C219.6,876.9,219.7,876.9,219.7,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,876.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,876.5,221.5,877.3,220.2,876.8 C220.2,876.9,220.2,876.9,220.2,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M219.7,879.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C217.5,879,218.4,879.8,219.7,879.3 C219.6,879.4,219.7,879.4,219.7,879.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M220.2,879.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C222.4,879,221.5,879.8,220.2,879.3 C220.2,879.4,220.2,879.4,220.2,879.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M219.9,886.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C221.3,886,220.7,886.2,219.9,886.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M214.1,881.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S214.3,882.2,214.1,881.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M219.9,891.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C221.3,890.8,220.7,891,219.9,891.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M214.1,886.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S214.3,887,214.1,886.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 233.4,
    y1: 879.3,
    x2: 233.4,
    y2: 900.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M233.5,900.8c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C241.5,906.3,237.9,900.8,233.5,900.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,861.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,861.5,231.8,862.4,233.1,861.9 L233.1,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,861.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,861.5,234.9,862.4,233.6,861.9 C233.7,861.9,233.6,861.9,233.6,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.3,860.2c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C234.6,858.5,234.6,859.7,233.3,860.2 C233.4,860.3,233.4,860.3,233.3,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,864.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,864,231.8,864.9,233.1,864.4 L233.1,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,864.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,864,234.9,864.9,233.6,864.4 C233.7,864.4,233.6,864.4,233.6,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,866.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,866.5,231.8,867.4,233.1,866.9 L233.1,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,866.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,866.5,234.9,867.4,233.6,866.9 C233.7,866.9,233.6,866.9,233.6,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,869.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,869,231.8,869.9,233.1,869.4 L233.1,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,869.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,869,234.9,869.9,233.6,869.4 C233.7,869.4,233.6,869.4,233.6,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,871.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,871.5,231.8,872.3,233.1,871.9 L233.1,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,871.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,871.5,234.9,872.3,233.6,871.9 C233.7,871.9,233.6,871.9,233.6,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,874.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,874,231.8,874.8,233.1,874.4 L233.1,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,874.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,874,234.9,874.8,233.6,874.4 C233.7,874.4,233.6,874.4,233.6,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,876.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,876.5,231.8,877.3,233.1,876.8 C233.1,876.9,233.1,876.9,233.1,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,876.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,876.5,234.9,877.3,233.6,876.8 C233.7,876.9,233.6,876.9,233.6,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.1,879.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C230.9,879,231.8,879.8,233.1,879.3 C233.1,879.4,233.1,879.4,233.1,879.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M233.6,879.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C235.8,879,234.9,879.8,233.6,879.3 C233.7,879.4,233.6,879.4,233.6,879.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M233.4,886.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C234.7,886,234.1,886.2,233.4,886.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M227.5,881.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C228.1,882.8,227.7,882.2,227.5,881.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M233.4,891.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C234.7,890.8,234.1,891,233.4,891.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M227.5,886.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C228.1,887.6,227.7,887,227.5,886.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 246.8,
    y1: 879.3,
    x2: 246.8,
    y2: 900.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M246.9,900.8c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H258c0.4,0,0.6-0.5,0.2-0.7 C254.9,906.3,251.4,900.8,246.9,900.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,861.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,861.5,245.2,862.4,246.5,861.9 L246.5,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247,861.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,861.5,248.3,862.4,247,861.9 C247.1,861.9,247.1,861.9,247,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.7,860.2c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C248,858.5,248,859.7,246.7,860.2 C246.8,860.3,246.8,860.3,246.7,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,864.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,864,245.2,864.9,246.5,864.4 L246.5,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247,864.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,864,248.3,864.9,247,864.4 C247.1,864.4,247.1,864.4,247,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,866.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,866.5,245.2,867.4,246.5,866.9 L246.5,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247,866.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,866.5,248.3,867.4,247,866.9 C247.1,866.9,247.1,866.9,247,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,869.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,869,245.2,869.9,246.5,869.4 L246.5,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247,869.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,869,248.3,869.9,247,869.4 C247.1,869.4,247.1,869.4,247,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,871.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,871.5,245.2,872.3,246.5,871.9 L246.5,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247,871.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,871.5,248.3,872.3,247,871.9 C247.1,871.9,247.1,871.9,247,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,874.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,874,245.2,874.8,246.5,874.4 L246.5,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247.1,874.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,874,248.3,874.8,247.1,874.4 L247.1,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,876.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,876.5,245.2,877.3,246.5,876.8 C246.5,876.9,246.5,876.9,246.5,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247.1,876.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,876.5,248.3,877.3,247.1,876.8 C247.1,876.9,247.1,876.9,247.1,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M246.5,879.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C244.4,879,245.2,879.8,246.5,879.3 C246.5,879.4,246.5,879.4,246.5,879.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M247.1,879.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C249.2,879,248.3,879.8,247.1,879.3 C247.1,879.4,247.1,879.4,247.1,879.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M246.8,886.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S247.5,886.2,246.8,886.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M240.9,881.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C241.5,882.8,241.2,882.2,240.9,881.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M246.8,891.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S247.5,891,246.8,891.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M240.9,886.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C241.5,887.6,241.2,887,240.9,886.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 260.2,
    y1: 879.3,
    x2: 260.2,
    y2: 900.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M260.3,900.8c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C268.3,906.3,264.8,900.8,260.3,900.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,861.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,861.5,258.6,862.4,259.9,861.9 L259.9,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,861.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,861.5,261.8,862.4,260.5,861.9 L260.5,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.2,860.2c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C261.5,858.5,261.4,859.7,260.2,860.2 C260.2,860.3,260.2,860.3,260.2,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,864.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,864,258.6,864.9,259.9,864.4 L259.9,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,864.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,864,261.8,864.9,260.5,864.4 L260.5,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,866.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,866.5,258.6,867.4,259.9,866.9 L259.9,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,866.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,866.5,261.8,867.4,260.5,866.9 L260.5,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,869.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,869,258.6,869.9,259.9,869.4 L259.9,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,869.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,869,261.8,869.9,260.5,869.4 L260.5,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,871.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,871.5,258.7,872.3,259.9,871.9 L259.9,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,871.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,871.5,261.8,872.3,260.5,871.9 L260.5,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,874.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,874,258.7,874.8,259.9,874.4 L259.9,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,874.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,874,261.8,874.8,260.5,874.4 L260.5,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,876.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,876.5,258.7,877.3,259.9,876.8 C259.9,876.9,259.9,876.9,259.9,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,876.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,876.5,261.8,877.3,260.5,876.8 C260.5,876.9,260.5,876.9,260.5,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M259.9,879.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C257.8,879,258.7,879.8,259.9,879.3 C259.9,879.4,259.9,879.4,259.9,879.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M260.5,879.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C262.6,879,261.8,879.8,260.5,879.3 C260.5,879.4,260.5,879.4,260.5,879.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M260.2,886.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S261,886.2,260.2,886.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M254.4,881.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C255,882.8,254.6,882.2,254.4,881.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M260.2,891.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S261,891,260.2,891.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M254.4,886.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C255,887.6,254.6,887,254.4,886.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 273.7,
    y1: 879.3,
    x2: 273.7,
    y2: 900.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.7,900.8c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C281.8,906.3,278.2,900.8,273.7,900.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,861.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,861.5,272.1,862.4,273.4,861.9 C273.3,861.9,273.4,861.9,273.4,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,861.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,861.5,275.2,862.4,273.9,861.9 L273.9,861.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.6,860.2c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C274.9,858.5,274.9,859.7,273.6,860.2 C273.7,860.3,273.6,860.3,273.6,860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,864.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,864,272.1,864.9,273.4,864.4 C273.3,864.4,273.4,864.4,273.4,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,864.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,864,275.2,864.9,273.9,864.4 L273.9,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,866.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,866.5,272.1,867.4,273.4,866.9 C273.3,866.9,273.4,866.9,273.4,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,866.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,866.5,275.2,867.4,273.9,866.9 L273.9,866.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,869.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,869,272.1,869.9,273.4,869.4 C273.3,869.4,273.4,869.4,273.4,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,869.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,869,275.2,869.9,273.9,869.4 L273.9,869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,871.9c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,871.5,272.1,872.3,273.4,871.9 C273.3,871.9,273.4,871.9,273.4,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,871.9c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,871.5,275.2,872.3,273.9,871.9 L273.9,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,874.4c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,874,272.1,874.8,273.4,874.4 C273.3,874.4,273.4,874.4,273.4,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,874.4c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,874,275.2,874.8,273.9,874.4 L273.9,874.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,876.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,876.5,272.1,877.3,273.4,876.8 C273.3,876.9,273.4,876.9,273.4,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,876.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,876.5,275.2,877.3,273.9,876.8 C273.9,876.9,273.9,876.9,273.9,876.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.4,879.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C271.2,879,272.1,879.8,273.4,879.3 C273.3,879.4,273.4,879.4,273.4,879.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M273.9,879.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C276.1,879,275.2,879.8,273.9,879.3 C273.9,879.4,273.9,879.4,273.9,879.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M273.6,886.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S274.4,886.2,273.6,886.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M267.8,881.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S268,882.2,267.8,881.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M273.6,891.1c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S274.4,891,273.6,891.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M267.8,886.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S268,887,267.8,886.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 213.3,
    y1: 888.2,
    x2: 213.3,
    y2: 909.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M213.4,909.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C221.4,915.2,217.9,909.6,213.4,909.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,870.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,870.4,211.7,871.2,213,870.8L213,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,870.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,870.4,214.8,871.2,213.5,870.8 C213.6,870.8,213.6,870.8,213.5,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.2,869.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C214.5,867.3,214.5,868.6,213.2,869.1 C213.3,869.1,213.3,869.1,213.2,869.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,873.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,872.9,211.7,873.7,213,873.2 C213,873.3,213,873.3,213,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,873.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,872.9,214.8,873.7,213.5,873.2 C213.6,873.3,213.6,873.3,213.5,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,875.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,875.4,211.7,876.2,213,875.7 C213,875.8,213,875.8,213,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,875.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,875.4,214.8,876.2,213.5,875.7 C213.6,875.8,213.6,875.8,213.5,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,878.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,877.9,211.7,878.7,213,878.2 C213,878.3,213,878.3,213,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,878.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,877.9,214.8,878.7,213.5,878.2 C213.6,878.3,213.6,878.3,213.5,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,880.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,880.4,211.7,881.2,213,880.7 C213,880.8,213,880.8,213,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,880.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,880.4,214.8,881.2,213.5,880.7 C213.6,880.8,213.6,880.8,213.5,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,883.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,882.9,211.7,883.7,213,883.2 C213,883.3,213,883.3,213,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,883.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,882.9,214.8,883.7,213.5,883.2 C213.6,883.3,213.6,883.3,213.5,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,885.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,885.4,211.7,886.2,213,885.7 C213,885.8,213,885.8,213,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.5,885.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,885.4,214.8,886.2,213.5,885.7 C213.6,885.8,213.6,885.8,213.5,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213,888.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C210.9,887.9,211.7,888.7,213,888.2 C213,888.3,213,888.3,213,888.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.6,888.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C215.7,887.9,214.8,888.7,213.6,888.2 C213.6,888.3,213.6,888.3,213.6,888.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M213.3,895.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S214,895.1,213.3,895.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M207.4,890.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C208,891.7,207.7,891.1,207.4,890.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M213.3,899.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C214.7,899.6,214,899.9,213.3,899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M207.4,895.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C208,896.4,207.7,895.9,207.4,895.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 226.7,
    y1: 888.2,
    x2: 226.7,
    y2: 909.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M226.8,909.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C234.8,915.2,231.3,909.6,226.8,909.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,870.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,870.4,225.1,871.2,226.4,870.8 L226.4,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,870.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,870.4,228.3,871.2,227,870.8L227,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.7,869.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C228,867.3,227.9,868.6,226.7,869.1L226.7,869.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,873.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,872.9,225.1,873.7,226.4,873.2 C226.4,873.3,226.4,873.3,226.4,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,873.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,872.9,228.3,873.7,227,873.2 C227,873.3,227,873.3,227,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,875.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,875.4,225.1,876.2,226.4,875.7 C226.4,875.8,226.4,875.8,226.4,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,875.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,875.4,228.3,876.2,227,875.7 C227,875.8,227,875.8,227,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,878.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,877.9,225.1,878.7,226.4,878.2 C226.4,878.3,226.4,878.3,226.4,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,878.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,877.9,228.3,878.7,227,878.2 C227,878.3,227,878.3,227,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,880.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,880.4,225.1,881.2,226.4,880.7 C226.4,880.8,226.4,880.8,226.4,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,880.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,880.4,228.3,881.2,227,880.7 C227,880.8,227,880.8,227,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,883.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,882.9,225.1,883.7,226.4,883.2 C226.4,883.3,226.4,883.3,226.4,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,883.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,882.9,228.3,883.7,227,883.2 C227,883.3,227,883.3,227,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,885.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,885.4,225.2,886.2,226.4,885.7 C226.4,885.8,226.4,885.8,226.4,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,885.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,885.4,228.3,886.2,227,885.7 C227,885.8,227,885.8,227,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M226.4,888.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C224.3,887.9,225.2,888.7,226.4,888.2 C226.4,888.3,226.4,888.3,226.4,888.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227,888.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C229.1,887.9,228.3,888.7,227,888.2 C227,888.3,227,888.3,227,888.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M226.7,895.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C228.1,894.9,227.5,895.1,226.7,895.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M220.9,890.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C221.5,891.7,221.1,891.1,220.9,890.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M226.7,899.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C228.1,899.6,227.5,899.9,226.7,899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M220.9,895.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C221.5,896.4,221.1,895.9,220.9,895.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 240.2,
    y1: 888.2,
    x2: 240.2,
    y2: 909.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M240.2,909.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C248.3,915.2,244.7,909.6,240.2,909.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,870.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,870.4,238.6,871.2,239.9,870.8 C239.8,870.8,239.9,870.8,239.9,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,870.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,870.4,241.7,871.2,240.4,870.8 L240.4,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.1,869.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C241.4,867.3,241.4,868.6,240.1,869.1 C240.2,869.1,240.1,869.1,240.1,869.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,873.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,872.9,238.6,873.7,239.9,873.2 C239.8,873.3,239.9,873.3,239.9,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,873.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,872.9,241.7,873.7,240.4,873.2 C240.4,873.3,240.4,873.3,240.4,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,875.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,875.4,238.6,876.2,239.9,875.7 C239.8,875.8,239.9,875.8,239.9,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,875.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,875.4,241.7,876.2,240.4,875.7 C240.4,875.8,240.4,875.8,240.4,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,878.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,877.9,238.6,878.7,239.9,878.2 C239.8,878.3,239.9,878.3,239.9,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,878.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,877.9,241.7,878.7,240.4,878.2 C240.4,878.3,240.4,878.3,240.4,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,880.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,880.4,238.6,881.2,239.9,880.7 C239.8,880.8,239.9,880.8,239.9,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,880.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,880.4,241.7,881.2,240.4,880.7 C240.4,880.8,240.4,880.8,240.4,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,883.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,882.9,238.6,883.7,239.9,883.2 C239.8,883.3,239.9,883.3,239.9,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,883.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,882.9,241.7,883.7,240.4,883.2 C240.4,883.3,240.4,883.3,240.4,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,885.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,885.4,238.6,886.2,239.9,885.7 C239.8,885.8,239.9,885.8,239.9,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,885.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,885.4,241.7,886.2,240.4,885.7 C240.4,885.8,240.4,885.8,240.4,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M239.9,888.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C237.7,887.9,238.6,888.7,239.9,888.2 C239.8,888.3,239.9,888.3,239.9,888.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M240.4,888.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C242.6,887.9,241.7,888.7,240.4,888.2 C240.4,888.3,240.4,888.3,240.4,888.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M240.1,895.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S240.9,895.1,240.1,895.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M234.3,890.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S234.5,891.1,234.3,890.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M240.1,899.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C241.5,899.6,240.9,899.9,240.1,899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M234.3,895.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C234.9,896.4,234.5,895.9,234.3,895.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 253.6,
    y1: 888.2,
    x2: 253.6,
    y2: 909.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M253.6,909.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C261.7,915.2,258.1,909.6,253.6,909.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,870.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,870.4,252,871.2,253.3,870.8 L253.3,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,870.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,870.4,255.1,871.2,253.8,870.8 C253.9,870.8,253.8,870.8,253.8,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.5,869.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C254.8,867.3,254.8,868.6,253.5,869.1 C253.6,869.1,253.5,869.1,253.5,869.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,873.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,872.9,252,873.7,253.3,873.2 C253.3,873.3,253.3,873.3,253.3,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,873.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,872.9,255.1,873.7,253.8,873.2 C253.9,873.3,253.8,873.3,253.8,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,875.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,875.4,252,876.2,253.3,875.7 C253.3,875.8,253.3,875.8,253.3,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,875.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,875.4,255.1,876.2,253.8,875.7 C253.9,875.8,253.8,875.8,253.8,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,878.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,877.9,252,878.7,253.3,878.2 C253.3,878.3,253.3,878.3,253.3,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,878.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,877.9,255.1,878.7,253.8,878.2 C253.9,878.3,253.8,878.3,253.8,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,880.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,880.4,252,881.2,253.3,880.7 C253.3,880.8,253.3,880.8,253.3,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,880.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,880.4,255.1,881.2,253.8,880.7 C253.9,880.8,253.8,880.8,253.8,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,883.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,882.9,252,883.7,253.3,883.2 C253.3,883.3,253.3,883.3,253.3,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,883.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,882.9,255.1,883.7,253.8,883.2 C253.9,883.3,253.8,883.3,253.8,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,885.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,885.4,252,886.2,253.3,885.7 C253.3,885.8,253.3,885.8,253.3,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,885.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,885.4,255.1,886.2,253.8,885.7 C253.9,885.8,253.8,885.8,253.8,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,888.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C251.1,887.9,252,888.7,253.3,888.2 C253.3,888.3,253.3,888.3,253.3,888.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.8,888.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C256,887.9,255.1,888.7,253.8,888.2 C253.9,888.3,253.8,888.3,253.8,888.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M253.6,895.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4c0.5-0.4,1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1C254.9,894.9,254.3,895.1,253.6,895.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M247.7,890.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C248.3,891.7,247.9,891.1,247.7,890.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M253.6,899.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4c0.5-0.4,1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1C254.9,899.6,254.3,899.9,253.6,899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M247.7,895.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C248.3,896.4,247.9,895.9,247.7,895.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 267,
    y1: 888.2,
    x2: 267,
    y2: 909.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M267.1,909.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C275.1,915.2,271.6,909.6,267.1,909.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,870.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,870.4,265.4,871.2,266.7,870.8 L266.7,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,870.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,870.4,268.5,871.2,267.2,870.8 C267.3,870.8,267.3,870.8,267.2,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.9,869.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C268.2,867.3,268.2,868.6,266.9,869.1 C267,869.1,267,869.1,266.9,869.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,873.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,872.9,265.4,873.7,266.7,873.2 C266.7,873.3,266.7,873.3,266.7,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,873.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,872.9,268.5,873.7,267.2,873.2 C267.3,873.3,267.3,873.3,267.2,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,875.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,875.4,265.4,876.2,266.7,875.7 C266.7,875.8,266.7,875.8,266.7,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,875.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,875.4,268.5,876.2,267.2,875.7 C267.3,875.8,267.3,875.8,267.2,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,878.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,877.9,265.4,878.7,266.7,878.2 C266.7,878.3,266.7,878.3,266.7,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,878.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,877.9,268.5,878.7,267.2,878.2 C267.3,878.3,267.3,878.3,267.2,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,880.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,880.4,265.4,881.2,266.7,880.7 C266.7,880.8,266.7,880.8,266.7,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,880.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,880.4,268.5,881.2,267.2,880.7 C267.3,880.8,267.3,880.8,267.2,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,883.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,882.9,265.4,883.7,266.7,883.2 C266.7,883.3,266.7,883.3,266.7,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,883.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,882.9,268.5,883.7,267.2,883.2 C267.3,883.3,267.3,883.3,267.2,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,885.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.5,885.4,265.4,886.2,266.7,885.7 C266.7,885.8,266.7,885.8,266.7,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,885.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,885.4,268.5,886.2,267.2,885.7 C267.3,885.8,267.3,885.8,267.2,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M266.7,888.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C264.6,887.9,265.4,888.7,266.7,888.2 C266.7,888.3,266.7,888.3,266.7,888.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M267.2,888.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C269.4,887.9,268.5,888.7,267.2,888.2 C267.3,888.3,267.3,888.3,267.2,888.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M267,895.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S267.7,895.1,267,895.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M261.1,890.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S261.4,891.1,261.1,890.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M267,899.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C268.4,899.6,267.7,899.9,267,899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M261.1,895.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C261.7,896.4,261.4,895.9,261.1,895.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 280.4,
    y1: 888.2,
    x2: 280.4,
    y2: 909.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M280.5,909.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C288.5,915.2,285,909.6,280.5,909.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,870.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,870.4,278.8,871.2,280.1,870.8 L280.1,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,870.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,870.4,282,871.2,280.7,870.8 L280.7,870.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.4,869.1c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C281.7,867.3,281.6,868.6,280.4,869.1 L280.4,869.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,873.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,872.9,278.8,873.7,280.1,873.2 C280.1,873.3,280.1,873.3,280.1,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,873.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,872.9,282,873.7,280.7,873.2 C280.7,873.3,280.7,873.3,280.7,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,875.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,875.4,278.8,876.2,280.1,875.7 C280.1,875.8,280.1,875.8,280.1,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,875.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,875.4,282,876.2,280.7,875.7 C280.7,875.8,280.7,875.8,280.7,875.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,878.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,877.9,278.8,878.7,280.1,878.2 C280.1,878.3,280.1,878.3,280.1,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,878.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,877.9,282,878.7,280.7,878.2 C280.7,878.3,280.7,878.3,280.7,878.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,880.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,880.4,278.8,881.2,280.1,880.7 C280.1,880.8,280.1,880.8,280.1,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,880.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,880.4,282,881.2,280.7,880.7 C280.7,880.8,280.7,880.8,280.7,880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,883.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,882.9,278.8,883.7,280.1,883.2 C280.1,883.3,280.1,883.3,280.1,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,883.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,882.9,282,883.7,280.7,883.2 C280.7,883.3,280.7,883.3,280.7,883.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,885.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,885.4,278.8,886.2,280.1,885.7 C280.1,885.8,280.1,885.8,280.1,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,885.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,885.4,282,886.2,280.7,885.7 C280.7,885.8,280.7,885.8,280.7,885.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.1,888.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C278,887.9,278.8,888.7,280.1,888.2 C280.1,888.3,280.1,888.3,280.1,888.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M280.7,888.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C282.8,887.9,282,888.7,280.7,888.2 C280.7,888.3,280.7,888.3,280.7,888.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M280.4,895.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S281.2,895.1,280.4,895.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M274.6,890.4c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C275.1,891.7,274.8,891.1,274.6,890.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M280.4,899.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C281.8,899.6,281.2,899.9,280.4,899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M274.6,895.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C275.1,896.4,274.8,895.9,274.6,895.2z"
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 321.2,
    y1: 865.1,
    x2: 0,
    y2: 865.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 750,
    y1: 865.1,
    x2: 452.9,
    y2: 865.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 321.2,
    y1: 1370,
    x2: 0,
    y2: 1370
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 750,
    y1: 1370,
    x2: 452.9,
    y2: 1370
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 511.2,
    y1: 2658.9,
    x2: 0,
    y2: 2658.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 750,
    y1: 2658.9,
    x2: 641.7,
    y2: 2658.9
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "325.8,2673.3 330.9,2665.7 340,2665.6 334.3,2658.4 337,2649.7 328.4,2652.9 321,2647.6  321.4,2656.7 314.1,2662.2 322.8,2664.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "329.6,2638.6 330.2,2632.8 335.2,2630 329.9,2627.7 328.8,2622.1 325,2626.4 319.3,2625.7  322.2,2630.6 319.8,2635.9 325.4,2634.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "306.3,2632 305.2,2627.8 308.1,2624.6 303.8,2624.2 301.7,2620.5 300,2624.5 295.8,2625.4  299.1,2628.2 298.6,2632.5 302.3,2630.2  "
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "131.5,2673.3 126.4,2665.7 117.3,2665.6 123,2658.4 120.3,2649.7 128.8,2652.9 136.3,2647.6  135.9,2656.7 143.2,2662.2 134.4,2664.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "127.7,2638.6 127.1,2632.8 122.1,2630 127.4,2627.7 128.5,2622.1 132.3,2626.4 138,2625.7  135.1,2630.6 137.5,2635.9 131.9,2634.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "151,2632 152,2627.8 149.2,2624.6 153.5,2624.2 155.6,2620.5 157.3,2624.5 161.5,2625.4  158.2,2628.2 158.7,2632.5 155,2630.2  "
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "674.8,3049.5 679.8,3041.9 689,3041.7 683.3,3034.6 686,3025.9 677.4,3029 670,3023.8 670.3,3032.9  663.1,3038.4 671.8,3040.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "678.6,3014.7 679.2,3009 684.2,3006.2 678.9,3003.9 677.8,2998.2 674,3002.5 668.3,3001.8  671.2,3006.8 668.8,3012 674.4,3010.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "655.3,3008.2 654.2,3004 657.1,3000.7 652.8,3000.4 650.6,2996.7 649,3000.7 644.8,3001.6  648.1,3004.4 647.6,3008.7 651.3,3006.4  "
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "480.5,3049.5 475.4,3041.9 466.3,3041.7 472,3034.6 469.3,3025.9 477.8,3029 485.3,3023.8  484.9,3032.9 492.2,3038.4 483.4,3040.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "476.7,3014.7 476.1,3009 471.1,3006.2 476.4,3003.9 477.5,2998.2 481.3,3002.5 487,3001.8  484.1,3006.8 486.5,3012 480.9,3010.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "500,3008.2 501,3004 498.1,3000.7 502.5,3000.4 504.6,2996.7 506.3,3000.7 510.5,3001.6  507.2,3004.4 507.6,3008.7 504,3006.4  "
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,1053.9v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C171,1054.7,170.6,1054.3,170.6,1053.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,1028.1v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C171,1028.9,170.6,1028.5,170.6,1028.1z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,1258.9v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C171,1259.7,170.6,1259.3,170.6,1258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,1233.1v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C171,1233.9,170.6,1233.5,170.6,1233.1z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,1519.8v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C171,1520.5,170.6,1520.2,170.6,1519.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,1494v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8h-37.1 C171,1494.7,170.6,1494.4,170.6,1494z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M373.3,1557.2h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8V1558 C372.6,1557.6,372.9,1557.2,373.3,1557.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M399.1,1557.2h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8V1558 C398.3,1557.6,398.7,1557.2,399.1,1557.2z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.1,2226.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C43.3,2226.8,43.7,2226.5,44.1,2226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.9,2226.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C69.1,2226.8,69.4,2226.5,69.9,2226.5z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.6,2226.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C99.8,2226.8,100.2,2226.5,100.6,2226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.4,2226.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C125.6,2226.8,125.9,2226.5,126.4,2226.5z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372,2226.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8H372c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C371.3,2226.8,371.6,2226.5,372,2226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M397.8,2226.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C397,2226.8,397.4,2226.5,397.8,2226.5z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M561.4,2551.9h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C560.7,2552.3,561,2551.9,561.4,2551.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M587.2,2551.9h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C586.4,2552.3,586.8,2551.9,587.2,2551.9z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M561.4,2913.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C560.7,2913.8,561,2913.5,561.4,2913.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M587.2,2913.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C586.4,2913.8,586.8,2913.5,587.2,2913.5z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213,2913.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8H213c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C212.3,2913.8,212.6,2913.5,213,2913.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.8,2913.5h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C238,2913.8,238.4,2913.5,238.8,2913.5z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M651.2,1559h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C650.4,1559.3,650.7,1559,651.2,1559z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M676.9,1559h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1c0,0.4-0.3,0.8-0.8,0.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1 C676.2,1559.3,676.5,1559,676.9,1559z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    y: 724.5,
    width: 39.7,
    height: 127.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    className: "st55"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -12,
    cy: 767.5,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -7.7,
    cy: 781.6,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 2.7,
    cy: 755.2,
    r: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020248e-02 1.020248e-02 0.9999 -7.7583 0.1671)",
    className: "st17",
    cx: 12.5,
    cy: 760.5,
    rx: 9.8,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 9.8,
    cy: 787.7,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 6.3,
    cy: 772,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 20.8,
    cy: 773.2,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -28.5,
    cy: 773.4,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -26.2,
    cy: 785.3,
    r: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.089771e-03 -1 1 9.089771e-03 -767.0483 799.5474)",
    className: "st17",
    cx: 19.9,
    cy: 786.8,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-26.6,774.8c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3H8.8 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C-24.1,776.3-33.1,770.1-26.6,774.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    y: 1912.2,
    width: 41.3,
    height: 99.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -2.463036e-03 2.463036e-03 1 -4.7864 1.550041e-02)",
    className: "st17",
    cx: 3.9,
    cy: 1943.3,
    rx: 12.8,
    ry: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 7.2,
    cy: 1954.2,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 15.2,
    cy: 1933.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 22.7,
    cy: 1937.9,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 20.6,
    cy: 1958.9,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 18,
    cy: 1946.8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 29.2,
    cy: 1947.7,
    r: 11.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -8.9,
    cy: 1947.9,
    r: 6.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -1.222497e-03 1.222497e-03 1 -2.3926 -7.217288e-03)",
    className: "st17",
    cx: -7.1,
    cy: 1957.1,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020246e-02 1.020246e-02 0.9999 -19.977 0.3927)",
    className: "st17",
    cx: 28.5,
    cy: 1958.2,
    rx: 4.1,
    ry: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-7.4,1948.9c6.5,4.5,16.2,8.9,17.5,17.6c0.3,9.8,1.2,20.9-3.4,29.8c-0.1,0.1,0,0.3,0.2,0.3h13 c0.1,0,0.2-0.1,0.2-0.3c-3-6.1-2.8-12.5-3.8-19.2l0,0c-1.2-5.9-1.5-10.3,3.4-14.5c2-2,4-4,5.9-6c2-1.4,3.2-2.5,4.2-5.1 c0.4-1,0.4-1.9,0.3-1.5c-1.1,4.7-6.3,7.1-9.8,10c1.5-3.4,2.4-8.3,2.6-11.7c-1.2,4-1.4,9.2-4.2,12.6c-1.7,1.1-3.8,1.9-4.8,3.8 c-4.7-6.2-0.7-14.5-2.9-21.1c-0.7-2.5,0.5,3,0,4.3c0,3.4-1,6.8-1.5,10.1c-4.5-2.2-7.9-4.5-8.9-9.6l0,0c-1-1.7-1.2-4-2.1-5.6 c0.9,4,1.8,7.9,4,11.5c-2.4-1-5.4-3-7.4-3.9C-5.4,1950.1-12.4,1945.3-7.4,1948.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: -0.5,
    y: 2339.5,
    width: 42.8,
    height: 104.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -11.4,
    cy: 2370.9,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -7.2,
    cy: 2385,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 3.3,
    cy: 2358.6,
    r: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415444e-03 -1 1 2.415444e-03 -2350.9243 2371.1899)",
    className: "st19",
    cx: 13,
    cy: 2363.9,
    rx: 9.8,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 10.3,
    cy: 2391.1,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 6.8,
    cy: 2375.4,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 21.4,
    cy: 2376.6,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -28,
    cy: 2376.8,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: -25.6,
    cy: 2388.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415449e-03 -1 1 2.415449e-03 -2369.7424 2404.9265)",
    className: "st19",
    cx: 20.5,
    cy: 2390.2,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-26.1,2378.2c8.5,5.9,21,11.6,22.7,22.8c0.4,12.8,1.5,27.1-4.4,38.7c-0.1,0.2,0,0.3,0.2,0.3H9.3 c0.2,0,0.3-0.2,0.2-0.3c-3.8-8-3.6-16.2-4.9-24.9l0,0c-1.5-7.6-2-13.3,4.4-18.9c2.6-2.6,5.2-5.2,7.6-7.8c2.6-1.9,4.2-3.2,5.4-6.7 c0.5-1.3,0.5-2.4,0.4-2c-1.4,6.1-8.1,9.2-12.8,12.9c1.9-4.5,3.1-10.8,3.4-15.2c-1.6,5.2-1.8,11.9-5.4,16.3 c-2.2,1.5-4.9,2.5-6.2,4.9c-6.1-8-0.9-18.8-3.7-27.4c-1-3.3,0.6,3.8,0,5.5c0,4.4-1.3,8.8-2,13.1c-5.8-2.9-10.2-5.8-11.5-12.5l0,0 c-1.3-2.2-1.6-5.2-2.7-7.2c1.1,5.2,2.3,10.2,5.2,14.9c-3.1-1.2-7-3.9-9.6-5.1C-23.5,2379.7-32.6,2373.5-26.1,2378.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_57_",
    x: 0.7,
    y: 2743.9,
    width: 193.4,
    height: 125.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    className: "st58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 32.1,
    y1: 2818.3,
    x2: 32.1,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M32.2,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C40.2,2845.3,36.7,2839.7,32.2,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.1,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S32.8,2825.2,32.1,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M26.2,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S26.5,2821.2,26.2,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.1,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S32.8,2830,32.1,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M26.2,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C26.8,2826.5,26.5,2826,26.2,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M32.1,2805.6c1.4,2.4,1.4,5.4,0,7.8C30.8,2811,30.8,2808,32.1,2805.6L32.1,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M29.5,2806c2.1,1.8,3.1,4.6,2.7,7.4C30,2811.6,29,2808.8,29.5,2806L29.5,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M27.1,2807.4c2.6,1,4.5,3.3,5,6C29.5,2812.4,27.6,2810.1,27.1,2807.4L27.1,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M25.4,2809.5c2.8,0,5.4,1.5,6.8,3.9C29.4,2813.4,26.8,2811.9,25.4,2809.5L25.4,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24.4,2812c2.6-0.9,5.6-0.4,7.7,1.4C29.5,2814.3,26.6,2813.8,24.4,2812L24.4,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24.4,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C30,2815.2,27,2815.7,24.4,2814.8L24.4,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M25.4,2817.3c1.4-2.4,4-3.9,6.8-3.9C30.7,2815.8,28.1,2817.3,25.4,2817.3L25.4,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M27.1,2819.4c0.5-2.7,2.4-5,5-6C31.6,2816.1,29.7,2818.4,27.1,2819.4L27.1,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M29.5,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C32.6,2816.1,31.6,2819,29.5,2820.8L29.5,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M32.1,2821.2c-1.4-2.4-1.4-5.4,0-7.8C33.5,2815.8,33.5,2818.8,32.1,2821.2L32.1,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M34.8,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C34.3,2815.2,35.3,2818,34.8,2820.8L34.8,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M37.2,2819.4c-2.6-1-4.5-3.3-5-6C34.7,2814.4,36.7,2816.7,37.2,2819.4L37.2,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.9,2817.3c-2.8,0-5.4-1.5-6.8-3.9C34.9,2813.4,37.5,2814.9,38.9,2817.3L38.9,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M39.9,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C34.8,2812.5,37.7,2813,39.9,2814.8L39.9,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M39.9,2812c-2.1,1.8-5.1,2.3-7.7,1.4C34.3,2811.6,37.2,2811.1,39.9,2812L39.9,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.9,2809.5c-1.4,2.4-4,3.9-6.8,3.9C33.6,2811,36.2,2809.5,38.9,2809.5L38.9,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M37.2,2807.4c-0.5,2.7-2.4,5-5,6C32.7,2810.7,34.6,2808.4,37.2,2807.4L37.2,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M34.8,2806c0.5,2.7-0.6,5.6-2.7,7.4C31.7,2810.7,32.7,2807.8,34.8,2806L34.8,2806z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415407e-03 -1 1 2.415407e-03 -2781.3691 2838.7043)",
    className: "st60",
    cx: 32.1,
    cy: 2813.4,
    rx: 3.9,
    ry: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 45.5,
    y1: 2818.3,
    x2: 45.5,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M45.6,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C53.6,2845.3,50.1,2839.7,45.6,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45.5,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S46.2,2825.2,45.5,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M39.6,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S39.9,2821.2,39.6,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45.5,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S46.2,2830,45.5,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M39.6,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C40.2,2826.5,39.9,2826,39.6,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.5,2805.6c1.4,2.4,1.4,5.4,0,7.8C44.2,2811,44.2,2808,45.5,2805.6L45.5,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M42.9,2806c2.1,1.8,3.1,4.6,2.7,7.4C43.4,2811.6,42.4,2808.8,42.9,2806L42.9,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M40.5,2807.4c2.6,1,4.5,3.3,5,6C42.9,2812.4,41,2810.1,40.5,2807.4L40.5,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.7,2809.5c2.8,0,5.4,1.5,6.8,3.9C42.8,2813.4,40.2,2811.9,38.7,2809.5L38.7,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M37.8,2812c2.6-0.9,5.6-0.4,7.7,1.4C42.9,2814.3,40,2813.8,37.8,2812L37.8,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M37.8,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C43.4,2815.2,40.4,2815.7,37.8,2814.8L37.8,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.7,2817.3c1.4-2.4,4-3.9,6.8-3.9C44.1,2815.8,41.5,2817.3,38.7,2817.3L38.7,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M40.5,2819.4c0.5-2.7,2.4-5,5-6C45,2816.1,43.1,2818.4,40.5,2819.4L40.5,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M42.9,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C46,2816.1,45,2819,42.9,2820.8L42.9,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.5,2821.2c-1.4-2.4-1.4-5.4,0-7.8C46.9,2815.8,46.9,2818.8,45.5,2821.2L45.5,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M48.2,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C47.6,2815.2,48.7,2818,48.2,2820.8L48.2,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50.6,2819.4c-2.6-1-4.5-3.3-5-6C48.1,2814.4,50.1,2816.7,50.6,2819.4L50.6,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.3,2817.3c-2.8,0-5.4-1.5-6.8-3.9C48.3,2813.4,50.9,2814.9,52.3,2817.3L52.3,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M53.3,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C48.2,2812.5,51.1,2813,53.3,2814.8L53.3,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M53.3,2812c-2.1,1.8-5.1,2.3-7.7,1.4C47.7,2811.6,50.6,2811.1,53.3,2812L53.3,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.3,2809.5c-1.4,2.4-4,3.9-6.8,3.9C46.9,2811,49.5,2809.5,52.3,2809.5L52.3,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50.6,2807.4c-0.5,2.7-2.4,5-5,6C46,2810.7,48,2808.4,50.6,2807.4L50.6,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M48.2,2806c0.5,2.7-0.6,5.6-2.7,7.4C45.1,2810.7,46.1,2807.8,48.2,2806L48.2,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 45.5,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 58.9,
    y1: 2818.3,
    x2: 58.9,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M59,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H59h11c0.4,0,0.6-0.5,0.2-0.7 C67,2845.3,63.4,2839.7,59,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M58.9,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C60.2,2825,59.6,2825.2,58.9,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M53,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C53.6,2821.8,53.2,2821.2,53,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M58.9,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C60.2,2829.7,59.6,2830,58.9,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M53,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C53.6,2826.5,53.2,2826,53,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.9,2805.6c1.4,2.4,1.4,5.4,0,7.8C57.6,2811,57.6,2808,58.9,2805.6L58.9,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M56.2,2806c2.1,1.8,3.1,4.6,2.7,7.4C56.8,2811.6,55.8,2808.8,56.2,2806L56.2,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M53.9,2807.4c2.6,1,4.5,3.3,5,6C56.3,2812.4,54.4,2810.1,53.9,2807.4L53.9,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.1,2809.5c2.8,0,5.4,1.5,6.8,3.9C56.1,2813.4,53.5,2811.9,52.1,2809.5L52.1,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M51.2,2812c2.6-0.9,5.6-0.4,7.7,1.4C56.3,2814.3,53.3,2813.8,51.2,2812L51.2,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M51.2,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C56.8,2815.2,53.8,2815.7,51.2,2814.8L51.2,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.1,2817.3c1.4-2.4,4-3.9,6.8-3.9C57.5,2815.8,54.9,2817.3,52.1,2817.3L52.1,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M53.9,2819.4c0.5-2.7,2.4-5,5-6C58.4,2816.1,56.5,2818.4,53.9,2819.4L53.9,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M56.2,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C59.4,2816.1,58.3,2819,56.2,2820.8L56.2,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.9,2821.2c-1.4-2.4-1.4-5.4,0-7.8C60.3,2815.8,60.3,2818.8,58.9,2821.2L58.9,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M61.6,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C61,2815.2,62.1,2818,61.6,2820.8L61.6,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64,2819.4c-2.6-1-4.5-3.3-5-6C61.5,2814.4,63.4,2816.7,64,2819.4L64,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.7,2817.3c-2.8,0-5.4-1.5-6.8-3.9C61.7,2813.4,64.3,2814.9,65.7,2817.3L65.7,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M66.6,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C61.5,2812.5,64.5,2813,66.6,2814.8L66.6,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M66.6,2812c-2.1,1.8-5.1,2.3-7.7,1.4C61.1,2811.6,64,2811.1,66.6,2812L66.6,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.7,2809.5c-1.4,2.4-4,3.9-6.8,3.9C60.3,2811,62.9,2809.5,65.7,2809.5L65.7,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64,2807.4c-0.5,2.7-2.4,5-5,6C59.4,2810.7,61.4,2808.4,64,2807.4L64,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M61.6,2806c0.5,2.7-0.6,5.6-2.7,7.4C58.5,2810.7,59.5,2807.8,61.6,2806L61.6,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 58.9,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 72.3,
    y1: 2818.3,
    x2: 72.3,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M72.3,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C80.4,2845.3,76.8,2839.7,72.3,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M72.3,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C73.6,2825,73,2825.2,72.3,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M66.4,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S66.6,2821.2,66.4,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M72.3,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C73.6,2829.7,73,2830,72.3,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M66.4,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C67,2826.5,66.6,2826,66.4,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.3,2805.6c1.4,2.4,1.4,5.4,0,7.8C70.9,2811,70.9,2808,72.3,2805.6L72.3,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M69.6,2806c2.1,1.8,3.1,4.6,2.7,7.4C70.2,2811.6,69.2,2808.8,69.6,2806L69.6,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M67.3,2807.4c2.6,1,4.5,3.3,5,6C69.7,2812.4,67.8,2810.1,67.3,2807.4L67.3,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.5,2809.5c2.8,0,5.4,1.5,6.8,3.9C69.5,2813.4,66.9,2811.9,65.5,2809.5L65.5,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.6,2812c2.6-0.9,5.6-0.4,7.7,1.4C69.7,2814.3,66.7,2813.8,64.6,2812L64.6,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.6,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C70.2,2815.2,67.2,2815.7,64.6,2814.8L64.6,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.5,2817.3c1.4-2.4,4-3.9,6.8-3.9C70.9,2815.8,68.3,2817.3,65.5,2817.3L65.5,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M67.3,2819.4c0.5-2.7,2.4-5,5-6C71.8,2816.1,69.9,2818.4,67.3,2819.4L67.3,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M69.6,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C72.8,2816.1,71.7,2819,69.6,2820.8L69.6,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.3,2821.2c-1.4-2.4-1.4-5.4,0-7.8C73.7,2815.8,73.7,2818.8,72.3,2821.2L72.3,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M75,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C74.4,2815.2,75.4,2818,75,2820.8L75,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.3,2819.4c-2.6-1-4.5-3.3-5-6C74.9,2814.4,76.8,2816.7,77.3,2819.4L77.3,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M79.1,2817.3c-2.8,0-5.4-1.5-6.8-3.9C75.1,2813.4,77.7,2814.9,79.1,2817.3L79.1,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M80,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C74.9,2812.5,77.9,2813,80,2814.8L80,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M80,2812c-2.1,1.8-5.1,2.3-7.7,1.4C74.4,2811.6,77.4,2811.1,80,2812L80,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M79.1,2809.5c-1.4,2.4-4,3.9-6.8,3.9C73.7,2811,76.3,2809.5,79.1,2809.5L79.1,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.3,2807.4c-0.5,2.7-2.4,5-5,6C72.8,2810.7,74.7,2808.4,77.3,2807.4L77.3,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M75,2806c0.5,2.7-0.6,5.6-2.7,7.4C71.8,2810.7,72.9,2807.8,75,2806L75,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 72.3,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 85.7,
    y1: 2818.3,
    x2: 85.7,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M85.7,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C93.8,2845.3,90.2,2839.7,85.7,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M85.6,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S86.4,2825.2,85.6,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M79.8,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S80,2821.2,79.8,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M85.6,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S86.4,2830,85.6,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M79.8,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C80.4,2826.5,80,2826,79.8,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.7,2805.6c1.4,2.4,1.4,5.4,0,7.8C84.3,2811,84.3,2808,85.7,2805.6L85.7,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M83,2806c2.1,1.8,3.1,4.6,2.7,7.4C83.6,2811.6,82.6,2808.8,83,2806L83,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M80.7,2807.4c2.6,1,4.5,3.3,5,6C83.1,2812.4,81.2,2810.1,80.7,2807.4L80.7,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.9,2809.5c2.8,0,5.4,1.5,6.8,3.9C82.9,2813.4,80.3,2811.9,78.9,2809.5L78.9,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78,2812c2.6-0.9,5.6-0.4,7.7,1.4C83.1,2814.3,80.1,2813.8,78,2812L78,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C83.6,2815.2,80.6,2815.7,78,2814.8L78,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.9,2817.3c1.4-2.4,4-3.9,6.8-3.9C84.3,2815.8,81.7,2817.3,78.9,2817.3L78.9,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M80.7,2819.4c0.5-2.7,2.4-5,5-6C85.2,2816.1,83.3,2818.4,80.7,2819.4L80.7,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M83,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C86.2,2816.1,85.1,2819,83,2820.8L83,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.7,2821.2c-1.4-2.4-1.4-5.4,0-7.8C87.1,2815.8,87.1,2818.8,85.7,2821.2L85.7,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M88.4,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C87.8,2815.2,88.8,2818,88.4,2820.8L88.4,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M90.7,2819.4c-2.6-1-4.5-3.3-5-6C88.3,2814.4,90.2,2816.7,90.7,2819.4L90.7,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.5,2817.3c-2.8,0-5.4-1.5-6.8-3.9C88.5,2813.4,91.1,2814.9,92.5,2817.3L92.5,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M93.4,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C88.3,2812.5,91.3,2813,93.4,2814.8L93.4,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M93.4,2812c-2.1,1.8-5.1,2.3-7.7,1.4C87.8,2811.6,90.8,2811.1,93.4,2812L93.4,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.5,2809.5c-1.4,2.4-4,3.9-6.8,3.9C87.1,2811,89.7,2809.5,92.5,2809.5L92.5,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M90.7,2807.4c-0.5,2.7-2.4,5-5,6C86.2,2810.7,88.1,2808.4,90.7,2807.4L90.7,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M88.4,2806c0.5,2.7-0.6,5.6-2.7,7.4C85.2,2810.7,86.3,2807.8,88.4,2806L88.4,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 85.7,
    cy: 2813.4,
    r: 3.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 98.3,
    y1: 2818.3,
    x2: 98.3,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M98.4,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C106.4,2845.3,102.9,2839.7,98.4,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M98.3,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C99.7,2825,99,2825.2,98.3,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92.4,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S92.7,2821.2,92.4,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M98.3,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C99.7,2829.7,99,2830,98.3,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92.4,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C93,2826.5,92.7,2826,92.4,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M98.3,2805.6c1.4,2.4,1.4,5.4,0,7.8C97,2811,97,2808,98.3,2805.6L98.3,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M95.7,2806c2.1,1.8,3.1,4.6,2.7,7.4C96.2,2811.6,95.2,2808.8,95.7,2806L95.7,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M93.3,2807.4c2.6,1,4.5,3.3,5,6C95.7,2812.4,93.8,2810.1,93.3,2807.4L93.3,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.5,2809.5c2.8,0,5.4,1.5,6.8,3.9C95.6,2813.4,93,2811.9,91.5,2809.5L91.5,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M90.6,2812c2.6-0.9,5.6-0.4,7.7,1.4C95.7,2814.3,92.8,2813.8,90.6,2812L90.6,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M90.6,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C96.2,2815.2,93.2,2815.7,90.6,2814.8L90.6,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.5,2817.3c1.4-2.4,4-3.9,6.8-3.9C96.9,2815.8,94.3,2817.3,91.5,2817.3L91.5,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M93.3,2819.4c0.5-2.7,2.4-5,5-6C97.8,2816.1,95.9,2818.4,93.3,2819.4L93.3,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M95.7,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C98.8,2816.1,97.8,2819,95.7,2820.8L95.7,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M98.3,2821.2c-1.4-2.4-1.4-5.4,0-7.8C99.7,2815.8,99.7,2818.8,98.3,2821.2L98.3,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M101,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C100.4,2815.2,101.5,2818,101,2820.8L101,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M103.4,2819.4c-2.6-1-4.5-3.3-5-6C100.9,2814.4,102.9,2816.7,103.4,2819.4L103.4,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M105.1,2817.3c-2.8,0-5.4-1.5-6.8-3.9C101.1,2813.4,103.7,2814.9,105.1,2817.3L105.1,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M106,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C100.9,2812.5,103.9,2813,106,2814.8L106,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M106,2812c-2.1,1.8-5.1,2.3-7.7,1.4C100.5,2811.6,103.4,2811.1,106,2812L106,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M105.1,2809.5c-1.4,2.4-4,3.9-6.8,3.9C99.7,2811,102.3,2809.5,105.1,2809.5L105.1,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M103.4,2807.4c-0.5,2.7-2.4,5-5,6C98.8,2810.7,100.8,2808.4,103.4,2807.4L103.4,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M101,2806c0.5,2.7-0.6,5.6-2.7,7.4C97.9,2810.7,98.9,2807.8,101,2806L101,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 98.3,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 111.7,
    y1: 2818.3,
    x2: 111.7,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M111.8,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C119.8,2845.3,116.2,2839.7,111.8,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M111.7,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C113,2825,112.4,2825.2,111.7,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.8,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S106,2821.2,105.8,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M111.7,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C113,2829.7,112.4,2830,111.7,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.8,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C106.4,2826.5,106,2826,105.8,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.7,2805.6c1.4,2.4,1.4,5.4,0,7.8C110.3,2811,110.4,2808,111.7,2805.6L111.7,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M109,2806c2.1,1.8,3.1,4.6,2.7,7.4C109.6,2811.6,108.6,2808.8,109,2806L109,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M106.7,2807.4c2.6,1,4.5,3.3,5,6C109.1,2812.4,107.2,2810.1,106.7,2807.4L106.7,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.9,2809.5c2.8,0,5.4,1.5,6.8,3.9C108.9,2813.4,106.3,2811.9,104.9,2809.5L104.9,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104,2812c2.6-0.9,5.6-0.4,7.7,1.4C109.1,2814.3,106.1,2813.8,104,2812L104,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C109.6,2815.2,106.6,2815.7,104,2814.8L104,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.9,2817.3c1.4-2.4,4-3.9,6.8-3.9C110.3,2815.8,107.7,2817.3,104.9,2817.3L104.9,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M106.7,2819.4c0.5-2.7,2.4-5,5-6C111.2,2816.1,109.3,2818.4,106.7,2819.4L106.7,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M109,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C112.2,2816.1,111.1,2819,109,2820.8L109,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.7,2821.2c-1.4-2.4-1.4-5.4,0-7.8C113.1,2815.8,113.1,2818.8,111.7,2821.2L111.7,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M114.4,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C113.8,2815.2,114.8,2818,114.4,2820.8L114.4,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M116.8,2819.4c-2.6-1-4.5-3.3-5-6C114.3,2814.4,116.2,2816.7,116.8,2819.4L116.8,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.5,2817.3c-2.8,0-5.4-1.5-6.8-3.9C114.5,2813.4,117.1,2814.9,118.5,2817.3L118.5,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M119.4,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C114.3,2812.5,117.3,2813,119.4,2814.8L119.4,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M119.4,2812c-2.1,1.8-5.1,2.3-7.7,1.4C113.9,2811.6,116.8,2811.1,119.4,2812L119.4,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.5,2809.5c-1.4,2.4-4,3.9-6.8,3.9C113.1,2811,115.7,2809.5,118.5,2809.5L118.5,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M116.8,2807.4c-0.5,2.7-2.4,5-5,6C112.2,2810.7,114.2,2808.4,116.8,2807.4L116.8,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M114.4,2806c0.5,2.7-0.6,5.6-2.7,7.4C111.3,2810.7,112.3,2807.8,114.4,2806L114.4,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 111.7,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 125.1,
    y1: 2818.3,
    x2: 125.1,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M125.1,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C133.2,2845.3,129.6,2839.7,125.1,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C126.4,2825,125.8,2825.2,125,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M119.2,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C119.8,2821.8,119.4,2821.2,119.2,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C126.4,2829.7,125.8,2830,125,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M119.2,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C119.8,2826.5,119.4,2826,119.2,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M125.1,2805.6c1.4,2.4,1.4,5.4,0,7.8C123.7,2811,123.7,2808,125.1,2805.6L125.1,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M122.4,2806c2.1,1.8,3.1,4.6,2.7,7.4C123,2811.6,122,2808.8,122.4,2806L122.4,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M120.1,2807.4c2.6,1,4.5,3.3,5,6C122.5,2812.4,120.6,2810.1,120.1,2807.4L120.1,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.3,2809.5c2.8,0,5.4,1.5,6.8,3.9C122.3,2813.4,119.7,2811.9,118.3,2809.5L118.3,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M117.4,2812c2.6-0.9,5.6-0.4,7.7,1.4C122.5,2814.3,119.5,2813.8,117.4,2812L117.4,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M117.4,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C123,2815.2,120,2815.7,117.4,2814.8L117.4,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.3,2817.3c1.4-2.4,4-3.9,6.8-3.9C123.7,2815.8,121.1,2817.3,118.3,2817.3L118.3,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M120.1,2819.4c0.5-2.7,2.4-5,5-6C124.6,2816.1,122.7,2818.4,120.1,2819.4L120.1,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M122.4,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C125.6,2816.1,124.5,2819,122.4,2820.8L122.4,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M125.1,2821.2c-1.4-2.4-1.4-5.4,0-7.8C126.5,2815.8,126.5,2818.8,125.1,2821.2L125.1,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M127.8,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C127.2,2815.2,128.2,2818,127.8,2820.8L127.8,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M130.1,2819.4c-2.6-1-4.5-3.3-5-6C127.7,2814.4,129.6,2816.7,130.1,2819.4L130.1,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.9,2817.3c-2.8,0-5.4-1.5-6.8-3.9C127.9,2813.4,130.5,2814.9,131.9,2817.3L131.9,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M132.8,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C127.7,2812.5,130.7,2813,132.8,2814.8L132.8,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M132.8,2812c-2.1,1.8-5.1,2.3-7.7,1.4C127.2,2811.6,130.2,2811.1,132.8,2812L132.8,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.9,2809.5c-1.4,2.4-4,3.9-6.8,3.9C126.5,2811,129.1,2809.5,131.9,2809.5L131.9,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M130.1,2807.4c-0.5,2.7-2.4,5-5,6C125.6,2810.7,127.5,2808.4,130.1,2807.4L130.1,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M127.8,2806c0.5,2.7-0.6,5.6-2.7,7.4C124.6,2810.7,125.7,2807.8,127.8,2806L127.8,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 125.1,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 138.5,
    y1: 2818.3,
    x2: 138.5,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M138.5,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C146.6,2845.3,143,2839.7,138.5,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M138.4,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C139.8,2825,139.2,2825.2,138.4,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M132.6,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S132.8,2821.2,132.6,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M138.4,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C139.8,2829.7,139.2,2830,138.4,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M132.6,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C133.2,2826.5,132.8,2826,132.6,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138.5,2805.6c1.4,2.4,1.4,5.4,0,7.8C137.1,2811,137.1,2808,138.5,2805.6L138.5,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M135.8,2806c2.1,1.8,3.1,4.6,2.7,7.4C136.4,2811.6,135.4,2808.8,135.8,2806L135.8,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M133.5,2807.4c2.6,1,4.5,3.3,5,6C135.9,2812.4,134,2810.1,133.5,2807.4L133.5,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.7,2809.5c2.8,0,5.4,1.5,6.8,3.9C135.7,2813.4,133.1,2811.9,131.7,2809.5L131.7,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M130.8,2812c2.6-0.9,5.6-0.4,7.7,1.4C135.9,2814.3,132.9,2813.8,130.8,2812L130.8,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M130.8,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C136.3,2815.2,133.4,2815.7,130.8,2814.8L130.8,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.7,2817.3c1.4-2.4,4-3.9,6.8-3.9C137.1,2815.8,134.5,2817.3,131.7,2817.3L131.7,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M133.5,2819.4c0.5-2.7,2.4-5,5-6C138,2816.1,136,2818.4,133.5,2819.4L133.5,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M135.8,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C139,2816.1,137.9,2819,135.8,2820.8L135.8,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138.5,2821.2c-1.4-2.4-1.4-5.4,0-7.8C139.9,2815.8,139.8,2818.8,138.5,2821.2L138.5,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M141.2,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C140.6,2815.2,141.6,2818,141.2,2820.8L141.2,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M143.5,2819.4c-2.6-1-4.5-3.3-5-6C141.1,2814.4,143,2816.7,143.5,2819.4L143.5,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M145.3,2817.3c-2.8,0-5.4-1.5-6.8-3.9C141.3,2813.4,143.9,2814.9,145.3,2817.3L145.3,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M146.2,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C141.1,2812.5,144.1,2813,146.2,2814.8L146.2,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M146.2,2812c-2.1,1.8-5.1,2.3-7.7,1.4C140.6,2811.6,143.6,2811.1,146.2,2812L146.2,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M145.3,2809.5c-1.4,2.4-4,3.9-6.8,3.9C139.9,2811,142.5,2809.5,145.3,2809.5L145.3,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M143.5,2807.4c-0.5,2.7-2.4,5-5,6C139,2810.7,140.9,2808.4,143.5,2807.4L143.5,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M141.2,2806c0.5,2.7-0.6,5.6-2.7,7.4C138,2810.7,139.1,2807.8,141.2,2806L141.2,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 138.5,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 151.9,
    y1: 2818.3,
    x2: 151.9,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M151.9,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H163c0.4,0,0.6-0.5,0.2-0.7 C159.9,2845.3,156.4,2839.7,151.9,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M151.8,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S152.6,2825.2,151.8,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M146,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C146.6,2821.8,146.2,2821.2,146,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M151.8,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S152.6,2830,151.8,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M146,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C146.6,2826.5,146.2,2826,146,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M151.9,2805.6c1.4,2.4,1.4,5.4,0,7.8C150.5,2811,150.5,2808,151.9,2805.6L151.9,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M149.2,2806c2.1,1.8,3.1,4.6,2.7,7.4C149.8,2811.6,148.7,2808.8,149.2,2806L149.2,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M146.8,2807.4c2.6,1,4.5,3.3,5,6C149.3,2812.4,147.4,2810.1,146.8,2807.4L146.8,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M145.1,2809.5c2.8,0,5.4,1.5,6.8,3.9C149.1,2813.4,146.5,2811.9,145.1,2809.5L145.1,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M144.2,2812c2.6-0.9,5.6-0.4,7.7,1.4C149.3,2814.3,146.3,2813.8,144.2,2812L144.2,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M144.2,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C149.7,2815.2,146.8,2815.7,144.2,2814.8L144.2,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M145.1,2817.3c1.4-2.4,4-3.9,6.8-3.9C150.5,2815.8,147.9,2817.3,145.1,2817.3L145.1,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M146.8,2819.4c0.5-2.7,2.4-5,5-6C151.4,2816.1,149.4,2818.4,146.8,2819.4L146.8,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M149.2,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C152.3,2816.1,151.3,2819,149.2,2820.8L149.2,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M151.9,2821.2c-1.4-2.4-1.4-5.4,0-7.8C153.2,2815.8,153.2,2818.8,151.9,2821.2L151.9,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M154.6,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C154,2815.2,155,2818,154.6,2820.8L154.6,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M156.9,2819.4c-2.6-1-4.5-3.3-5-6C154.5,2814.4,156.4,2816.7,156.9,2819.4L156.9,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M158.7,2817.3c-2.8,0-5.4-1.5-6.8-3.9C154.7,2813.4,157.2,2814.9,158.7,2817.3L158.7,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M159.6,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C154.5,2812.5,157.4,2813,159.6,2814.8L159.6,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M159.6,2812c-2.1,1.8-5.1,2.3-7.7,1.4C154,2811.6,157,2811.1,159.6,2812L159.6,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M158.7,2809.5c-1.4,2.4-4,3.9-6.8,3.9C153.3,2811,155.9,2809.5,158.7,2809.5L158.7,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M156.9,2807.4c-0.5,2.7-2.4,5-5,6C152.4,2810.7,154.3,2808.4,156.9,2807.4L156.9,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M154.6,2806c0.5,2.7-0.6,5.6-2.7,7.4C151.4,2810.7,152.5,2807.8,154.6,2806L154.6,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 151.9,
    cy: 2813.4,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 165.2,
    y1: 2818.3,
    x2: 165.2,
    y2: 2839.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M165.3,2839.7c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C173.3,2845.3,169.8,2839.7,165.3,2839.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M165.2,2825.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C166.6,2825,166,2825.2,165.2,2825.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M159.4,2820.5c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C159.9,2821.8,159.6,2821.2,159.4,2820.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M165.2,2830c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C166.6,2829.7,166,2830,165.2,2830z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M159.4,2825.3c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C159.9,2826.5,159.6,2826,159.4,2825.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M165.3,2805.6c1.4,2.4,1.4,5.4,0,7.8C163.9,2811,163.9,2808,165.3,2805.6L165.3,2805.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M162.6,2806c2.1,1.8,3.1,4.6,2.7,7.4C163.1,2811.6,162.1,2808.8,162.6,2806L162.6,2806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M160.2,2807.4c2.6,1,4.5,3.3,5,6C162.7,2812.4,160.7,2810.1,160.2,2807.4L160.2,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M158.5,2809.5c2.8,0,5.4,1.5,6.8,3.9C162.5,2813.4,159.9,2811.9,158.5,2809.5L158.5,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M157.5,2812c2.6-0.9,5.6-0.4,7.7,1.4C162.6,2814.3,159.7,2813.8,157.5,2812L157.5,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M157.5,2814.8c2.1-1.8,5.1-2.3,7.7-1.4C163.1,2815.2,160.2,2815.7,157.5,2814.8L157.5,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M158.5,2817.3c1.4-2.4,4-3.9,6.8-3.9C163.9,2815.8,161.2,2817.3,158.5,2817.3L158.5,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M160.2,2819.4c0.5-2.7,2.4-5,5-6C164.8,2816.1,162.8,2818.4,160.2,2819.4L160.2,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M162.6,2820.8c-0.5-2.7,0.6-5.6,2.7-7.4C165.7,2816.1,164.7,2819,162.6,2820.8L162.6,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M165.3,2821.2c-1.4-2.4-1.4-5.4,0-7.8C166.6,2815.8,166.6,2818.8,165.3,2821.2L165.3,2821.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M167.9,2820.8c-2.1-1.8-3.1-4.6-2.7-7.4C167.4,2815.2,168.4,2818,167.9,2820.8L167.9,2820.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M170.3,2819.4c-2.6-1-4.5-3.3-5-6C167.9,2814.4,169.8,2816.7,170.3,2819.4L170.3,2819.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M172,2817.3c-2.8,0-5.4-1.5-6.8-3.9C168,2813.4,170.6,2814.9,172,2817.3L172,2817.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M173,2814.8c-2.6,0.9-5.6,0.4-7.7-1.4C167.9,2812.5,170.8,2813,173,2814.8L173,2814.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M173,2812c-2.1,1.8-5.1,2.3-7.7,1.4C167.4,2811.6,170.4,2811.1,173,2812L173,2812z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M172,2809.5c-1.4,2.4-4,3.9-6.8,3.9C166.7,2811,169.3,2809.5,172,2809.5L172,2809.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M170.3,2807.4c-0.5,2.7-2.4,5-5,6C165.8,2810.7,167.7,2808.4,170.3,2807.4L170.3,2807.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M167.9,2806c0.5,2.7-0.6,5.6-2.7,7.4C164.8,2810.7,165.8,2807.8,167.9,2806L167.9,2806z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 165.3,
    cy: 2813.4,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 38.7,
    y1: 2829.1,
    x2: 38.7,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M38.8,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C46.8,2856.1,43.3,2850.5,38.8,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M38.7,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C40.1,2835.7,39.4,2835.9,38.7,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.8,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S33.1,2832,32.8,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M38.7,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C40.1,2840.5,39.4,2840.7,38.7,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.8,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S33.1,2836.7,32.8,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.7,2816.3c1.4,2.4,1.4,5.4,0,7.8C37.4,2821.7,37.4,2818.7,38.7,2816.3L38.7,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M36.1,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C36.6,2822.4,35.6,2819.5,36.1,2816.8L36.1,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M33.7,2818.2c2.6,1,4.5,3.3,5,6C36.1,2823.2,34.2,2820.9,33.7,2818.2L33.7,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M32,2820.2c2.8,0,5.4,1.5,6.8,3.9C36,2824.1,33.4,2822.6,32,2820.2L32,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C36.1,2825.1,33.2,2824.5,31,2822.8L31,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C36.6,2825.9,33.6,2826.4,31,2825.5L31,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M32,2828.1c1.4-2.4,4-3.9,6.8-3.9C37.3,2826.5,34.7,2828,32,2828.1L32,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M33.7,2830.2c0.5-2.7,2.4-5,5-6C38.2,2826.9,36.3,2829.2,33.7,2830.2L33.7,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M36.1,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C39.2,2826.9,38.2,2829.7,36.1,2831.5L36.1,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.7,2832c-1.4-2.4-1.4-5.4,0-7.8C40.1,2826.6,40.1,2829.6,38.7,2832L38.7,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M41.4,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C40.9,2826,41.9,2828.8,41.4,2831.5L41.4,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M43.8,2830.2c-2.6-1-4.5-3.3-5-6C41.3,2825.1,43.3,2827.4,43.8,2830.2L43.8,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.5,2828.1c-2.8,0-5.4-1.5-6.8-3.9C41.5,2824.2,44.1,2825.7,45.5,2828.1L45.5,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M46.5,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C41.4,2823.2,44.3,2823.8,46.5,2825.5L46.5,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M46.5,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C40.9,2822.4,43.8,2821.9,46.5,2822.8L46.5,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.5,2820.2c-1.4,2.4-4,3.9-6.8,3.9C40.2,2821.8,42.8,2820.3,45.5,2820.2L45.5,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M43.8,2818.2c-0.5,2.7-2.4,5-5,6C39.3,2821.4,41.2,2819.1,43.8,2818.2L43.8,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M41.4,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C38.3,2821.4,39.3,2818.6,41.4,2816.8L41.4,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 38.7,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 52.1,
    y1: 2829.1,
    x2: 52.1,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M52.2,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C60.2,2856.1,56.7,2850.5,52.2,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M52.1,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S52.8,2835.9,52.1,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M46.2,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C46.8,2832.5,46.5,2832,46.2,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M52.1,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S52.8,2840.7,52.1,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M46.2,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C46.8,2837.3,46.5,2836.7,46.2,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.1,2816.3c1.4,2.4,1.4,5.4,0,7.8C50.8,2821.7,50.8,2818.7,52.1,2816.3L52.1,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M49.5,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C50,2822.4,49,2819.5,49.5,2816.8L49.5,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M47.1,2818.2c2.6,1,4.5,3.3,5,6C49.5,2823.2,47.6,2820.9,47.1,2818.2L47.1,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.3,2820.2c2.8,0,5.4,1.5,6.8,3.9C49.4,2824.1,46.8,2822.6,45.3,2820.2L45.3,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M44.4,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C49.5,2825.1,46.6,2824.6,44.4,2822.8L44.4,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M44.4,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C50,2825.9,47,2826.4,44.4,2825.5L44.4,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.3,2828.1c1.4-2.4,4-3.9,6.8-3.9C50.7,2826.5,48.1,2828,45.3,2828.1L45.3,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M47.1,2830.2c0.5-2.7,2.4-5,5-6C51.6,2826.9,49.7,2829.2,47.1,2830.2L47.1,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M49.5,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C52.6,2826.9,51.6,2829.7,49.5,2831.5L49.5,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.1,2832c-1.4-2.4-1.4-5.4,0-7.8C53.5,2826.6,53.5,2829.6,52.1,2832L52.1,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M54.8,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C54.2,2826,55.3,2828.8,54.8,2831.5L54.8,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.2,2830.2c-2.6-1-4.5-3.3-5-6C54.7,2825.1,56.7,2827.4,57.2,2830.2L57.2,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.9,2828.1c-2.8,0-5.4-1.5-6.8-3.9C54.9,2824.2,57.5,2825.7,58.9,2828.1L58.9,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M59.8,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C54.7,2823.2,57.7,2823.8,59.8,2825.5L59.8,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M59.8,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C54.3,2822.4,57.2,2821.9,59.8,2822.8L59.8,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.9,2820.2c-1.4,2.4-4,3.9-6.8,3.9C53.5,2821.8,56.1,2820.3,58.9,2820.2L58.9,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.2,2818.2c-0.5,2.7-2.4,5-5,6C52.6,2821.4,54.6,2819.1,57.2,2818.2L57.2,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M54.8,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C51.7,2821.4,52.7,2818.6,54.8,2816.8L54.8,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 52.1,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 65.5,
    y1: 2829.1,
    x2: 65.5,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M65.6,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C73.6,2856.1,70,2850.5,65.6,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M65.5,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C66.8,2835.7,66.2,2835.9,65.5,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M59.6,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C60.2,2832.5,59.8,2832,59.6,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M65.5,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C66.8,2840.5,66.2,2840.7,65.5,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M59.6,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C60.2,2837.3,59.8,2836.7,59.6,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.5,2816.3c1.4,2.4,1.4,5.4,0,7.8C64.2,2821.7,64.2,2818.7,65.5,2816.3L65.5,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M62.8,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C63.4,2822.4,62.4,2819.5,62.8,2816.8L62.8,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M60.5,2818.2c2.6,1,4.5,3.3,5,6C62.9,2823.2,61,2820.9,60.5,2818.2L60.5,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.7,2820.2c2.8,0,5.4,1.5,6.8,3.9C62.7,2824.1,60.1,2822.6,58.7,2820.2L58.7,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.8,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C62.9,2825.1,59.9,2824.6,57.8,2822.8L57.8,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.8,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C63.4,2825.9,60.4,2826.4,57.8,2825.5L57.8,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.7,2828.1c1.4-2.4,4-3.9,6.8-3.9C64.1,2826.5,61.5,2828,58.7,2828.1L58.7,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M60.5,2830.2c0.5-2.7,2.4-5,5-6C65,2826.9,63.1,2829.2,60.5,2830.2L60.5,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M62.8,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C66,2826.9,64.9,2829.7,62.8,2831.5L62.8,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.5,2832c-1.4-2.4-1.4-5.4,0-7.8C66.9,2826.6,66.9,2829.6,65.5,2832L65.5,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M68.2,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C67.6,2826,68.7,2828.8,68.2,2831.5L68.2,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M70.6,2830.2c-2.6-1-4.5-3.3-5-6C68.1,2825.1,70,2827.4,70.6,2830.2L70.6,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.3,2828.1c-2.8,0-5.4-1.5-6.8-3.9C68.3,2824.2,70.9,2825.7,72.3,2828.1L72.3,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M73.2,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C68.1,2823.2,71.1,2823.8,73.2,2825.5L73.2,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M73.2,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C67.7,2822.4,70.6,2821.9,73.2,2822.8L73.2,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.3,2820.2c-1.4,2.4-4,3.9-6.8,3.9C66.9,2821.8,69.5,2820.3,72.3,2820.2L72.3,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M70.6,2818.2c-0.5,2.7-2.4,5-5,6C66,2821.4,68,2819.1,70.6,2818.2L70.6,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M68.2,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C65.1,2821.4,66.1,2818.6,68.2,2816.8L68.2,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 65.5,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 78.9,
    y1: 2829.1,
    x2: 78.9,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M78.9,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H90c0.4,0,0.6-0.5,0.2-0.7 C87,2856.1,83.4,2850.5,78.9,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M78.8,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C80.2,2835.7,79.6,2835.9,78.8,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M73,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S73.2,2832,73,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M78.8,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C80.2,2840.5,79.6,2840.7,78.8,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M73,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S73.2,2836.7,73,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.9,2816.3c1.4,2.4,1.4,5.4,0,7.8C77.5,2821.7,77.5,2818.7,78.9,2816.3L78.9,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M76.2,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C76.8,2822.4,75.8,2819.5,76.2,2816.8L76.2,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M73.9,2818.2c2.6,1,4.5,3.3,5,6C76.3,2823.2,74.4,2820.9,73.9,2818.2L73.9,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.1,2820.2c2.8,0,5.4,1.5,6.8,3.9C76.1,2824.1,73.5,2822.6,72.1,2820.2L72.1,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M71.2,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C76.3,2825.1,73.3,2824.6,71.2,2822.8L71.2,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M71.2,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C76.8,2825.9,73.8,2826.4,71.2,2825.5L71.2,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.1,2828.1c1.4-2.4,4-3.9,6.8-3.9C77.5,2826.5,74.9,2828,72.1,2828.1L72.1,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M73.9,2830.2c0.5-2.7,2.4-5,5-6C78.4,2826.9,76.5,2829.2,73.9,2830.2L73.9,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M76.2,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C79.4,2826.9,78.3,2829.7,76.2,2831.5L76.2,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.9,2832c-1.4-2.4-1.4-5.4,0-7.8C80.3,2826.6,80.3,2829.6,78.9,2832L78.9,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M81.6,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C81,2826,82,2828.8,81.6,2831.5L81.6,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M83.9,2830.2c-2.6-1-4.5-3.3-5-6C81.5,2825.1,83.4,2827.4,83.9,2830.2L83.9,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.7,2828.1c-2.8,0-5.4-1.5-6.8-3.9C81.7,2824.2,84.3,2825.7,85.7,2828.1L85.7,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M86.6,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C81.5,2823.2,84.5,2823.8,86.6,2825.5L86.6,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M86.6,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C81,2822.4,84,2821.9,86.6,2822.8L86.6,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.7,2820.2c-1.4,2.4-4,3.9-6.8,3.9C80.3,2821.8,82.9,2820.3,85.7,2820.2L85.7,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M83.9,2818.2c-0.5,2.7-2.4,5-5,6C79.4,2821.4,81.3,2819.1,83.9,2818.2L83.9,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M81.6,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C78.4,2821.4,79.5,2818.6,81.6,2816.8L81.6,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 78.9,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 92.3,
    y1: 2829.1,
    x2: 92.3,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M92.3,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C100.4,2856.1,96.8,2850.5,92.3,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92.2,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S93,2835.9,92.2,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M86.4,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S86.6,2832,86.4,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92.2,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S93,2840.7,92.2,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M86.4,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S86.6,2836.7,86.4,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.3,2816.3c1.4,2.4,1.4,5.4,0,7.8C90.9,2821.7,90.9,2818.7,92.3,2816.3L92.3,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M89.6,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C90.2,2822.4,89.2,2819.5,89.6,2816.8L89.6,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M87.3,2818.2c2.6,1,4.5,3.3,5,6C89.7,2823.2,87.8,2820.9,87.3,2818.2L87.3,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.5,2820.2c2.8,0,5.4,1.5,6.8,3.9C89.5,2824.1,86.9,2822.6,85.5,2820.2L85.5,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.6,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C89.7,2825.1,86.7,2824.6,84.6,2822.8L84.6,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.6,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C90.2,2825.9,87.2,2826.4,84.6,2825.5L84.6,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.5,2828.1c1.4-2.4,4-3.9,6.8-3.9C90.9,2826.5,88.3,2828,85.5,2828.1L85.5,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M87.3,2830.2c0.5-2.7,2.4-5,5-6C91.8,2826.9,89.9,2829.2,87.3,2830.2L87.3,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M89.6,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C92.8,2826.9,91.7,2829.7,89.6,2831.5L89.6,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.3,2832c-1.4-2.4-1.4-5.4,0-7.8C93.7,2826.6,93.7,2829.6,92.3,2832L92.3,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M95,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C94.4,2826,95.4,2828.8,95,2831.5L95,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.3,2830.2c-2.6-1-4.5-3.3-5-6C94.9,2825.1,96.8,2827.4,97.3,2830.2L97.3,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M99.1,2828.1c-2.8,0-5.4-1.5-6.8-3.9C95.1,2824.2,97.7,2825.7,99.1,2828.1L99.1,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M100,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C94.9,2823.2,97.9,2823.8,100,2825.5L100,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M100,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C94.4,2822.4,97.4,2821.9,100,2822.8L100,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M99.1,2820.2c-1.4,2.4-4,3.9-6.8,3.9C93.7,2821.8,96.3,2820.3,99.1,2820.2L99.1,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.3,2818.2c-0.5,2.7-2.4,5-5,6C92.8,2821.4,94.7,2819.1,97.3,2818.2L97.3,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M95,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C91.8,2821.4,92.9,2818.6,95,2816.8L95,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 92.3,
    cy: 2824.2,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 104.9,
    y1: 2829.1,
    x2: 104.9,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M105,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H105h11c0.4,0,0.6-0.5,0.2-0.7 C113,2856.1,109.5,2850.5,105,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.9,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S105.6,2835.9,104.9,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S99.3,2832,99,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.9,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S105.6,2840.7,104.9,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S99.3,2836.7,99,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.9,2816.3c1.4,2.4,1.4,5.4,0,7.8C103.6,2821.7,103.6,2818.7,104.9,2816.3L104.9,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M102.3,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C102.8,2822.4,101.8,2819.5,102.3,2816.8L102.3,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M99.9,2818.2c2.6,1,4.5,3.3,5,6C102.3,2823.2,100.4,2820.9,99.9,2818.2L99.9,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M98.1,2820.2c2.8,0,5.4,1.5,6.8,3.9C102.2,2824.1,99.6,2822.6,98.1,2820.2L98.1,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.2,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C102.3,2825.1,99.4,2824.6,97.2,2822.8L97.2,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.2,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C102.8,2825.9,99.8,2826.4,97.2,2825.5L97.2,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M98.1,2828.1c1.4-2.4,4-3.9,6.8-3.9C103.5,2826.5,100.9,2828,98.1,2828.1L98.1,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M99.9,2830.2c0.5-2.7,2.4-5,5-6C104.4,2826.9,102.5,2829.2,99.9,2830.2L99.9,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M102.3,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C105.4,2826.9,104.4,2829.7,102.3,2831.5L102.3,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.9,2832c-1.4-2.4-1.4-5.4,0-7.8C106.3,2826.6,106.3,2829.6,104.9,2832L104.9,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M107.6,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C107,2826,108.1,2828.8,107.6,2831.5L107.6,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M110,2830.2c-2.6-1-4.5-3.3-5-6C107.5,2825.1,109.5,2827.4,110,2830.2L110,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.7,2828.1c-2.8,0-5.4-1.5-6.8-3.9C107.7,2824.2,110.3,2825.7,111.7,2828.1L111.7,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M112.6,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C107.5,2823.2,110.5,2823.8,112.6,2825.5L112.6,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M112.6,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C107.1,2822.4,110,2821.9,112.6,2822.8L112.6,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.7,2820.2c-1.4,2.4-4,3.9-6.8,3.9C106.3,2821.8,108.9,2820.3,111.7,2820.2L111.7,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M110,2818.2c-0.5,2.7-2.4,5-5,6C105.4,2821.4,107.4,2819.1,110,2818.2L110,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M107.6,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C104.5,2821.4,105.5,2818.6,107.6,2816.8L107.6,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 104.9,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 118.3,
    y1: 2829.1,
    x2: 118.3,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M118.4,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C126.4,2856.1,122.8,2850.5,118.4,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M118.3,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C119.6,2835.7,119,2835.9,118.3,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M112.4,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S112.6,2832,112.4,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M118.3,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C119.6,2840.5,119,2840.7,118.3,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M112.4,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S112.6,2836.7,112.4,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.3,2816.3c1.4,2.4,1.4,5.4,0,7.8C116.9,2821.7,117,2818.7,118.3,2816.3L118.3,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M115.6,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C116.2,2822.4,115.2,2819.5,115.6,2816.8L115.6,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M113.3,2818.2c2.6,1,4.5,3.3,5,6C115.7,2823.2,113.8,2820.9,113.3,2818.2L113.3,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.5,2820.2c2.8,0,5.4,1.5,6.8,3.9C115.5,2824.1,112.9,2822.6,111.5,2820.2L111.5,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M110.6,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C115.7,2825.1,112.7,2824.6,110.6,2822.8L110.6,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M110.6,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C116.2,2825.9,113.2,2826.4,110.6,2825.5L110.6,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.5,2828.1c1.4-2.4,4-3.9,6.8-3.9C116.9,2826.5,114.3,2828,111.5,2828.1L111.5,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M113.3,2830.2c0.5-2.7,2.4-5,5-6C117.8,2826.9,115.9,2829.2,113.3,2830.2L113.3,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M115.6,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C118.8,2826.9,117.7,2829.7,115.6,2831.5L115.6,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.3,2832c-1.4-2.4-1.4-5.4,0-7.8C119.7,2826.6,119.7,2829.6,118.3,2832L118.3,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M121,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C120.4,2826,121.4,2828.8,121,2831.5L121,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M123.4,2830.2c-2.6-1-4.5-3.3-5-6C120.9,2825.1,122.8,2827.4,123.4,2830.2L123.4,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M125.1,2828.1c-2.8,0-5.4-1.5-6.8-3.9C121.1,2824.2,123.7,2825.7,125.1,2828.1L125.1,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M126,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C120.9,2823.2,123.9,2823.8,126,2825.5L126,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M126,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C120.5,2822.4,123.4,2821.9,126,2822.8L126,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M125.1,2820.2c-1.4,2.4-4,3.9-6.8,3.9C119.7,2821.8,122.3,2820.3,125.1,2820.2L125.1,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M123.4,2818.2c-0.5,2.7-2.4,5-5,6C118.8,2821.4,120.8,2819.1,123.4,2818.2L123.4,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M121,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C117.9,2821.4,118.9,2818.6,121,2816.8L121,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 118.3,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 131.7,
    y1: 2829.1,
    x2: 131.7,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M131.7,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C139.8,2856.1,136.2,2850.5,131.7,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M131.6,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S132.4,2835.9,131.6,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125.8,2831.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S126,2832,125.8,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M131.6,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S132.4,2840.7,131.6,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125.8,2836c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S126,2836.7,125.8,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.7,2816.3c1.4,2.4,1.4,5.4,0,7.8C130.3,2821.7,130.3,2818.7,131.7,2816.3L131.7,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M129,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C129.6,2822.4,128.6,2819.5,129,2816.8L129,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M126.7,2818.2c2.6,1,4.5,3.3,5,6C129.1,2823.2,127.2,2820.9,126.7,2818.2L126.7,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.9,2820.2c2.8,0,5.4,1.5,6.8,3.9C128.9,2824.1,126.3,2822.6,124.9,2820.2L124.9,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C129.1,2825.1,126.1,2824.5,124,2822.8L124,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C129.6,2825.9,126.6,2826.4,124,2825.5L124,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.9,2828.1c1.4-2.4,4-3.9,6.8-3.9C130.3,2826.5,127.7,2828,124.9,2828.1L124.9,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M126.7,2830.2c0.5-2.7,2.4-5,5-6C131.2,2826.9,129.3,2829.2,126.7,2830.2L126.7,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M129,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C132.2,2826.9,131.1,2829.7,129,2831.5L129,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.7,2832c-1.4-2.4-1.4-5.4,0-7.8C133.1,2826.6,133.1,2829.6,131.7,2832L131.7,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M134.4,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C133.8,2826,134.8,2828.8,134.4,2831.5L134.4,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M136.7,2830.2c-2.6-1-4.5-3.3-5-6C134.3,2825.1,136.2,2827.4,136.7,2830.2L136.7,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138.5,2828.1c-2.8,0-5.4-1.5-6.8-3.9C134.5,2824.2,137.1,2825.7,138.5,2828.1L138.5,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M139.4,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C134.3,2823.2,137.3,2823.8,139.4,2825.5L139.4,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M139.4,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C133.8,2822.4,136.8,2821.9,139.4,2822.8L139.4,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138.5,2820.2c-1.4,2.4-4,3.9-6.8,3.9C133.1,2821.8,135.7,2820.3,138.5,2820.2L138.5,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M136.7,2818.2c-0.5,2.7-2.4,5-5,6C132.2,2821.4,134.1,2819.1,136.7,2818.2L136.7,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M134.4,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C131.2,2821.4,132.3,2818.6,134.4,2816.8L134.4,2816.8z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020237e-02 1.020237e-02 0.9999 -28.8067 1.4906)",
    className: "st60",
    cx: 131.7,
    cy: 2824.2,
    rx: 3.9,
    ry: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 145.1,
    y1: 2829.1,
    x2: 145.1,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M145.1,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C153.2,2856.1,149.6,2850.5,145.1,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M145,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S145.8,2835.9,145,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M139.2,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C139.8,2832.5,139.4,2832,139.2,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M145,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S145.8,2840.7,145,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M139.2,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C139.8,2837.3,139.4,2836.7,139.2,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M145.1,2816.3c1.4,2.4,1.4,5.4,0,7.8C143.7,2821.7,143.7,2818.7,145.1,2816.3L145.1,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M142.4,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C143,2822.4,142,2819.5,142.4,2816.8L142.4,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M140.1,2818.2c2.6,1,4.5,3.3,5,6C142.5,2823.2,140.6,2820.9,140.1,2818.2L140.1,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138.3,2820.2c2.8,0,5.4,1.5,6.8,3.9C142.3,2824.1,139.7,2822.6,138.3,2820.2L138.3,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M137.4,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C142.5,2825.1,139.5,2824.6,137.4,2822.8L137.4,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M137.4,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C142.9,2825.9,140,2826.4,137.4,2825.5L137.4,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138.3,2828.1c1.4-2.4,4-3.9,6.8-3.9C143.7,2826.5,141.1,2828,138.3,2828.1L138.3,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M140.1,2830.2c0.5-2.7,2.4-5,5-6C144.6,2826.9,142.6,2829.2,140.1,2830.2L140.1,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M142.4,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C145.5,2826.9,144.5,2829.7,142.4,2831.5L142.4,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M145.1,2832c-1.4-2.4-1.4-5.4,0-7.8C146.5,2826.6,146.4,2829.6,145.1,2832L145.1,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M147.8,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C147.2,2826,148.2,2828.8,147.8,2831.5L147.8,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M150.1,2830.2c-2.6-1-4.5-3.3-5-6C147.7,2825.1,149.6,2827.4,150.1,2830.2L150.1,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M151.9,2828.1c-2.8,0-5.4-1.5-6.8-3.9C147.9,2824.2,150.5,2825.7,151.9,2828.1L151.9,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M152.8,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C147.7,2823.2,150.7,2823.8,152.8,2825.5L152.8,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M152.8,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C147.2,2822.4,150.2,2821.9,152.8,2822.8L152.8,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M151.9,2820.2c-1.4,2.4-4,3.9-6.8,3.9C146.5,2821.8,149.1,2820.3,151.9,2820.2L151.9,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M150.1,2818.2c-0.5,2.7-2.4,5-5,6C145.6,2821.4,147.5,2819.1,150.1,2818.2L150.1,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M147.8,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C144.6,2821.4,145.7,2818.6,147.8,2816.8L147.8,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 145.1,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 158.5,
    y1: 2829.1,
    x2: 158.5,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M158.5,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C166.5,2856.1,163,2850.5,158.5,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M158.4,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C159.8,2835.7,159.2,2835.9,158.4,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M152.6,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S152.8,2832,152.6,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M158.4,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C159.8,2840.5,159.2,2840.7,158.4,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M152.6,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S152.8,2836.7,152.6,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M158.5,2816.3c1.4,2.4,1.4,5.4,0,7.8C157.1,2821.7,157.1,2818.7,158.5,2816.3L158.5,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M155.8,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C156.4,2822.4,155.3,2819.5,155.8,2816.8L155.8,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M153.4,2818.2c2.6,1,4.5,3.3,5,6C155.9,2823.2,154,2820.9,153.4,2818.2L153.4,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M151.7,2820.2c2.8,0,5.4,1.5,6.8,3.9C155.7,2824.1,153.1,2822.6,151.7,2820.2L151.7,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M150.8,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C155.9,2825.1,152.9,2824.5,150.8,2822.8L150.8,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M150.8,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C156.3,2825.9,153.4,2826.4,150.8,2825.5L150.8,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M151.7,2828.1c1.4-2.4,4-3.9,6.8-3.9C157.1,2826.5,154.5,2828,151.7,2828.1L151.7,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M153.4,2830.2c0.5-2.7,2.4-5,5-6C158,2826.9,156,2829.2,153.4,2830.2L153.4,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M155.8,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C158.9,2826.9,157.9,2829.7,155.8,2831.5L155.8,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M158.5,2832c-1.4-2.4-1.4-5.4,0-7.8C159.8,2826.6,159.8,2829.6,158.5,2832L158.5,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M161.2,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C160.6,2826,161.6,2828.8,161.2,2831.5L161.2,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M163.5,2830.2c-2.6-1-4.5-3.3-5-6C161.1,2825.1,163,2827.4,163.5,2830.2L163.5,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M165.3,2828.1c-2.8,0-5.4-1.5-6.8-3.9C161.3,2824.2,163.8,2825.7,165.3,2828.1L165.3,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M166.2,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C161.1,2823.2,164,2823.8,166.2,2825.5L166.2,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M166.2,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C160.6,2822.4,163.6,2821.9,166.2,2822.8L166.2,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M165.3,2820.2c-1.4,2.4-4,3.9-6.8,3.9C159.9,2821.8,162.5,2820.3,165.3,2820.2L165.3,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M163.5,2818.2c-0.5,2.7-2.4,5-5,6C159,2821.4,160.9,2819.1,163.5,2818.2L163.5,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M161.2,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C158,2821.4,159.1,2818.6,161.2,2816.8L161.2,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 158.5,
    cy: 2824.2,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 171.8,
    y1: 2829.1,
    x2: 171.8,
    y2: 2850.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M171.9,2850.5c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H183c0.4,0,0.6-0.5,0.2-0.7 C179.9,2856.1,176.4,2850.5,171.9,2850.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M171.8,2836c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S172.6,2835.9,171.8,2836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M166,2831.2c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C166.5,2832.5,166.2,2832,166,2831.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M171.8,2840.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S172.6,2840.7,171.8,2840.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M166,2836c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C166.5,2837.3,166.2,2836.7,166,2836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M171.9,2816.3c1.4,2.4,1.4,5.4,0,7.8C170.5,2821.7,170.5,2818.7,171.9,2816.3L171.9,2816.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M169.2,2816.8c2.1,1.8,3.1,4.6,2.7,7.4C169.7,2822.4,168.7,2819.5,169.2,2816.8L169.2,2816.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M166.8,2818.2c2.6,1,4.5,3.3,5,6C169.3,2823.2,167.3,2820.9,166.8,2818.2L166.8,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M165.1,2820.2c2.8,0,5.4,1.5,6.8,3.9C169.1,2824.1,166.5,2822.6,165.1,2820.2L165.1,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M164.1,2822.8c2.6-0.9,5.6-0.4,7.7,1.4C169.2,2825.1,166.3,2824.6,164.1,2822.8L164.1,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M164.1,2825.5c2.1-1.8,5.1-2.3,7.7-1.4C169.7,2825.9,166.8,2826.4,164.1,2825.5L164.1,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M165.1,2828.1c1.4-2.4,4-3.9,6.8-3.9C170.5,2826.5,167.8,2828,165.1,2828.1L165.1,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M166.8,2830.2c0.5-2.7,2.4-5,5-6C171.4,2826.9,169.4,2829.2,166.8,2830.2L166.8,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M169.2,2831.5c-0.5-2.7,0.6-5.6,2.7-7.4C172.3,2826.9,171.3,2829.7,169.2,2831.5L169.2,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M171.9,2832c-1.4-2.4-1.4-5.4,0-7.8C173.2,2826.6,173.2,2829.6,171.9,2832L171.9,2832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M174.5,2831.5c-2.1-1.8-3.1-4.6-2.7-7.4C174,2826,175,2828.8,174.5,2831.5L174.5,2831.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M176.9,2830.2c-2.6-1-4.5-3.3-5-6C174.5,2825.1,176.4,2827.4,176.9,2830.2L176.9,2830.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M178.6,2828.1c-2.8,0-5.4-1.5-6.8-3.9C174.6,2824.2,177.2,2825.7,178.6,2828.1L178.6,2828.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M179.6,2825.5c-2.6,0.9-5.6,0.4-7.7-1.4C174.5,2823.2,177.4,2823.8,179.6,2825.5L179.6,2825.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M179.6,2822.8c-2.1,1.8-5.1,2.3-7.7,1.4C174,2822.4,177,2821.9,179.6,2822.8L179.6,2822.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M178.6,2820.2c-1.4,2.4-4,3.9-6.8,3.9C173.3,2821.8,175.9,2820.3,178.6,2820.2L178.6,2820.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M176.9,2818.2c-0.5,2.7-2.4,5-5,6C172.4,2821.4,174.3,2819.1,176.9,2818.2L176.9,2818.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M174.5,2816.8c0.5,2.7-0.6,5.6-2.7,7.4C171.4,2821.4,172.4,2818.6,174.5,2816.8L174.5,2816.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 171.9,
    cy: 2824.2,
    r: 3.9
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: 0.7,
    y: 2743.9,
    width: 193.4,
    height: 125.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: -8.5,
    y1: 2764.9,
    x2: -8.5,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-8.4,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11c0.4,0,0.6-0.5,0.2-0.7 C-0.4,2791.9-3.9,2786.3-8.4,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-8.5,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S-7.8,2771.7-8.5,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-14.4,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S-14.1,2767.8-14.4,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-8.5,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S-7.8,2776.5-8.5,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-14.4,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S-14.1,2772.5-14.4,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-8.5,2752.1c1.4,2.4,1.4,5.4,0,7.8C-9.8,2757.5-9.8,2754.5-8.5,2752.1L-8.5,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-11.1,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C-10.6,2758.1-11.6,2755.3-11.1,2752.6L-11.1,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-13.5,2753.9c2.6,1,4.5,3.3,5,6C-11.1,2759-13,2756.7-13.5,2753.9L-13.5,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-15.2,2756c2.8,0,5.4,1.5,6.8,3.9C-11.2,2759.9-13.8,2758.4-15.2,2756L-15.2,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-16.2,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C-11.1,2760.9-14,2760.3-16.2,2758.6L-16.2,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-16.2,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C-10.6,2761.7-13.6,2762.2-16.2,2761.3L-16.2,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-15.2,2763.9c1.4-2.4,4-3.9,6.8-3.9C-9.9,2762.3-12.5,2763.8-15.2,2763.9L-15.2,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-13.5,2765.9c0.5-2.7,2.4-5,5-6C-9,2762.7-10.9,2765-13.5,2765.9L-13.5,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-11.1,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C-8,2762.7-9,2765.5-11.1,2767.3L-11.1,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-8.5,2767.8c-1.4-2.4-1.4-5.4,0-7.8C-7.1,2762.4-7.1,2765.4-8.5,2767.8L-8.5,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-5.8,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C-6.3,2761.7-5.3,2764.6-5.8,2767.3L-5.8,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-3.4,2765.9c-2.6-1-4.5-3.3-5-6C-5.9,2760.9-3.9,2763.2-3.4,2765.9L-3.4,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1.7,2763.9c-2.8,0-5.4-1.5-6.8-3.9C-5.7,2760-3.1,2761.5-1.7,2763.9L-1.7,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-0.7,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C-5.8,2759-2.9,2759.5-0.7,2761.3L-0.7,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-0.7,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C-6.3,2758.2-3.4,2757.7-0.7,2758.6L-0.7,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1.7,2756c-1.4,2.4-4,3.9-6.8,3.9C-7,2757.6-4.4,2756.1-1.7,2756L-1.7,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-3.4,2753.9c-0.5,2.7-2.4,5-5,6C-8,2757.2-6,2754.9-3.4,2753.9L-3.4,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-5.8,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C-8.9,2757.2-7.9,2754.4-5.8,2752.6L-5.8,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: -8.5,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 4.9,
    y1: 2764.9,
    x2: 4.9,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M5,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H5h11c0.4,0,0.6-0.5,0.2-0.7 C13,2791.9,9.5,2786.3,5,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M4.9,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S5.6,2771.7,4.9,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S-0.7,2767.8-1,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M4.9,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S5.6,2776.5,4.9,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S-0.7,2772.5-1,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.9,2752.1c1.4,2.4,1.4,5.4,0,7.8C3.6,2757.5,3.6,2754.5,4.9,2752.1L4.9,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M2.3,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C2.8,2758.1,1.8,2755.3,2.3,2752.6L2.3,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-0.1,2753.9c2.6,1,4.5,3.3,5,6C2.3,2759,0.4,2756.7-0.1,2753.9L-0.1,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1.9,2756c2.8,0,5.4,1.5,6.8,3.9C2.2,2759.9-0.4,2758.4-1.9,2756L-1.9,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-2.8,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C2.3,2760.9-0.6,2760.3-2.8,2758.6L-2.8,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-2.8,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C2.8,2761.7-0.2,2762.2-2.8,2761.3L-2.8,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1.9,2763.9c1.4-2.4,4-3.9,6.8-3.9C3.5,2762.3,0.9,2763.8-1.9,2763.9L-1.9,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-0.1,2765.9c0.5-2.7,2.4-5,5-6C4.4,2762.7,2.5,2765-0.1,2765.9L-0.1,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M2.3,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C5.4,2762.7,4.4,2765.5,2.3,2767.3L2.3,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.9,2767.8c-1.4-2.4-1.4-5.4,0-7.8C6.3,2762.4,6.3,2765.4,4.9,2767.8L4.9,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M7.6,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C7,2761.7,8.1,2764.6,7.6,2767.3L7.6,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M10,2765.9c-2.6-1-4.5-3.3-5-6C7.5,2760.9,9.5,2763.2,10,2765.9L10,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M11.7,2763.9c-2.8,0-5.4-1.5-6.8-3.9C7.7,2760,10.3,2761.5,11.7,2763.9L11.7,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M12.6,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C7.5,2759,10.5,2759.5,12.6,2761.3L12.6,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M12.6,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C7.1,2758.2,10,2757.7,12.6,2758.6L12.6,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M11.7,2756c-1.4,2.4-4,3.9-6.8,3.9C6.3,2757.6,8.9,2756.1,11.7,2756L11.7,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M10,2753.9c-0.5,2.7-2.4,5-5,6C5.4,2757.2,7.4,2754.9,10,2753.9L10,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M7.6,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C4.5,2757.2,5.5,2754.4,7.6,2752.6L7.6,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 4.9,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 18.3,
    y1: 2764.9,
    x2: 18.3,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M18.4,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C26.4,2791.9,22.8,2786.3,18.4,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M18.3,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C19.6,2771.5,19,2771.7,18.3,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M12.4,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C13,2768.3,12.6,2767.8,12.4,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M18.3,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C19.6,2776.3,19,2776.5,18.3,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M12.4,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C13,2773.1,12.6,2772.5,12.4,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M18.3,2752.1c1.4,2.4,1.4,5.4,0,7.8C16.9,2757.5,17,2754.5,18.3,2752.1L18.3,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M15.6,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C16.2,2758.1,15.2,2755.3,15.6,2752.6L15.6,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M13.3,2753.9c2.6,1,4.5,3.3,5,6C15.7,2759,13.8,2756.7,13.3,2753.9L13.3,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M11.5,2756c2.8,0,5.4,1.5,6.8,3.9C15.5,2759.9,12.9,2758.4,11.5,2756L11.5,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M10.6,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C15.7,2760.9,12.7,2760.3,10.6,2758.6L10.6,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M10.6,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C16.2,2761.7,13.2,2762.2,10.6,2761.3L10.6,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M11.5,2763.9c1.4-2.4,4-3.9,6.8-3.9C16.9,2762.3,14.3,2763.8,11.5,2763.9L11.5,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M13.3,2765.9c0.5-2.7,2.4-5,5-6C17.8,2762.7,15.9,2765,13.3,2765.9L13.3,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M15.6,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C18.8,2762.7,17.7,2765.5,15.6,2767.3L15.6,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M18.3,2767.8c-1.4-2.4-1.4-5.4,0-7.8C19.7,2762.4,19.7,2765.4,18.3,2767.8L18.3,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M21,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C20.4,2761.7,21.4,2764.6,21,2767.3L21,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M23.4,2765.9c-2.6-1-4.5-3.3-5-6C20.9,2760.9,22.8,2763.2,23.4,2765.9L23.4,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M25.1,2763.9c-2.8,0-5.4-1.5-6.8-3.9C21.1,2760,23.7,2761.5,25.1,2763.9L25.1,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M26,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C20.9,2759,23.9,2759.5,26,2761.3L26,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M26,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C20.5,2758.2,23.4,2757.7,26,2758.6L26,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M25.1,2756c-1.4,2.4-4,3.9-6.8,3.9C19.7,2757.6,22.3,2756.1,25.1,2756L25.1,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M23.4,2753.9c-0.5,2.7-2.4,5-5,6C18.8,2757.2,20.8,2754.9,23.4,2753.9L23.4,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M21,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C17.9,2757.2,18.9,2754.4,21,2752.6L21,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 18.3,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 31.7,
    y1: 2764.9,
    x2: 31.7,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M31.7,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C39.8,2791.9,36.2,2786.3,31.7,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M31.6,2771.8c0.2-0.7,0.6-1.3,1-1.8c0.4-0.5,0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1S32.4,2771.7,31.6,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M25.8,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S26,2767.8,25.8,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M31.6,2776.6c0.2-0.7,0.6-1.3,1-1.8c0.4-0.5,0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1S32.4,2776.5,31.6,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M25.8,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S26,2772.5,25.8,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31.7,2752.1c1.4,2.4,1.4,5.4,0,7.8C30.3,2757.5,30.3,2754.5,31.7,2752.1L31.7,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M29,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C29.6,2758.1,28.6,2755.3,29,2752.6L29,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M26.7,2753.9c2.6,1,4.5,3.3,5,6C29.1,2759,27.2,2756.7,26.7,2753.9L26.7,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24.9,2756c2.8,0,5.4,1.5,6.8,3.9C28.9,2759.9,26.3,2758.4,24.9,2756L24.9,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C29.1,2760.9,26.1,2760.3,24,2758.6L24,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C29.6,2761.7,26.6,2762.2,24,2761.3L24,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24.9,2763.9c1.4-2.4,4-3.9,6.8-3.9C30.3,2762.3,27.7,2763.8,24.9,2763.9L24.9,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M26.7,2765.9c0.5-2.7,2.4-5,5-6C31.2,2762.7,29.3,2765,26.7,2765.9L26.7,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M29,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C32.2,2762.7,31.1,2765.5,29,2767.3L29,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31.7,2767.8c-1.4-2.4-1.4-5.4,0-7.8C33.1,2762.4,33.1,2765.4,31.7,2767.8L31.7,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M34.4,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C33.8,2761.7,34.8,2764.6,34.4,2767.3L34.4,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M36.7,2765.9c-2.6-1-4.5-3.3-5-6C34.3,2760.9,36.2,2763.2,36.7,2765.9L36.7,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.5,2763.9c-2.8,0-5.4-1.5-6.8-3.9C34.5,2760,37.1,2761.5,38.5,2763.9L38.5,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M39.4,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C34.3,2759,37.3,2759.5,39.4,2761.3L39.4,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M39.4,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C33.8,2758.2,36.8,2757.7,39.4,2758.6L39.4,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.5,2756c-1.4,2.4-4,3.9-6.8,3.9C33.1,2757.6,35.7,2756.1,38.5,2756L38.5,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M36.7,2753.9c-0.5,2.7-2.4,5-5,6C32.2,2757.2,34.1,2754.9,36.7,2753.9L36.7,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M34.4,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C31.2,2757.2,32.3,2754.4,34.4,2752.6L34.4,2752.6z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(2.415407e-03 -1 1 2.415407e-03 -2728.2683 2784.9336)",
    className: "st60",
    cx: 31.7,
    cy: 2759.9,
    rx: 3.9,
    ry: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 45.1,
    y1: 2764.9,
    x2: 45.1,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M45.1,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C53.2,2791.9,49.6,2786.3,45.1,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S45.8,2771.7,45,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M39.2,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C39.8,2768.3,39.4,2767.8,39.2,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S45.8,2776.5,45,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M39.2,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C39.8,2773.1,39.4,2772.5,39.2,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.1,2752.1c1.4,2.4,1.4,5.4,0,7.8C43.7,2757.5,43.7,2754.5,45.1,2752.1L45.1,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M42.4,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C43,2758.1,42,2755.3,42.4,2752.6L42.4,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M40.1,2753.9c2.6,1,4.5,3.3,5,6C42.5,2759,40.6,2756.7,40.1,2753.9L40.1,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.3,2756c2.8,0,5.4,1.5,6.8,3.9C42.3,2759.9,39.7,2758.4,38.3,2756L38.3,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M37.4,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C42.5,2760.9,39.5,2760.3,37.4,2758.6L37.4,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M37.4,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C42.9,2761.7,40,2762.2,37.4,2761.3L37.4,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.3,2763.9c1.4-2.4,4-3.9,6.8-3.9C43.7,2762.3,41.1,2763.8,38.3,2763.9L38.3,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M40.1,2765.9c0.5-2.7,2.4-5,5-6C44.6,2762.7,42.6,2765,40.1,2765.9L40.1,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M42.4,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C45.6,2762.7,44.5,2765.5,42.4,2767.3L42.4,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.1,2767.8c-1.4-2.4-1.4-5.4,0-7.8C46.5,2762.4,46.4,2765.4,45.1,2767.8L45.1,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M47.8,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C47.2,2761.7,48.2,2764.6,47.8,2767.3L47.8,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50.1,2765.9c-2.6-1-4.5-3.3-5-6C47.7,2760.9,49.6,2763.2,50.1,2765.9L50.1,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M51.9,2763.9c-2.8,0-5.4-1.5-6.8-3.9C47.9,2760,50.5,2761.5,51.9,2763.9L51.9,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.8,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C47.7,2759,50.7,2759.5,52.8,2761.3L52.8,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.8,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C47.2,2758.2,50.2,2757.7,52.8,2758.6L52.8,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M51.9,2756c-1.4,2.4-4,3.9-6.8,3.9C46.5,2757.6,49.1,2756.1,51.9,2756L51.9,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50.1,2753.9c-0.5,2.7-2.4,5-5,6C45.6,2757.2,47.5,2754.9,50.1,2753.9L50.1,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M47.8,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C44.6,2757.2,45.7,2754.4,47.8,2752.6L47.8,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 45.1,
    cy: 2759.9,
    r: 3.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 57.7,
    y1: 2764.9,
    x2: 57.7,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M57.8,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C65.8,2791.9,62.3,2786.3,57.8,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M57.7,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C59,2771.5,58.4,2771.7,57.7,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M51.8,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S52.1,2767.8,51.8,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M57.7,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C59,2776.3,58.4,2776.5,57.7,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M51.8,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S52.1,2772.5,51.8,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.7,2752.1c1.4,2.4,1.4,5.4,0,7.8C56.4,2757.5,56.4,2754.5,57.7,2752.1L57.7,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M55,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C55.6,2758.1,54.6,2755.3,55,2752.6L55,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.7,2753.9c2.6,1,4.5,3.3,5,6C55.1,2759,53.2,2756.7,52.7,2753.9L52.7,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50.9,2756c2.8,0,5.4,1.5,6.8,3.9C55,2759.9,52.4,2758.4,50.9,2756L50.9,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C55.1,2760.9,52.2,2760.3,50,2758.6L50,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C55.6,2761.7,52.6,2762.2,50,2761.3L50,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M50.9,2763.9c1.4-2.4,4-3.9,6.8-3.9C56.3,2762.3,53.7,2763.8,50.9,2763.9L50.9,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M52.7,2765.9c0.5-2.7,2.4-5,5-6C57.2,2762.7,55.3,2765,52.7,2765.9L52.7,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M55,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C58.2,2762.7,57.2,2765.5,55,2767.3L55,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.7,2767.8c-1.4-2.4-1.4-5.4,0-7.8C59.1,2762.4,59.1,2765.4,57.7,2767.8L57.7,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M60.4,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C59.8,2761.7,60.9,2764.6,60.4,2767.3L60.4,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M62.8,2765.9c-2.6-1-4.5-3.3-5-6C60.3,2760.9,62.3,2763.2,62.8,2765.9L62.8,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.5,2763.9c-2.8,0-5.4-1.5-6.8-3.9C60.5,2760,63.1,2761.5,64.5,2763.9L64.5,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.4,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C60.3,2759,63.3,2759.5,65.4,2761.3L65.4,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M65.4,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C59.9,2758.2,62.8,2757.7,65.4,2758.6L65.4,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.5,2756c-1.4,2.4-4,3.9-6.8,3.9C59.1,2757.6,61.7,2756.1,64.5,2756L64.5,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M62.8,2753.9c-0.5,2.7-2.4,5-5,6C58.2,2757.2,60.2,2754.9,62.8,2753.9L62.8,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M60.4,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C57.3,2757.2,58.3,2754.4,60.4,2752.6L60.4,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 57.7,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 71.1,
    y1: 2764.9,
    x2: 71.1,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M71.2,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C79.2,2791.9,75.6,2786.3,71.2,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M71.1,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C72.4,2771.5,71.8,2771.7,71.1,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M65.2,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C65.8,2768.3,65.4,2767.8,65.2,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M71.1,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C72.4,2776.3,71.8,2776.5,71.1,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M65.2,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C65.8,2773.1,65.4,2772.5,65.2,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M71.1,2752.1c1.4,2.4,1.4,5.4,0,7.8C69.7,2757.5,69.8,2754.5,71.1,2752.1L71.1,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M68.4,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C69,2758.1,68,2755.3,68.4,2752.6L68.4,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M66.1,2753.9c2.6,1,4.5,3.3,5,6C68.5,2759,66.6,2756.7,66.1,2753.9L66.1,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.3,2756c2.8,0,5.4,1.5,6.8,3.9C68.3,2759.9,65.7,2758.4,64.3,2756L64.3,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M63.4,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C68.5,2760.9,65.5,2760.3,63.4,2758.6L63.4,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M63.4,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C69,2761.7,66,2762.2,63.4,2761.3L63.4,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.3,2763.9c1.4-2.4,4-3.9,6.8-3.9C69.7,2762.3,67.1,2763.8,64.3,2763.9L64.3,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M66.1,2765.9c0.5-2.7,2.4-5,5-6C70.6,2762.7,68.7,2765,66.1,2765.9L66.1,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M68.4,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C71.6,2762.7,70.5,2765.5,68.4,2767.3L68.4,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M71.1,2767.8c-1.4-2.4-1.4-5.4,0-7.8C72.5,2762.4,72.5,2765.4,71.1,2767.8L71.1,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M73.8,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C73.2,2761.7,74.2,2764.6,73.8,2767.3L73.8,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M76.2,2765.9c-2.6-1-4.5-3.3-5-6C73.7,2760.9,75.6,2763.2,76.2,2765.9L76.2,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.9,2763.9c-2.8,0-5.4-1.5-6.8-3.9C73.9,2760,76.5,2761.5,77.9,2763.9L77.9,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.8,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C73.7,2759,76.7,2759.5,78.8,2761.3L78.8,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.8,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C73.3,2758.2,76.2,2757.7,78.8,2758.6L78.8,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.9,2756c-1.4,2.4-4,3.9-6.8,3.9C72.5,2757.6,75.1,2756.1,77.9,2756L77.9,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M76.2,2753.9c-0.5,2.7-2.4,5-5,6C71.6,2757.2,73.6,2754.9,76.2,2753.9L76.2,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M73.8,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C70.7,2757.2,71.7,2754.4,73.8,2752.6L73.8,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 71.1,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 84.5,
    y1: 2764.9,
    x2: 84.5,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M84.5,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C92.6,2791.9,89,2786.3,84.5,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M84.4,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S85.2,2771.7,84.4,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M78.6,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S78.8,2767.8,78.6,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M84.4,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S85.2,2776.5,84.4,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M78.6,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S78.8,2772.5,78.6,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.5,2752.1c1.4,2.4,1.4,5.4,0,7.8C83.1,2757.5,83.1,2754.5,84.5,2752.1L84.5,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M81.8,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C82.4,2758.1,81.4,2755.3,81.8,2752.6L81.8,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M79.5,2753.9c2.6,1,4.5,3.3,5,6C81.9,2759,80,2756.7,79.5,2753.9L79.5,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.7,2756c2.8,0,5.4,1.5,6.8,3.9C81.7,2759.9,79.1,2758.4,77.7,2756L77.7,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M76.8,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C81.9,2760.9,78.9,2760.3,76.8,2758.6L76.8,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M76.8,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C82.4,2761.7,79.4,2762.2,76.8,2761.3L76.8,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.7,2763.9c1.4-2.4,4-3.9,6.8-3.9C83.1,2762.3,80.5,2763.8,77.7,2763.9L77.7,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M79.5,2765.9c0.5-2.7,2.4-5,5-6C84,2762.7,82.1,2765,79.5,2765.9L79.5,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M81.8,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C85,2762.7,83.9,2765.5,81.8,2767.3L81.8,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.5,2767.8c-1.4-2.4-1.4-5.4,0-7.8C85.9,2762.4,85.9,2765.4,84.5,2767.8L84.5,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M87.2,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C86.6,2761.7,87.6,2764.6,87.2,2767.3L87.2,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M89.5,2765.9c-2.6-1-4.5-3.3-5-6C87.1,2760.9,89,2763.2,89.5,2765.9L89.5,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.3,2763.9c-2.8,0-5.4-1.5-6.8-3.9C87.3,2760,89.9,2761.5,91.3,2763.9L91.3,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.2,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C87.1,2759,90.1,2759.5,92.2,2761.3L92.2,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.2,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C86.6,2758.2,89.6,2757.7,92.2,2758.6L92.2,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.3,2756c-1.4,2.4-4,3.9-6.8,3.9C85.9,2757.6,88.5,2756.1,91.3,2756L91.3,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M89.5,2753.9c-0.5,2.7-2.4,5-5,6C85,2757.2,86.9,2754.9,89.5,2753.9L89.5,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M87.2,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C84,2757.2,85.1,2754.4,87.2,2752.6L87.2,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 84.5,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 97.9,
    y1: 2764.9,
    x2: 97.9,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M97.9,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H109c0.4,0,0.6-0.5,0.2-0.7 C106,2791.9,102.4,2786.3,97.9,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M97.8,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C99.2,2771.5,98.6,2771.7,97.8,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S92.2,2767.8,92,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M97.8,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C99.2,2776.3,98.6,2776.5,97.8,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M92,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S92.2,2772.5,92,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.9,2752.1c1.4,2.4,1.4,5.4,0,7.8C96.5,2757.5,96.5,2754.5,97.9,2752.1L97.9,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M95.2,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C95.8,2758.1,94.8,2755.3,95.2,2752.6L95.2,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.9,2753.9c2.6,1,4.5,3.3,5,6C95.3,2759,93.4,2756.7,92.9,2753.9L92.9,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.1,2756c2.8,0,5.4,1.5,6.8,3.9C95.1,2759.9,92.5,2758.4,91.1,2756L91.1,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M90.2,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C95.3,2760.9,92.3,2760.3,90.2,2758.6L90.2,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M90.2,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C95.7,2761.7,92.8,2762.2,90.2,2761.3L90.2,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.1,2763.9c1.4-2.4,4-3.9,6.8-3.9C96.5,2762.3,93.9,2763.8,91.1,2763.9L91.1,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M92.9,2765.9c0.5-2.7,2.4-5,5-6C97.4,2762.7,95.4,2765,92.9,2765.9L92.9,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M95.2,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C98.3,2762.7,97.3,2765.5,95.2,2767.3L95.2,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.9,2767.8c-1.4-2.4-1.4-5.4,0-7.8C99.3,2762.4,99.2,2765.4,97.9,2767.8L97.9,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M100.6,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C100,2761.7,101,2764.6,100.6,2767.3L100.6,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M102.9,2765.9c-2.6-1-4.5-3.3-5-6C100.5,2760.9,102.4,2763.2,102.9,2765.9L102.9,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.7,2763.9c-2.8,0-5.4-1.5-6.8-3.9C100.7,2760,103.3,2761.5,104.7,2763.9L104.7,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M105.6,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C100.5,2759,103.5,2759.5,105.6,2761.3L105.6,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M105.6,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C100,2758.2,103,2757.7,105.6,2758.6L105.6,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.7,2756c-1.4,2.4-4,3.9-6.8,3.9C99.3,2757.6,101.9,2756.1,104.7,2756L104.7,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M102.9,2753.9c-0.5,2.7-2.4,5-5,6C98.4,2757.2,100.3,2754.9,102.9,2753.9L102.9,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M100.6,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C97.4,2757.2,98.5,2754.4,100.6,2752.6L100.6,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 97.9,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 111.3,
    y1: 2764.9,
    x2: 111.3,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M111.3,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C119.3,2791.9,115.8,2786.3,111.3,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M111.2,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S112,2771.7,111.2,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.4,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S105.6,2767.8,105.4,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M111.2,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S112,2776.5,111.2,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.4,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S105.6,2772.5,105.4,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.3,2752.1c1.4,2.4,1.4,5.4,0,7.8C109.9,2757.5,109.9,2754.5,111.3,2752.1L111.3,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M108.6,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C109.2,2758.1,108.1,2755.3,108.6,2752.6L108.6,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M106.2,2753.9c2.6,1,4.5,3.3,5,6C108.7,2759,106.7,2756.7,106.2,2753.9L106.2,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.5,2756c2.8,0,5.4,1.5,6.8,3.9C108.5,2759.9,105.9,2758.4,104.5,2756L104.5,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M103.6,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C108.7,2760.9,105.7,2760.3,103.6,2758.6L103.6,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M103.6,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C109.1,2761.7,106.2,2762.2,103.6,2761.3L103.6,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.5,2763.9c1.4-2.4,4-3.9,6.8-3.9C109.9,2762.3,107.3,2763.8,104.5,2763.9L104.5,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M106.2,2765.9c0.5-2.7,2.4-5,5-6C110.8,2762.7,108.8,2765,106.2,2765.9L106.2,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M108.6,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C111.7,2762.7,110.7,2765.5,108.6,2767.3L108.6,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.3,2767.8c-1.4-2.4-1.4-5.4,0-7.8C112.6,2762.4,112.6,2765.4,111.3,2767.8L111.3,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M114,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C113.4,2761.7,114.4,2764.6,114,2767.3L114,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M116.3,2765.9c-2.6-1-4.5-3.3-5-6C113.9,2760.9,115.8,2763.2,116.3,2765.9L116.3,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.1,2763.9c-2.8,0-5.4-1.5-6.8-3.9C114,2760,116.6,2761.5,118.1,2763.9L118.1,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M119,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C113.9,2759,116.8,2759.5,119,2761.3L119,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M119,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C113.4,2758.2,116.4,2757.7,119,2758.6L119,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M118.1,2756c-1.4,2.4-4,3.9-6.8,3.9C112.7,2757.6,115.3,2756.1,118.1,2756L118.1,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M116.3,2753.9c-0.5,2.7-2.4,5-5,6C111.8,2757.2,113.7,2754.9,116.3,2753.9L116.3,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M114,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C110.8,2757.2,111.8,2754.4,114,2752.6L114,2752.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 111.3,
    cy: 2759.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 124.6,
    y1: 2764.9,
    x2: 124.6,
    y2: 2786.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M124.7,2786.3c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C132.7,2791.9,129.2,2786.3,124.7,2786.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M124.6,2771.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1S125.4,2771.7,124.6,2771.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M118.8,2767c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C119.3,2768.3,119,2767.8,118.8,2767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M124.6,2776.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1S125.4,2776.5,124.6,2776.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M118.8,2771.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C119.3,2773.1,119,2772.5,118.8,2771.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.7,2752.1c1.4,2.4,1.4,5.4,0,7.8C123.3,2757.5,123.3,2754.5,124.7,2752.1L124.7,2752.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M122,2752.6c2.1,1.8,3.1,4.6,2.7,7.4C122.5,2758.1,121.5,2755.3,122,2752.6L122,2752.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M119.6,2753.9c2.6,1,4.5,3.3,5,6C122.1,2759,120.1,2756.7,119.6,2753.9L119.6,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M117.9,2756c2.8,0,5.4,1.5,6.8,3.9C121.9,2759.9,119.3,2758.4,117.9,2756L117.9,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M116.9,2758.6c2.6-0.9,5.6-0.4,7.7,1.4C122,2760.9,119.1,2760.3,116.9,2758.6L116.9,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M116.9,2761.3c2.1-1.8,5.1-2.3,7.7-1.4C122.5,2761.7,119.6,2762.2,116.9,2761.3L116.9,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M117.9,2763.9c1.4-2.4,4-3.9,6.8-3.9C123.3,2762.3,120.6,2763.8,117.9,2763.9L117.9,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M119.6,2765.9c0.5-2.7,2.4-5,5-6C124.2,2762.7,122.2,2765,119.6,2765.9L119.6,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M122,2767.3c-0.5-2.7,0.6-5.6,2.7-7.4C125.1,2762.7,124.1,2765.5,122,2767.3L122,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.7,2767.8c-1.4-2.4-1.4-5.4,0-7.8C126,2762.4,126,2765.4,124.7,2767.8L124.7,2767.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M127.3,2767.3c-2.1-1.8-3.1-4.6-2.7-7.4C126.8,2761.7,127.8,2764.6,127.3,2767.3L127.3,2767.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M129.7,2765.9c-2.6-1-4.5-3.3-5-6C127.3,2760.9,129.2,2763.2,129.7,2765.9L129.7,2765.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.4,2763.9c-2.8,0-5.4-1.5-6.8-3.9C127.4,2760,130,2761.5,131.4,2763.9L131.4,2763.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M132.4,2761.3c-2.6,0.9-5.6,0.4-7.7-1.4C127.3,2759,130.2,2759.5,132.4,2761.3L132.4,2761.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M132.4,2758.6c-2.1,1.8-5.1,2.3-7.7,1.4C126.8,2758.2,129.8,2757.7,132.4,2758.6L132.4,2758.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.4,2756c-1.4,2.4-4,3.9-6.8,3.9C126.1,2757.6,128.7,2756.1,131.4,2756L131.4,2756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M129.7,2753.9c-0.5,2.7-2.4,5-5,6C125.2,2757.2,127.1,2754.9,129.7,2753.9L129.7,2753.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M127.3,2752.6c0.5,2.7-0.6,5.6-2.7,7.4C124.2,2757.2,125.2,2754.4,127.3,2752.6L127.3,2752.6z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020237e-02 1.020237e-02 0.9999 -28.151 1.4159)",
    className: "st60",
    cx: 124.7,
    cy: 2759.9,
    rx: 3.9,
    ry: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: -1.9,
    y1: 2775.6,
    x2: -1.9,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1.8,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11c0.4,0,0.6-0.5,0.2-0.7 C6.2,2802.6,2.7,2797-1.8,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1.9,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S-1.2,2782.5-1.9,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-7.8,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S-7.5,2778.5-7.8,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-1.9,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S-1.2,2787.3-1.9,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-7.8,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C-7.2,2783.8-7.5,2783.3-7.8,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1.9,2762.9c1.4,2.4,1.4,5.4,0,7.8C-3.2,2768.3-3.2,2765.3-1.9,2762.9L-1.9,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-4.5,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C-4,2768.9-5,2766.1-4.5,2763.3L-4.5,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-6.9,2764.7c2.6,1,4.5,3.3,5,6C-4.5,2769.7-6.4,2767.4-6.9,2764.7L-6.9,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-8.6,2766.8c2.8,0,5.4,1.5,6.8,3.9C-4.6,2770.7-7.2,2769.2-8.6,2766.8L-8.6,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-9.6,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C-4.5,2771.6-7.4,2771.1-9.6,2769.3L-9.6,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-9.6,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C-4,2772.5-7,2773-9.6,2772.1L-9.6,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-8.6,2774.6c1.4-2.4,4-3.9,6.8-3.9C-3.3,2773.1-5.9,2774.6-8.6,2774.6L-8.6,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-6.9,2776.7c0.5-2.7,2.4-5,5-6C-2.4,2773.4-4.3,2775.7-6.9,2776.7L-6.9,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-4.5,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C-1.4,2773.4-2.4,2776.3-4.5,2778.1L-4.5,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1.9,2778.5c-1.4-2.4-1.4-5.4,0-7.8C-0.5,2773.1-0.5,2776.1-1.9,2778.5L-1.9,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M0.8,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C0.3,2772.5,1.3,2775.3,0.8,2778.1L0.8,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M3.2,2776.7c-2.6-1-4.5-3.3-5-6C0.7,2771.7,2.7,2774,3.2,2776.7L3.2,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.9,2774.6c-2.8,0-5.4-1.5-6.8-3.9C0.9,2770.7,3.5,2772.2,4.9,2774.6L4.9,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M5.9,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C0.8,2769.8,3.7,2770.3,5.9,2772.1L5.9,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M5.9,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C0.3,2768.9,3.2,2768.4,5.9,2769.3L5.9,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.9,2766.8c-1.4,2.4-4,3.9-6.8,3.9C-0.4,2768.3,2.2,2766.8,4.9,2766.8L4.9,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M3.2,2764.7c-0.5,2.7-2.4,5-5,6C-1.4,2768,0.6,2765.7,3.2,2764.7L3.2,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M0.8,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C-2.3,2768-1.3,2765.1,0.8,2763.3L0.8,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: -1.9,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 11.5,
    y1: 2775.6,
    x2: 11.5,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M11.6,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C19.6,2802.6,16.1,2797,11.6,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M11.5,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1C12.9,2782.3,12.2,2782.5,11.5,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M5.6,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C6.2,2779.1,5.9,2778.5,5.6,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M11.5,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1C12.9,2787,12.2,2787.3,11.5,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M5.6,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C6.2,2783.8,5.9,2783.3,5.6,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M11.5,2762.9c1.4,2.4,1.4,5.4,0,7.8C10.2,2768.3,10.2,2765.3,11.5,2762.9L11.5,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M8.9,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C9.4,2768.9,8.4,2766.1,8.9,2763.3L8.9,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M6.5,2764.7c2.6,1,4.5,3.3,5,6C8.9,2769.7,7,2767.4,6.5,2764.7L6.5,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.7,2766.8c2.8,0,5.4,1.5,6.8,3.9C8.8,2770.7,6.2,2769.2,4.7,2766.8L4.7,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M3.8,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C8.9,2771.6,6,2771.1,3.8,2769.3L3.8,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M3.8,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C9.4,2772.5,6.4,2773,3.8,2772.1L3.8,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M4.7,2774.6c1.4-2.4,4-3.9,6.8-3.9C10.1,2773.1,7.5,2774.6,4.7,2774.6L4.7,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M6.5,2776.7c0.5-2.7,2.4-5,5-6C11,2773.4,9.1,2775.7,6.5,2776.7L6.5,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M8.9,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C12,2773.4,11,2776.3,8.9,2778.1L8.9,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M11.5,2778.5c-1.4-2.4-1.4-5.4,0-7.8C12.9,2773.1,12.9,2776.1,11.5,2778.5L11.5,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M14.2,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C13.6,2772.5,14.7,2775.3,14.2,2778.1L14.2,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M16.6,2776.7c-2.6-1-4.5-3.3-5-6C14.1,2771.7,16.1,2774,16.6,2776.7L16.6,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M18.3,2774.6c-2.8,0-5.4-1.5-6.8-3.9C14.3,2770.7,16.9,2772.2,18.3,2774.6L18.3,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M19.2,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C14.1,2769.8,17.1,2770.3,19.2,2772.1L19.2,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M19.2,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C13.7,2768.9,16.6,2768.4,19.2,2769.3L19.2,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M18.3,2766.8c-1.4,2.4-4,3.9-6.8,3.9C12.9,2768.3,15.5,2766.8,18.3,2766.8L18.3,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M16.6,2764.7c-0.5,2.7-2.4,5-5,6C12,2768,14,2765.7,16.6,2764.7L16.6,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M14.2,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C11.1,2768,12.1,2765.1,14.2,2763.3L14.2,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 11.5,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 24.9,
    y1: 2775.6,
    x2: 24.9,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M25,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H25h11c0.4,0,0.6-0.5,0.2-0.7 C33,2802.6,29.4,2797,25,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M24.9,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C26.2,2782.3,25.6,2782.5,24.9,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M19,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S19.2,2778.5,19,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M24.9,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C26.2,2787,25.6,2787.3,24.9,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M19,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C19.6,2783.8,19.2,2783.3,19,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24.9,2762.9c1.4,2.4,1.4,5.4,0,7.8C23.5,2768.3,23.6,2765.3,24.9,2762.9L24.9,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M22.2,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C22.8,2768.9,21.8,2766.1,22.2,2763.3L22.2,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M19.9,2764.7c2.6,1,4.5,3.3,5,6C22.3,2769.7,20.4,2767.4,19.9,2764.7L19.9,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M18.1,2766.8c2.8,0,5.4,1.5,6.8,3.9C22.1,2770.7,19.5,2769.2,18.1,2766.8L18.1,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M17.2,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C22.3,2771.6,19.3,2771.1,17.2,2769.3L17.2,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M17.2,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C22.8,2772.5,19.8,2773,17.2,2772.1L17.2,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M18.1,2774.6c1.4-2.4,4-3.9,6.8-3.9C23.5,2773.1,20.9,2774.6,18.1,2774.6L18.1,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M19.9,2776.7c0.5-2.7,2.4-5,5-6C24.4,2773.4,22.5,2775.7,19.9,2776.7L19.9,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M22.2,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C25.4,2773.4,24.3,2776.3,22.2,2778.1L22.2,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M24.9,2778.5c-1.4-2.4-1.4-5.4,0-7.8C26.3,2773.1,26.3,2776.1,24.9,2778.5L24.9,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M27.6,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C27,2772.5,28,2775.3,27.6,2778.1L27.6,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M30,2776.7c-2.6-1-4.5-3.3-5-6C27.5,2771.7,29.4,2774,30,2776.7L30,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31.7,2774.6c-2.8,0-5.4-1.5-6.8-3.9C27.7,2770.7,30.3,2772.2,31.7,2774.6L31.7,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M32.6,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C27.5,2769.8,30.5,2770.3,32.6,2772.1L32.6,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M32.6,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C27.1,2768.9,30,2768.4,32.6,2769.3L32.6,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31.7,2766.8c-1.4,2.4-4,3.9-6.8,3.9C26.3,2768.3,28.9,2766.8,31.7,2766.8L31.7,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M30,2764.7c-0.5,2.7-2.4,5-5,6C25.4,2768,27.4,2765.7,30,2764.7L30,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M27.6,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C24.5,2768,25.5,2765.1,27.6,2763.3L27.6,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 24.9,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 38.3,
    y1: 2775.6,
    x2: 38.3,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M38.3,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C46.4,2802.6,42.8,2797,38.3,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M38.2,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C39.6,2782.3,39,2782.5,38.2,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.4,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C33,2779.1,32.6,2778.5,32.4,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M38.2,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C39.6,2787,39,2787.3,38.2,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.4,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C33,2783.8,32.6,2783.3,32.4,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.3,2762.9c1.4,2.4,1.4,5.4,0,7.8C36.9,2768.3,36.9,2765.3,38.3,2762.9L38.3,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M35.6,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C36.2,2768.9,35.2,2766.1,35.6,2763.3L35.6,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M33.3,2764.7c2.6,1,4.5,3.3,5,6C35.7,2769.7,33.8,2767.4,33.3,2764.7L33.3,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31.5,2766.8c2.8,0,5.4,1.5,6.8,3.9C35.5,2770.7,32.9,2769.2,31.5,2766.8L31.5,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M30.6,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C35.7,2771.6,32.7,2771.1,30.6,2769.3L30.6,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M30.6,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C36.2,2772.5,33.2,2773,30.6,2772.1L30.6,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M31.5,2774.6c1.4-2.4,4-3.9,6.8-3.9C36.9,2773.1,34.3,2774.6,31.5,2774.6L31.5,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M33.3,2776.7c0.5-2.7,2.4-5,5-6C37.8,2773.4,35.9,2775.7,33.3,2776.7L33.3,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M35.6,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C38.8,2773.4,37.7,2776.3,35.6,2778.1L35.6,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.3,2778.5c-1.4-2.4-1.4-5.4,0-7.8C39.7,2773.1,39.7,2776.1,38.3,2778.5L38.3,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M41,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C40.4,2772.5,41.4,2775.3,41,2778.1L41,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M43.3,2776.7c-2.6-1-4.5-3.3-5-6C40.9,2771.7,42.8,2774,43.3,2776.7L43.3,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.1,2774.6c-2.8,0-5.4-1.5-6.8-3.9C41.1,2770.7,43.7,2772.2,45.1,2774.6L45.1,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M46,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C40.9,2769.8,43.9,2770.3,46,2772.1L46,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M46,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C40.4,2768.9,43.4,2768.4,46,2769.3L46,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M45.1,2766.8c-1.4,2.4-4,3.9-6.8,3.9C39.7,2768.3,42.3,2766.8,45.1,2766.8L45.1,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M43.3,2764.7c-0.5,2.7-2.4,5-5,6C38.8,2768,40.7,2765.7,43.3,2764.7L43.3,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M41,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C37.8,2768,38.9,2765.1,41,2763.3L41,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 38.3,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 51.7,
    y1: 2775.6,
    x2: 51.7,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M51.7,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C59.8,2802.6,56.2,2797,51.7,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M51.6,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S52.4,2782.5,51.6,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45.8,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S46,2778.5,45.8,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M51.6,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S52.4,2787.3,51.6,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M45.8,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C46.4,2783.8,46,2783.3,45.8,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M51.7,2762.9c1.4,2.4,1.4,5.4,0,7.8C50.3,2768.3,50.3,2765.3,51.7,2762.9L51.7,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M49,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C49.6,2768.9,48.6,2766.1,49,2763.3L49,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M46.7,2764.7c2.6,1,4.5,3.3,5,6C49.1,2769.7,47.2,2767.4,46.7,2764.7L46.7,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M44.9,2766.8c2.8,0,5.4,1.5,6.8,3.9C48.9,2770.7,46.3,2769.2,44.9,2766.8L44.9,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M44,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C49.1,2771.6,46.1,2771.1,44,2769.3L44,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M44,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C49.5,2772.5,46.6,2773,44,2772.1L44,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M44.9,2774.6c1.4-2.4,4-3.9,6.8-3.9C50.3,2773.1,47.7,2774.6,44.9,2774.6L44.9,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M46.7,2776.7c0.5-2.7,2.4-5,5-6C51.2,2773.4,49.2,2775.7,46.7,2776.7L46.7,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M49,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C52.1,2773.4,51.1,2776.3,49,2778.1L49,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M51.7,2778.5c-1.4-2.4-1.4-5.4,0-7.8C53.1,2773.1,53,2776.1,51.7,2778.5L51.7,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M54.4,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C53.8,2772.5,54.8,2775.3,54.4,2778.1L54.4,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M56.7,2776.7c-2.6-1-4.5-3.3-5-6C54.3,2771.7,56.2,2774,56.7,2776.7L56.7,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.5,2774.6c-2.8,0-5.4-1.5-6.8-3.9C54.5,2770.7,57.1,2772.2,58.5,2774.6L58.5,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M59.4,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C54.3,2769.8,57.3,2770.3,59.4,2772.1L59.4,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M59.4,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C53.8,2768.9,56.8,2768.4,59.4,2769.3L59.4,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M58.5,2766.8c-1.4,2.4-4,3.9-6.8,3.9C53.1,2768.3,55.7,2766.8,58.5,2766.8L58.5,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M56.7,2764.7c-0.5,2.7-2.4,5-5,6C52.2,2768,54.1,2765.7,56.7,2764.7L56.7,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M54.4,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C51.2,2768,52.3,2765.1,54.4,2763.3L54.4,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 51.7,
    cy: 2770.7,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 64.3,
    y1: 2775.6,
    x2: 64.3,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M64.4,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C72.4,2802.6,68.9,2797,64.4,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M64.3,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C65.6,2782.3,65,2782.5,64.3,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M58.4,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C59,2779.1,58.7,2778.5,58.4,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M64.3,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C65.6,2787,65,2787.3,64.3,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M58.4,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C59,2783.8,58.7,2783.3,58.4,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.3,2762.9c1.4,2.4,1.4,5.4,0,7.8C63,2768.3,63,2765.3,64.3,2762.9L64.3,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M61.6,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C62.2,2768.9,61.2,2766.1,61.6,2763.3L61.6,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M59.3,2764.7c2.6,1,4.5,3.3,5,6C61.7,2769.7,59.8,2767.4,59.3,2764.7L59.3,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.5,2766.8c2.8,0,5.4,1.5,6.8,3.9C61.6,2770.7,59,2769.2,57.5,2766.8L57.5,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M56.6,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C61.7,2771.6,58.8,2771.1,56.6,2769.3L56.6,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M56.6,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C62.2,2772.5,59.2,2773,56.6,2772.1L56.6,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M57.5,2774.6c1.4-2.4,4-3.9,6.8-3.9C62.9,2773.1,60.3,2774.6,57.5,2774.6L57.5,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M59.3,2776.7c0.5-2.7,2.4-5,5-6C63.8,2773.4,61.9,2775.7,59.3,2776.7L59.3,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M61.6,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C64.8,2773.4,63.8,2776.3,61.6,2778.1L61.6,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M64.3,2778.5c-1.4-2.4-1.4-5.4,0-7.8C65.7,2773.1,65.7,2776.1,64.3,2778.5L64.3,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M67,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C66.4,2772.5,67.5,2775.3,67,2778.1L67,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M69.4,2776.7c-2.6-1-4.5-3.3-5-6C66.9,2771.7,68.9,2774,69.4,2776.7L69.4,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M71.1,2774.6c-2.8,0-5.4-1.5-6.8-3.9C67.1,2770.7,69.7,2772.2,71.1,2774.6L71.1,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C66.9,2769.8,69.9,2770.3,72,2772.1L72,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C66.5,2768.9,69.4,2768.4,72,2769.3L72,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M71.1,2766.8c-1.4,2.4-4,3.9-6.8,3.9C65.7,2768.3,68.3,2766.8,71.1,2766.8L71.1,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M69.4,2764.7c-0.5,2.7-2.4,5-5,6C64.8,2768,66.8,2765.7,69.4,2764.7L69.4,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M67,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C63.9,2768,64.9,2765.1,67,2763.3L67,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 64.3,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 77.7,
    y1: 2775.6,
    x2: 77.7,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M77.8,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C85.8,2802.6,82.2,2797,77.8,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M77.7,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C79,2782.3,78.4,2782.5,77.7,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M71.8,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S72,2778.5,71.8,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M77.7,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C79,2787,78.4,2787.3,77.7,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M71.8,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C72.4,2783.8,72,2783.3,71.8,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.7,2762.9c1.4,2.4,1.4,5.4,0,7.8C76.3,2768.3,76.4,2765.3,77.7,2762.9L77.7,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M75,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C75.6,2768.9,74.6,2766.1,75,2763.3L75,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.7,2764.7c2.6,1,4.5,3.3,5,6C75.1,2769.7,73.2,2767.4,72.7,2764.7L72.7,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M70.9,2766.8c2.8,0,5.4,1.5,6.8,3.9C74.9,2770.7,72.3,2769.2,70.9,2766.8L70.9,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M70,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C75.1,2771.6,72.1,2771.1,70,2769.3L70,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M70,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C75.6,2772.5,72.6,2773,70,2772.1L70,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M70.9,2774.6c1.4-2.4,4-3.9,6.8-3.9C76.3,2773.1,73.7,2774.6,70.9,2774.6L70.9,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M72.7,2776.7c0.5-2.7,2.4-5,5-6C77.2,2773.4,75.3,2775.7,72.7,2776.7L72.7,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M75,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C78.2,2773.4,77.1,2776.3,75,2778.1L75,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M77.7,2778.5c-1.4-2.4-1.4-5.4,0-7.8C79.1,2773.1,79.1,2776.1,77.7,2778.5L77.7,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M80.4,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C79.8,2772.5,80.8,2775.3,80.4,2778.1L80.4,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M82.7,2776.7c-2.6-1-4.5-3.3-5-6C80.3,2771.7,82.2,2774,82.7,2776.7L82.7,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.5,2774.6c-2.8,0-5.4-1.5-6.8-3.9C80.5,2770.7,83.1,2772.2,84.5,2774.6L84.5,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.4,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C80.3,2769.8,83.3,2770.3,85.4,2772.1L85.4,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M85.4,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C79.9,2768.9,82.8,2768.4,85.4,2769.3L85.4,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.5,2766.8c-1.4,2.4-4,3.9-6.8,3.9C79.1,2768.3,81.7,2766.8,84.5,2766.8L84.5,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M82.7,2764.7c-0.5,2.7-2.4,5-5,6C78.2,2768,80.2,2765.7,82.7,2764.7L82.7,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M80.4,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C77.3,2768,78.3,2765.1,80.4,2763.3L80.4,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 77.7,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 91.1,
    y1: 2775.6,
    x2: 91.1,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M91.1,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C99.2,2802.6,95.6,2797,91.1,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M91,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S91.8,2782.5,91,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M85.2,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C85.8,2779.1,85.4,2778.5,85.2,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M91,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S91.8,2787.3,91,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M85.2,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C85.8,2783.8,85.4,2783.3,85.2,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.1,2762.9c1.4,2.4,1.4,5.4,0,7.8C89.7,2768.3,89.7,2765.3,91.1,2762.9L91.1,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M88.4,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C89,2768.9,88,2766.1,88.4,2763.3L88.4,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M86.1,2764.7c2.6,1,4.5,3.3,5,6C88.5,2769.7,86.6,2767.4,86.1,2764.7L86.1,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.3,2766.8c2.8,0,5.4,1.5,6.8,3.9C88.3,2770.7,85.7,2769.2,84.3,2766.8L84.3,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M83.4,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C88.5,2771.6,85.5,2771.1,83.4,2769.3L83.4,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M83.4,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C89,2772.5,86,2773,83.4,2772.1L83.4,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M84.3,2774.6c1.4-2.4,4-3.9,6.8-3.9C89.7,2773.1,87.1,2774.6,84.3,2774.6L84.3,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M86.1,2776.7c0.5-2.7,2.4-5,5-6C90.6,2773.4,88.7,2775.7,86.1,2776.7L86.1,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M88.4,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C91.6,2773.4,90.5,2776.3,88.4,2778.1L88.4,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M91.1,2778.5c-1.4-2.4-1.4-5.4,0-7.8C92.5,2773.1,92.5,2776.1,91.1,2778.5L91.1,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M93.8,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C93.2,2772.5,94.2,2775.3,93.8,2778.1L93.8,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M96.1,2776.7c-2.6-1-4.5-3.3-5-6C93.7,2771.7,95.6,2774,96.1,2776.7L96.1,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.9,2774.6c-2.8,0-5.4-1.5-6.8-3.9C93.9,2770.7,96.5,2772.2,97.9,2774.6L97.9,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M98.8,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C93.7,2769.8,96.7,2770.3,98.8,2772.1L98.8,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M98.8,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C93.2,2768.9,96.2,2768.4,98.8,2769.3L98.8,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.9,2766.8c-1.4,2.4-4,3.9-6.8,3.9C92.5,2768.3,95.1,2766.8,97.9,2766.8L97.9,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M96.1,2764.7c-0.5,2.7-2.4,5-5,6C91.6,2768,93.5,2765.7,96.1,2764.7L96.1,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M93.8,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C90.6,2768,91.7,2765.1,93.8,2763.3L93.8,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 91.1,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 104.5,
    y1: 2775.6,
    x2: 104.5,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M104.5,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C112.5,2802.6,109,2797,104.5,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.4,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S105.2,2782.5,104.4,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M98.6,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S98.8,2778.5,98.6,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M104.4,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S105.2,2787.3,104.4,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M98.6,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C99.2,2783.8,98.8,2783.3,98.6,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.5,2762.9c1.4,2.4,1.4,5.4,0,7.8C103.1,2768.3,103.1,2765.3,104.5,2762.9L104.5,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M101.8,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C102.4,2768.9,101.4,2766.1,101.8,2763.3L101.8,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M99.4,2764.7c2.6,1,4.5,3.3,5,6C101.9,2769.7,100,2767.4,99.4,2764.7L99.4,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.7,2766.8c2.8,0,5.4,1.5,6.8,3.9C101.7,2770.7,99.1,2769.2,97.7,2766.8L97.7,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M96.8,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C101.9,2771.6,98.9,2771.1,96.8,2769.3L96.8,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M96.8,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C102.3,2772.5,99.4,2773,96.8,2772.1L96.8,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M97.7,2774.6c1.4-2.4,4-3.9,6.8-3.9C103.1,2773.1,100.5,2774.6,97.7,2774.6L97.7,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M99.4,2776.7c0.5-2.7,2.4-5,5-6C104,2773.4,102,2775.7,99.4,2776.7L99.4,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M101.8,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C104.9,2773.4,103.9,2776.3,101.8,2778.1L101.8,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M104.5,2778.5c-1.4-2.4-1.4-5.4,0-7.8C105.9,2773.1,105.8,2776.1,104.5,2778.5L104.5,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M107.2,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C106.6,2772.5,107.6,2775.3,107.2,2778.1L107.2,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M109.5,2776.7c-2.6-1-4.5-3.3-5-6C107.1,2771.7,109,2774,109.5,2776.7L109.5,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.3,2774.6c-2.8,0-5.4-1.5-6.8-3.9C107.3,2770.7,109.9,2772.2,111.3,2774.6L111.3,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M112.2,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C107.1,2769.8,110.1,2770.3,112.2,2772.1L112.2,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M112.2,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C106.6,2768.9,109.6,2768.4,112.2,2769.3L112.2,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.3,2766.8c-1.4,2.4-4,3.9-6.8,3.9C105.9,2768.3,108.5,2766.8,111.3,2766.8L111.3,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M109.5,2764.7c-0.5,2.7-2.4,5-5,6C105,2768,106.9,2765.7,109.5,2764.7L109.5,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M107.2,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C104,2768,105.1,2765.1,107.2,2763.3L107.2,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 104.5,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 117.9,
    y1: 2775.6,
    x2: 117.9,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M117.9,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H129c0.4,0,0.6-0.5,0.2-0.7 C125.9,2802.6,122.4,2797,117.9,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M117.8,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C119.2,2782.3,118.6,2782.5,117.8,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M112,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S112.2,2778.5,112,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M117.8,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C119.2,2787,118.6,2787.3,117.8,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M112,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C112.6,2783.8,112.2,2783.3,112,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M117.9,2762.9c1.4,2.4,1.4,5.4,0,7.8C116.5,2768.3,116.5,2765.3,117.9,2762.9L117.9,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M115.2,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C115.8,2768.9,114.7,2766.1,115.2,2763.3L115.2,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M112.8,2764.7c2.6,1,4.5,3.3,5,6C115.3,2769.7,113.3,2767.4,112.8,2764.7L112.8,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.1,2766.8c2.8,0,5.4,1.5,6.8,3.9C115.1,2770.7,112.5,2769.2,111.1,2766.8L111.1,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M110.2,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C115.3,2771.6,112.3,2771.1,110.2,2769.3L110.2,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M110.2,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C115.7,2772.5,112.8,2773,110.2,2772.1L110.2,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M111.1,2774.6c1.4-2.4,4-3.9,6.8-3.9C116.5,2773.1,113.9,2774.6,111.1,2774.6L111.1,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M112.8,2776.7c0.5-2.7,2.4-5,5-6C117.4,2773.4,115.4,2775.7,112.8,2776.7L112.8,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M115.2,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C118.3,2773.4,117.3,2776.3,115.2,2778.1L115.2,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M117.9,2778.5c-1.4-2.4-1.4-5.4,0-7.8C119.2,2773.1,119.2,2776.1,117.9,2778.5L117.9,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M120.6,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C120,2772.5,121,2775.3,120.6,2778.1L120.6,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M122.9,2776.7c-2.6-1-4.5-3.3-5-6C120.5,2771.7,122.4,2774,122.9,2776.7L122.9,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.7,2774.6c-2.8,0-5.4-1.5-6.8-3.9C120.6,2770.7,123.2,2772.2,124.7,2774.6L124.7,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M125.6,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C120.5,2769.8,123.4,2770.3,125.6,2772.1L125.6,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M125.6,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C120,2768.9,123,2768.4,125.6,2769.3L125.6,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.7,2766.8c-1.4,2.4-4,3.9-6.8,3.9C119.3,2768.3,121.9,2766.8,124.7,2766.8L124.7,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M122.9,2764.7c-0.5,2.7-2.4,5-5,6C118.4,2768,120.3,2765.7,122.9,2764.7L122.9,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M120.6,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C117.4,2768,118.4,2765.1,120.6,2763.3L120.6,2763.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 117.9,
    cy: 2770.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 131.2,
    y1: 2775.6,
    x2: 131.2,
    y2: 2797.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M131.3,2797c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C139.3,2802.6,135.8,2797,131.3,2797z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M131.2,2782.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C132.6,2782.3,132,2782.5,131.2,2782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125.4,2777.8c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1c-0.5-0.4-0.9-0.9-1.3-1.4C125.9,2779.1,125.6,2778.5,125.4,2777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M131.2,2787.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C132.6,2787,132,2787.3,131.2,2787.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M125.4,2782.6c0.8,0.1,1.4,0.3,2,0.6s1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6s-1.1-0.6-1.6-1c-0.5-0.4-0.9-0.9-1.3-1.4C125.9,2783.8,125.6,2783.3,125.4,2782.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.3,2762.9c1.4,2.4,1.4,5.4,0,7.8C129.9,2768.3,129.9,2765.3,131.3,2762.9L131.3,2762.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M128.6,2763.3c2.1,1.8,3.1,4.6,2.7,7.4C129.1,2768.9,128.1,2766.1,128.6,2763.3L128.6,2763.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M126.2,2764.7c2.6,1,4.5,3.3,5,6C128.7,2769.7,126.7,2767.4,126.2,2764.7L126.2,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.5,2766.8c2.8,0,5.4,1.5,6.8,3.9C128.5,2770.7,125.9,2769.2,124.5,2766.8L124.5,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M123.5,2769.3c2.6-0.9,5.6-0.4,7.7,1.4C128.6,2771.6,125.7,2771.1,123.5,2769.3L123.5,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M123.5,2772.1c2.1-1.8,5.1-2.3,7.7-1.4C129.1,2772.5,126.2,2773,123.5,2772.1L123.5,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M124.5,2774.6c1.4-2.4,4-3.9,6.8-3.9C129.9,2773.1,127.2,2774.6,124.5,2774.6L124.5,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M126.2,2776.7c0.5-2.7,2.4-5,5-6C130.8,2773.4,128.8,2775.7,126.2,2776.7L126.2,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M128.6,2778.1c-0.5-2.7,0.6-5.6,2.7-7.4C131.7,2773.4,130.7,2776.3,128.6,2778.1L128.6,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M131.3,2778.5c-1.4-2.4-1.4-5.4,0-7.8C132.6,2773.1,132.6,2776.1,131.3,2778.5L131.3,2778.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M133.9,2778.1c-2.1-1.8-3.1-4.6-2.7-7.4C133.4,2772.5,134.4,2775.3,133.9,2778.1L133.9,2778.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M136.3,2776.7c-2.6-1-4.5-3.3-5-6C133.9,2771.7,135.8,2774,136.3,2776.7L136.3,2776.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138,2774.6c-2.8,0-5.4-1.5-6.8-3.9C134,2770.7,136.6,2772.2,138,2774.6L138,2774.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M139,2772.1c-2.6,0.9-5.6,0.4-7.7-1.4C133.9,2769.8,136.8,2770.3,139,2772.1L139,2772.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M139,2769.3c-2.1,1.8-5.1,2.3-7.7,1.4C133.4,2768.9,136.4,2768.4,139,2769.3L139,2769.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M138,2766.8c-1.4,2.4-4,3.9-6.8,3.9C132.7,2768.3,135.3,2766.8,138,2766.8L138,2766.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M136.3,2764.7c-0.5,2.7-2.4,5-5,6C131.8,2768,133.7,2765.7,136.3,2764.7L136.3,2764.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M133.9,2763.3c0.5,2.7-0.6,5.6-2.7,7.4C130.8,2768,131.8,2765.1,133.9,2763.3L133.9,2763.3z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.020237e-02 1.020237e-02 0.9999 -28.2609 1.4838)",
    className: "st60",
    cx: 131.3,
    cy: 2770.7,
    rx: 3.9,
    ry: 3.9
  }))))))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 388.4,
    cy: 1960.8,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 392.2,
    cy: 1973.6,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 401.7,
    cy: 1949.7,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 410.6,
    cy: 1954.5,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 408.1,
    cy: 1979.2,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 405,
    cy: 1964.9,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 418.1,
    cy: 1966,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 373.4,
    cy: 1966.2,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 375.5,
    cy: 1977,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 417.3,
    cy: 1978.4,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M375.1,1967.4c7.7,5.3,19.1,10.5,20.6,20.7c0.3,11.6,1.4,24.6-4,35.1c-0.1,0.1,0,0.3,0.2,0.3h15.3 c0.2,0,0.3-0.2,0.2-0.3c-3.5-7.2-3.3-14.7-4.4-22.6l0,0c-1.4-6.9-1.8-12.1,4-17.1c2.3-2.3,4.7-4.7,6.9-7.1c2.3-1.7,3.8-2.9,4.9-6 c0.4-1.2,0.5-2.2,0.4-1.8c-1.3,5.6-7.4,8.3-11.6,11.8c1.7-4.1,2.8-9.8,3.1-13.8c-1.4,4.7-1.7,10.8-4.9,14.8c-2,1.3-4.4,2.2-5.6,4.5 c-5.6-7.3-0.8-17-3.4-24.9c-0.9-3,0.5,3.5,0,5c0,4-1.2,8-1.8,11.9c-5.3-2.6-9.3-5.3-10.5-11.3l0,0c-1.2-2-1.4-4.7-2.4-6.5 c1,4.7,2.1,9.3,4.7,13.5c-2.8-1.1-6.3-3.5-8.7-4.6C377.4,1968.8,369.2,1963.2,375.1,1967.4z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 343,
    cy: 1973.6,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 346.6,
    cy: 1985.4,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 355.5,
    cy: 1963.2,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 363.7,
    cy: 1967.7,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 361.4,
    cy: 1990.6,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 358.5,
    cy: 1977.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 370.7,
    cy: 1978.4,
    r: 12.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 329.1,
    cy: 1978.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 331.1,
    cy: 1988.6,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 370,
    cy: 1989.9,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M330.7,1979.7c7.1,5,17.7,9.8,19.1,19.3c0.3,10.8,1.3,22.9-3.7,32.6c-0.1,0.1,0,0.3,0.2,0.3h14.2 c0.1,0,0.2-0.2,0.2-0.3c-3.2-6.7-3-13.7-4.1-21l0,0c-1.3-6.4-1.7-11.2,3.7-15.9c2.2-2.2,4.4-4.3,6.4-6.6c2.2-1.6,3.5-2.7,4.6-5.6 c0.4-1.1,0.4-2,0.3-1.7c-1.2,5.2-6.9,7.7-10.8,10.9c1.6-3.8,2.6-9.1,2.9-12.8c-1.3,4.4-1.5,10.1-4.6,13.7c-1.8,1.2-4.1,2.1-5.2,4.1 c-5.2-6.7-0.8-15.8-3.1-23.1c-0.8-2.8,0.5,3.2,0,4.6c0,3.7-1.1,7.4-1.6,11c-4.9-2.4-8.6-4.9-9.7-10.5l0,0c-1.1-1.9-1.3-4.4-2.3-6.1 c0.9,4.4,2,8.6,4.4,12.6c-2.6-1-5.9-3.3-8.1-4.3C332.9,1981,325.2,1975.8,330.7,1979.7z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M432.8,2077.7c-0.2,0.2-1.2,1-2,4.7c0,0-0.5,2.3-1,3s-1.6,1.8-1.7,2.6s-0.2,1.3-0.2,1.3s-2.7,0.3-3.7,0.2 s-1.6-0.3-1.6-0.3s-0.1-0.3,0.2-0.6s1.4-1.3,1.8-1.6s1.5-1.4,2.3-3.2c0.7-1.8,0.9-4.3,0.8-5.9c-0.1-1.6-1.1-5.7-1.1-5.7l1.1-2.2 L432.8,2077.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M428.2,2071.5c-0.4,0.1-1.2,0.9-1.2,2.1c0,1.2-0.1,1.8-0.7,1.8c-0.5,0-0.7-0.6-0.8-1.8s-1.1-1.1-1.3-1 c-0.2,0.1-0.5,0.3-0.3,1.5s-0.2,1.3-0.5,1.4c-0.2,0-0.7,0-0.8-1.3c-0.1-1.3-0.4-1.7-0.8-1.7s-0.6,0.3-0.6,1s0.4,1.9-0.5,2 s-0.8-1-0.8-1.7s0-1.4-0.9-1.9c-0.9-0.4-2.9-0.8-3.9-1.8l2.6-2.1l5.2-0.6l3.3,0.1L428.2,2071.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M409,2071.3c-0.2,0.7-0.8,3.7-1,8.1s0.3,3.8,0.1,5.7c-0.1,1.9-0.7,5.4-1.2,5.6c-0.5,0.2-3.2,0.2-3.6,0 c0,0-0.2-0.2-0.1-0.5c0.1-0.2,0.9-0.8,1.1-1.3s0.4-1.6,0.4-2.2s0.1-1.8-0.1-2.3s-0.8-1.7-0.9-2.5s-0.5-4.6-0.8-5.6s0.9-5,0.9-5H409 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M383.5,2040.2c0,0-1.2-1.2-1.4-2.5c0,0-1.2,0.8-1,2.9c0,0-1.9,1.4-3.5,3.4s-2.6,2.9-3.6,3.4 c-1,0.4-3.2,1.6-2.9,2.8c0.3,1.2,0.6,2.7,1.7,3.1c1.1,0.4,2.9,0.2,4.6,0.3s2.9,0.3,3.2,0.4c0.3,0.1,3.8,1.1,4.3,1.3s0.8,0.5,1,0.9 s1.7,2.9,2.6,4.7c0.8,1.8,2,4.7,3.4,6.3s2.6,3,4.3,4.3c0,0,0.4,0.5,0.7,2.9c0.3,2.4,1,9.9,0.6,11.2s-0.9,3.5-2.9,5.8 c0,0,2.4,0.7,3.4,0.3s1.8-2,2-2.4c0.2-0.5,2-3.4,2.1-4.5s0.1-3.1,0.1-3.8s0.7-4.3,1.5-6.3s1.6-2.9,3.2-3c1.5-0.1,5.4-0.4,8.9-1.8 c3.5-1.5,8.9-1.5,9.8-1.1s0.8,0.5,0.9,0.8s1.2,3.3,4.8,7.2c0,0,1.3,1.4,1.3,1.7c0.1,0.3,0.3,1.4,0.3,2.8c0,1.4-0.1,4.1-1.2,5.7 c-1.1,1.6-3,4.5-3,4.5s3.7,0.3,4.2,0.2s1.3-1.3,1.9-2.4s1.6-3.1,1.8-3.4c0.1-0.3,0.2-1.5,0.3-2c0-0.5,0.1-3.3,0.3-4 c0.2-0.7,0.4-2.1,0.1-3.3s-0.9-2.8-1-3.7s-0.4-1.9,0.1-2.4s2.3-2.3,2.8-4.4c0.5-2.1,0.6-3.9,0.6-3.9s0,3.1,0.6,4.7 c0.6,1.6,0.8,2.1,0.8,2.1s0.1,3,1.2,4.3s2.3,1.8,3.2,1.5c0,0-1.2-0.5-1.7-1.8s-1.3-3.3-1.9-4c0,0-0.8-1.3-0.9-3.1 c-0.2-1.8-0.3-4.9-0.3-7.1c0-2.3-0.2-8.5-4.3-11.4c-4.1-2.9-11.3-2-13-2s-9.8,0.6-11.9,0.5s-3.4-0.1-4.3-0.4s-4.1-1.9-6.6-2.4 s-5.8,0-7.7-0.2c-1.8-0.2-3.2-0.9-3.8-1.2C388.6,2041.7,385.5,2040.4,383.5,2040.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M434.5,2062.5c-0.3-1-0.7-2.4-1.2-3.5c-0.4-0.9-1.3-1.9-1.4-2.8c-0.2-2.3,0.2-5.4,1-7.5 c0.3-0.9,1.3-2.1,1.3-2.1c0.9,0.3,1.7,0.7,2.4,1.2c4.1,2.9,3.7,8,3.7,10.3c0,1.2-0.4,4.5-0.4,4.5s-0.1,1.1-0.3,2.5 c0,0-2-0.2-3.1-0.7C435.6,2063.9,434.9,2063.8,434.5,2062.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M415.8,2051.6c-0.1,0.5-1.6,2.1-2.3,2.8c-1,1-1.9,2.1-3.3,2.6c-0.6,0.2-2.1-0.2-2.8-0.3 c-1.4-0.2-3.1-0.8-4.4-1.4c-0.6-0.3-1.8-0.8-2.3-1.3c-0.6-0.7-0.5-2.3-0.4-3.8s-0.2-2.7-0.1-4.1c0-1.1,0.1-2.7,0.1-2.7 c0.1,0,0.2,0,0.3,0c2.5,0.4,5.7,2,6.6,2.4c0.9,0.3,2.1,0.3,4.3,0.4c0.7,0,1.9,0,3.3-0.1C415.2,2046.2,416.1,2049.7,415.8,2051.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M399.5,2090.5c-0.4,0.6-0.9,1.3-1.5,1.5c-1,0.4-3.4-0.3-3.4-0.3c0.5-0.5,0.8-1,1.1-1.5L399.5,2090.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M434.3,2090.6c-0.5,0.7-1,1.3-1.3,1.4c-0.5,0.1-4.2-0.2-4.2-0.2s0.5-0.8,1.2-1.8 C430.8,2090.2,432.5,2090.4,434.3,2090.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M404,2089.3c1.1,0.4,2.2,0.4,3.4,0.4c-0.2,0.5-0.3,0.9-0.5,0.9c-0.5,0.2-3.2,0.2-3.6,0c0,0-0.2-0.2-0.1-0.5 C403.3,2090,403.7,2089.7,404,2089.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M378.5,2038.6c0,0,0.3,2.6,1.1,3.9c0,0-1.7,2-2.2,2.9s-1.3,1.4-1.1,2.1c0.2,0.7,0.9,2.7,2.1,3.2 s4.9-0.2,5.6-0.5c0.6-0.3,1.1-0.4,1.4-1.2c0.2-0.7,0.6-1.5,1.2-2.3s1.1-1.3,0.7-2.5s-1.4-2-2.4-2.2s-2-0.6-2-0.6L378.5,2038.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M393.2,2044.7c0.4-0.2,0.8-0.3,1.2-0.1c0.4,0.2,0.7,0.5,1,0.8c0.5,0.4,1.2,0.5,1.8,0.9c0.6,0.4,1,1.1,1.1,1.8 c0.2,0.7,0.2,1.4,0.2,2.2c0,0.3,0,0.6-0.1,0.9s-0.3,0.6-0.6,0.7c-0.3,0.1-0.7,0-1-0.2s-0.5-0.4-0.8-0.6c-0.4-0.3-0.9-0.4-1.5-0.5 c-0.5-0.1-1-0.2-1.5-0.3c-0.5-0.2-0.9-0.5-1.1-1s-0.1-1.1,0.1-1.6c0.1-0.6,0.3-1.2,0.4-1.8C392.7,2045.4,392.8,2045,393.2,2044.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M396.2,2053.8c0.7,0.5,1.4,1.1,2,1.8c0.9,0.9,1.7,1.8,2.6,2.8c0.5,0.5,1,1,1.1,1.7c0.1,0.6,0,1.2-0.2,1.7 c-0.2,0.8-0.4,1.6-0.7,2.5c-0.1,0.5-0.3,1-0.5,1.4s-0.6,0.8-1.1,1c-0.6,0.2-1.2,0.1-1.7-0.1c-1.2-0.3-2.3-0.5-3.5-0.8 c-0.6-0.1-1.1-0.3-1.6-0.6c-0.6-0.4-1-1.1-1.3-1.8c-0.7-1.6-1.3-3.4-1.6-5.1c-0.2-0.9-0.3-1.8-0.1-2.7c0.2-0.9,0.8-1.9,1.7-2.3 c1-0.4,2.2-0.4,3.2-0.2C395.1,2053.3,395.7,2053.5,396.2,2053.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M413.7,2057.9c0.8-0.5,1.7-0.9,2.7-1s2,0.2,2.7,0.9c0.5,0.5,0.9,1.2,1.1,1.9c0.3,0.7,0.5,1.5,0.7,2.2 c0.1,0.4,0.2,0.9,0,1.3c-0.2,0.6-0.8,0.9-1.4,1.2c-1.4,0.6-2.8,1.1-4.2,1.5c-1.1,0.3-2.4,0.4-3.4-0.1c-1.1-0.5-1.8-1.7-1.9-2.9 c0-0.8,0.2-1.7,0.7-2.4c0.2-0.3,1.5-1.3,1.8-1.6C412.8,2058.5,413.2,2058.2,413.7,2057.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M422.9,2049.9c1.1,0.1,2.2,0.7,2.9,1.7c1,1.4,1.1,3.4,2.3,4.6c0.2,0.2,0.5,0.5,0.6,0.8c0,0.4-0.4,0.8-0.8,0.9 c-0.8,0.4-1.8,0.5-2.7,0.4c-0.9-0.1-1.8-0.3-2.7-0.5c-0.6-0.2-1.3-0.4-1.8-0.7c-0.9-0.6-1.6-1.7-1.7-2.8c-0.1-0.9,0.1-1.9,0.6-2.7 c0.4-0.7,1.1-1.2,1.9-1.5C421.9,2049.9,422.4,2049.8,422.9,2049.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M428.1,2088.3c-0.1,0.6-0.1,1-0.1,1s-2.7,0.3-3.7,0.2s-1.6-0.3-1.6-0.3s-0.1-0.3,0.2-0.6 c0.2-0.2,0.6-0.6,1-0.9C424.8,2088,426.3,2088.2,428.1,2088.3z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M341.4,2082.3c0.1,0.1,0.7,0.6,1.2,2.8c0,0,0.3,1.4,0.6,1.8c0.3,0.4,0.9,1.1,1,1.6s0.1,0.8,0.1,0.8 s1.6,0.2,2.2,0.1c0.6-0.1,1-0.2,1-0.2s0.1-0.2-0.1-0.4s-0.9-0.8-1.1-1s-0.9-0.8-1.4-1.9s-0.6-2.6-0.5-3.6s0.6-3.4,0.6-3.4l-0.7-1.3 L341.4,2082.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M355.8,2078.5c0.1,0.4,0.5,2.2,0.6,4.9s-0.2,2.3-0.1,3.4s0.4,3.2,0.7,3.4c0.3,0.1,1.9,0.1,2.2,0 c0,0,0.1-0.1,0.1-0.3s-0.5-0.5-0.7-0.8c-0.1-0.3-0.2-1-0.3-1.3c0-0.4-0.1-1.1,0.1-1.4s0.5-1,0.5-1.5c0.1-0.5,0.3-2.8,0.5-3.3 s-0.6-3-0.6-3L355.8,2078.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M371.2,2059.8c0,0,0.7-0.7,0.8-1.5c0,0,0.7,0.5,0.6,1.8c0,0,1.1,0.9,2.1,2.1c0.9,1.2,1.5,1.8,2.2,2 c0.6,0.3,1.9,1,1.7,1.7c-0.2,0.7-0.4,1.6-1,1.9c-0.6,0.2-1.7,0.1-2.8,0.2c-1,0-1.8,0.2-2,0.2c-0.2,0.1-2.3,0.7-2.6,0.8 s-0.5,0.3-0.6,0.5s-1,1.8-1.5,2.8c-0.5,1.1-1.2,2.8-2.1,3.8c-0.8,1-1.6,1.8-2.6,2.6c0,0-0.2,0.3-0.4,1.7c-0.2,1.4-0.6,6-0.4,6.8 s0.5,2.1,1.8,3.5c0,0-1.4,0.4-2,0.2s-1.1-1.2-1.2-1.5s-1.2-2.1-1.3-2.7c-0.1-0.6-0.1-1.9-0.1-2.3c0-0.4-0.4-2.6-0.9-3.8 s-1-1.7-1.9-1.8s-3.2-0.2-5.4-1.1s-5.4-0.9-5.9-0.7c-0.6,0.3-0.5,0.3-0.6,0.5s-0.8,2-2.9,4.3c0,0-0.8,0.8-0.8,1s-0.2,0.9-0.2,1.7 s0.1,2.5,0.8,3.5c0.7,1,1.8,2.7,1.8,2.7s-2.2,0.2-2.5,0.1c-0.3-0.1-0.8-0.8-1.2-1.5c-0.4-0.7-1-1.9-1.1-2.1 c-0.1-0.2-0.2-0.9-0.2-1.2s-0.1-2-0.2-2.4s-0.2-1.3-0.1-2c0.2-0.7,0.5-1.7,0.6-2.2c0.1-0.6,0.3-1.1-0.1-1.5 c-0.3-0.3-1.4-1.4-1.7-2.7c-0.3-1.3-0.3-2.3-0.3-2.3s0,1.9-0.4,2.8c-0.4,1-0.5,1.3-0.5,1.3s-0.1,1.8-0.8,2.6 c-0.7,0.8-1.4,1.1-1.9,0.9c0,0,0.7-0.3,1.1-1.1s0.8-2,1.1-2.4c0,0,0.5-0.8,0.6-1.9c0.1-1.1,0.2-2.9,0.2-4.3c0-1.4,0.1-5.1,2.6-6.9 s6.8-1.2,7.8-1.2s5.9,0.3,7.2,0.3c1.3-0.1,2,0,2.6-0.3c0.5-0.2,2.5-1.2,4-1.4c1.5-0.3,3.5,0,4.6-0.1s1.9-0.5,2.3-0.7 C368,2060.7,370,2059.9,371.2,2059.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M340.4,2073.2c0.2-0.6,0.4-1.5,0.7-2.1c0.2-0.5,0.8-1.1,0.8-1.7c0.1-1.4-0.1-3.3-0.6-4.5 c-0.2-0.5-0.8-1.3-0.8-1.3c-0.5,0.2-1,0.4-1.4,0.7c-2.5,1.7-2.2,4.8-2.2,6.2c0,0.7,0.2,2.7,0.2,2.7s0,0.6,0.2,1.5 c0,0,1.2-0.1,1.8-0.4C339.7,2074,340.1,2074,340.4,2073.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M351.6,2066.6c0,0.3,1,1.2,1.4,1.7c0.6,0.6,1.1,1.3,2,1.6c0.4,0.1,1.3-0.1,1.7-0.2c0.8-0.1,1.9-0.5,2.6-0.8 c0.4-0.2,1.1-0.5,1.4-0.8c0.4-0.4,0.3-1.4,0.2-2.3c-0.1-0.9,0.1-1.6,0.1-2.5c0-0.6,0-1.6-0.1-1.6s-0.1,0-0.2,0 c-1.5,0.3-3.4,1.2-4,1.4c-0.5,0.2-1.3,0.2-2.6,0.3c-0.4,0-1.1,0-2,0C352,2063.3,351.5,2065.5,351.6,2066.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M361.5,2090c0.2,0.4,0.5,0.8,0.9,0.9c0.6,0.2,2-0.2,2-0.2c-0.3-0.3-0.5-0.6-0.7-0.9L361.5,2090z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M340.5,2090.1c0.3,0.4,0.6,0.8,0.8,0.8c0.3,0.1,2.5-0.1,2.5-0.1s-0.3-0.5-0.7-1.1 C342.6,2089.9,341.6,2090,340.5,2090.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M358.8,2089.3c-0.7,0.2-1.3,0.2-2,0.2c0.1,0.3,0.2,0.5,0.3,0.6c0.3,0.1,1.9,0.1,2.2,0c0,0,0.1-0.1,0.1-0.3 C359.2,2089.8,359,2089.6,358.8,2089.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M374.1,2058.8c0,0-0.2,1.6-0.7,2.3c0,0,1,1.2,1.3,1.7s0.8,0.8,0.7,1.3c-0.1,0.5-0.6,1.6-1.3,1.9 s-3-0.2-3.3-0.3c-0.4-0.2-0.7-0.3-0.8-0.7c-0.2-0.5-0.4-0.9-0.8-1.4s-0.6-0.8-0.4-1.5s0.8-1.2,1.5-1.3c0.6-0.1,1.2-0.4,1.2-0.4 L374.1,2058.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M363.5,2068c-0.5,0.3-0.8,0.7-1.2,1.1c-0.5,0.6-1,1.1-1.6,1.7c-0.3,0.3-0.6,0.6-0.7,1c-0.1,0.3,0,0.7,0.1,1 c0.1,0.5,0.3,1,0.4,1.5c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.3,0.4,0.5,0.6,0.6c0.3,0.1,0.7,0,1.1,0c0.7-0.2,1.4-0.3,2.1-0.5 c0.3-0.1,0.7-0.2,1-0.3c0.4-0.3,0.6-0.7,0.8-1.1c0.4-1,0.8-2,1-3.1c0.1-0.5,0.2-1.1,0.1-1.7c-0.1-0.5-0.5-1.2-1-1.4 c-0.6-0.2-1.3-0.2-1.9-0.1C364.1,2067.6,363.8,2067.8,363.5,2068z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M348.9,2069.4c-0.5-0.3-1-0.5-1.6-0.6s-1.2,0.1-1.6,0.5c-0.3,0.3-0.5,0.7-0.7,1.1c-0.2,0.4-0.3,0.9-0.4,1.3 c-0.1,0.3-0.1,0.6,0,0.8c0.1,0.3,0.5,0.5,0.8,0.7c0.8,0.4,1.7,0.7,2.6,0.9c0.7,0.2,1.4,0.2,2.1-0.1s1.1-1,1.1-1.8 c0-0.5-0.1-1-0.4-1.4c-0.1-0.2-0.9-0.8-1.1-1C349.4,2069.8,349.2,2069.6,348.9,2069.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M344.3,2088.7c0.1,0.4,0.1,0.6,0.1,0.6s1.6,0.2,2.2,0.1c0.6-0.1,1-0.2,1-0.2s0.1-0.2-0.1-0.4 c-0.1-0.1-0.4-0.4-0.6-0.6C346.3,2088.5,345.3,2088.7,344.3,2088.7z"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 399.5,
    className: "st19",
    width: 13.1,
    height: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 346.6,
    y: 399.5,
    className: "st19",
    width: 13.1,
    height: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 370.4,
    y: 399.5,
    className: "st19",
    width: 13.1,
    height: 2
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M284,396.9c0-3.4,0-6.9,0-10.3c0.1-0.5,0.1-0.9,0.2-1.4c0.3-1.1,0.5-2.2,0.8-3.3c0.2-0.6,0.5-1.1,0.7-1.7 c0.6-1.5,1.2-3,1.8-4.4c0.5-1.2,0.8-1.3,2-1.3c1.1,0,2.2,0,3.3,0c1.2,0,2.4,0,3.6,0c0.1,0,0.2-0.2,0.2-0.3c0-0.2-0.1-0.5-0.2-0.7 c-0.5-1-1.2-1.8-2.3-2.3c-1.3-0.6-2.7-0.3-4-0.5c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1,0-0.4,0.2-0.5c0.2-0.1,0.4-0.2,0.6-0.2 c4.4,0,8.8,0,13.2,0c0.3,0,0.6,0.1,0.9,0.2c0.3,0,0.4,0.1,0.4,0.4c0,0.3-0.2,0.4-0.5,0.4c-0.9,0-1.8,0-2.7,0.1 c-2,0.2-3.3,1.5-3.9,3.3c0,0.1,0.1,0.3,0.1,0.3c0.3,0,0.6,0,0.9,0c2.1,0,4.1,0,6.2,0c0.6,0,1.2,0.1,1.6,0.8 c0.2,0.3,0.5,0.7,0.7,1.1c0.6,1.3,1.1,2.6,1.7,3.9c0.3,0.6,0.6,1.1,0.9,1.7c0.1,0.2,0,0.5,0.1,0.7c0.1,0.2,0.4,0.3,0.6,0.4 c0.3,0.3,0.5,0.7,0.8,1c0.2,0.2,0.2,0.6,0.4,0.7c0.5,0.4,0.8,0.9,1.3,1.3c1.3,1.3,2.7,2.5,4.2,3.6c0.4,0.3,0.8,0.6,1.2,0.9 c0.3,0.2,0.7,0.3,1.1,0.5c0.3,0.2,0.6,0.3,0.9,0.5c1.3,0.5,2.5,1.1,3.8,1.5c1.8,0.6,3.6,1,5.4,1.1c0.4,0,0.6,0.2,0.6,0.6 c0,1.8,0,3.5,0,5.3c0,0.7-0.2,1.2-1,1.5c0,0-0.1,0-0.1,0c-0.1,0-0.3-0.1-0.4-0.1c-12.9,0-25.8,0-38.7,0c-0.1,0-0.3,0.1-0.4,0.1 c-0.3,0-0.5,0-0.8,0c-0.3-0.1-0.6-0.1-0.8-0.2c-2.1-0.4-3.5-1.7-4-3.8C284.1,397.4,284.1,397.2,284,396.9z M306.2,383.1 c0-0.4,0.1-0.9-0.1-1.3c-0.6-1.6-1.3-3.2-2-4.8c-0.2-0.6-0.6-0.8-1.2-0.8c-4.4,0-8.8,0-13.3,0c-0.4,0-0.8,0.1-1,0.5 c-0.3,0.5-0.6,1.1-0.8,1.6c-0.2,0.6-0.4,1.1-0.6,1.7c-0.3,0.7-0.6,1.5-0.9,2.2c0,0.1-0.1,0.2-0.1,0.3c0.2,0.6,0.7,0.9,1.4,0.9 c5.1,0,10.2,0,15.3,0C304.1,383.4,305.1,383.7,306.2,383.1z M312.6,394.1c0-0.1,0-0.1,0-0.2c0-2,0-3.9,0-5.9 c0-0.1-0.1-0.2-0.2-0.3c-0.5-0.5-1-1-1.5-1.5c-0.4-0.5-0.8-0.9-1.3-1.5c0,0.7,0,1.4,0,2c0,1.7,0,3.3,0,5c0,0.9,0,0.9,0.8,1.3 c0.4,0.2,0.9,0.5,1.3,0.7C312.1,393.9,312.3,394,312.6,394.1z M314.2,389.2c0,1.5,0,2.9,0,4.4c0,0.4-0.1,1,0.1,1.3 c0.2,0.3,0.7,0.4,1.1,0.5c0.6,0.2,1.1,0.4,1.8,0.7c0-1.3-0.1-2.5,0-3.7c0.1-0.8-0.2-1.3-0.9-1.7 C315.5,390.2,314.9,389.7,314.2,389.2z M303.5,394.4c1.1,0,1.9-0.8,1.9-1.9c0-1.1-0.9-1.9-1.9-1.8c-1.2,0.1-1.8,0.6-1.8,2 C301.5,393.7,302.4,394.4,303.5,394.4z M289.4,394.4c0.2,0,0.8,0,1-0.2c0.3-0.5,0.8-1,0.7-1.7c-0.1-1.1-0.8-1.8-1.9-1.8 c-1.1,0-2,1-1.9,2.1C287.2,393.6,288.1,394.4,289.4,394.4z M318.5,391.9c0,1.5,0,2.9,0,4.3c0,0.1,0.1,0.2,0.2,0.2 c0.8,0.2,1.6,0.5,2.4,0.7c0-0.1,0-0.2,0-0.2c0-1.2,0-2.4,0-3.6c0-0.1-0.1-0.3-0.2-0.4c-0.4-0.2-0.7-0.4-1.1-0.5 C319.3,392.3,318.9,392.1,318.5,391.9z M322.3,393.6c0,1.3,0,2.5,0,3.7c0,0.1,0.1,0.2,0.1,0.2c0.7,0.1,1.4,0.3,2.1,0.4 c0-1.2,0-2.3,0-3.4c0-0.1-0.1-0.2-0.1-0.3C323.7,394.1,323,393.8,322.3,393.6z M325.5,398.1c0.6,0.1,1.2,0.2,1.9,0.3 c0-1.1,0-2.2,0-3.2c0-0.1-0.1-0.2-0.2-0.2c-0.5-0.1-1.1-0.2-1.7-0.4C325.5,395.7,325.5,396.9,325.5,398.1z M328.2,395.1 c0,1.1,0,2.2,0,3.3c0.5,0,1,0.1,1.5,0.1c0-1.1,0-2.2,0-3.2C329.2,395.3,328.7,395.2,328.2,395.1z M297.4,372.7 c0.3-0.4,0.7-0.9,1-1.3c0.2-0.2,0.5-0.4,0.8-0.7c-1.3,0-2.4,0-3.5,0C296.3,371.4,296.9,372.1,297.4,372.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteIngenieur);
export default __webpack_public_path__ + "static/media/carte-ingenieur.ce54114465bb33d7be761940c39e4013.svg";
export { ForwardRef as ReactComponent };